
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gxP2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $93afe32c7f6fd7f3$export$2e2bcd8739ae039);

var $lEJki = parcelRequire("lEJki");

var $fJxAt = parcelRequire("fJxAt");



var $6fSfj = parcelRequire("6fSfj");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $93afe32c7f6fd7f3$var$FeatureGates {
    static{
        this.client = new (0, $lEJki.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$93afe32c7f6fd7f3$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $93afe32c7f6fd7f3$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$93afe32c7f6fd7f3$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $93afe32c7f6fd7f3$var$boundFGJS = $93afe32c7f6fd7f3$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $93afe32c7f6fd7f3$var$FeatureGates;
    else {
        $93afe32c7f6fd7f3$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $93afe32c7f6fd7f3$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $fJxAt.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $fJxAt.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $93afe32c7f6fd7f3$export$2e2bcd8739ae039 = $93afe32c7f6fd7f3$var$boundFGJS;

});
parcelRegister("lEJki", function(module, exports) {
$parcel$export(module.exports, "Client", () => $9eb64a79b39eb78f$export$1f2bb630327ac4b6);

var $4SQvv = parcelRequire("4SQvv");

var $cAZIH = parcelRequire("cAZIH");

var $iEUd5 = parcelRequire("iEUd5");

var $8TzEk = parcelRequire("8TzEk");

var $km2o0 = parcelRequire("km2o0");

var $geRnF = parcelRequire("geRnF");

var $1qKIL = parcelRequire("1qKIL");

var $cqhuj = parcelRequire("cqhuj");

var $6fSfj = parcelRequire("6fSfj");

var $gTOGG = parcelRequire("gTOGG");

var $fJxAt = parcelRequire("fJxAt");
const $9eb64a79b39eb78f$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $9eb64a79b39eb78f$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $9eb64a79b39eb78f$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $cqhuj.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
	 * True if an initialize method was called and completed, meaning the client is now usable.
	 * However if there was an error during initialization it may have initialized with default
	 * values. Use {@link initCompleted} to check for this.
	 */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $cAZIH.default)();
        this.dataAdapter = new (0, $1qKIL.NoFetchDataAdapter)();
        /**
	 * Call this if modifying the values being served by the Statsig library since it has its own
	 * memoization cache which will not be updated if the values are changed outside of the library.
	 */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $cqhuj.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
	 * @description
	 * This method initializes the client using a network call to fetch the bootstrap values.
	 * If the client is inialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $gTOGG.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gTOGG.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
	 * @description
	 * This method initializes the client using the provider given to call to fetch the bootstrap values.
	 * If the client is initialized with an `analyticsWebClient`, it will send an operational event
	 * to GASv3 with the following attributes:
	 * - targetApp: the target app of the client
	 * - clientVersion: the version of the client
	 * - success: whether the initialization was successful
	 * - startTime: the time when the initialization started
	 * - totalTime: the total time it took to initialize the client
	 * - apiKey: the api key used to initialize the client
	 * @param clientOptions {ClientOptions}
	 * @param provider {Provider}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @returns {Promise<void>}
	 */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $gTOGG.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gTOGG.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $fJxAt.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $fJxAt.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $6fSfj.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $gTOGG.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $gTOGG.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
	 * This method updates the user using a network call to fetch the new set of values.
	 * @param fetchOptions {FetcherOptions}
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $gTOGG.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $geRnF.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
	 * This method updates the user using the provider given on initialisation to get the new set of
	 * values.
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
	 * This method updates the user given a new set of bootstrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param identifiers {Identifiers}
	 * @param customAttributes {CustomAttributes}
	 * @param initializeValues {Record<string,unknown>}
	 */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
	 * Returns the value for a feature gate. Returns false if there are errors.
	 * @param {string} gateName - The name of the feature gate.
	 * @param {Object} options
	 * @param {boolean} options.fireGateExposure
	 *        Whether or not to fire the exposure event for the gate. Defaults to true.
	 *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
	 *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
	 * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
	 * <code>options.fireGateExposure</code> is false.
	 * @param gateName
	 */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
	 * Returns the entire config for a given experiment.
	 *
	 * @param {string} experimentName - The name of the experiment
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns The config for an experiment
	 * @example
	 * ```ts
	 * const experimentConfig = client.getExperiment('example-experiment-name');
	 * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
	 * ```
	 */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $iEUd5.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $iEUd5.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $km2o0.EvaluationReason).Error
            });
        }
    }
    /**
	 * Returns the value of a given parameter in an experiment config.
	 *
	 * @template T
	 * @param {string} experimentName - The name of the experiment
	 * @param {string} parameterName - The name of the parameter to fetch from the experiment config
	 * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
	 * if the returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
	 * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the
	 * expected type. If this function returns false, then the default value will be returned
	 * instead. This can be set to protect your code from unexpected values being set remotely. By
	 * default, this will be done by asserting that the default value and value are the same primitive
	 * type.
	 * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
	 * default value.
	 * @example
	 ``` ts
	 type ValidColor = 'blue' | 'red' | 'yellow';
	 type ValidColorTypeCheck = (value: unknown) => value is ValidColor;

	 const isValidColor: ValidColorTypeCheck =
			(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);

	 const buttonColor: ValidColor = client.getExperimentValue(
			'example-experiment-name',
			'backgroundColor',
			'yellow',
			{
					typeGuard: isValidColor
			}
	 );
	 ```
	*/ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
	 * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
	 * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
	 * @param experimentName
	 */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
	 * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
	 * @param layerName
	 * @param parameterName
	 */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
	 * Adds a new override for the given gate.
	 *
	 * This method is additive, meaning you can call it multiple times with different gate names to
	 * build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearGateOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} gateName
	 * @param {boolean} value
	 */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given gate.
	 */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
	 * Adds a new override for the given config (or experiment).
	 *
	 * This method is additive, meaning you can call it multiple times with different experiment
	 * names to build your full set of overrides.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearConfigOverride} after your tests are completed to remove this
	 * localStorage entry.
	 *
	 * @param {string} experimentName
	 * @param {object} values
	 */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
	 * Removes any overrides that have been set for the given experiment.
	 * @param {string} experimentName
	 */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
	 * Set overrides for gates, experiments and layers in batch.
	 *
	 * Note that these overrides are **not** additive and will completely replace any that have been
	 * added via prior calls to {@link Client.overrideConfig} or
	 * {@link Client.overrideGate}.
	 *
	 * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
	 * will continue to affect every client that is initialized on the same domain after this method
	 * is called. If you are using this API for testing purposes, you should call
	 * {@link Client.clearAllOverrides} after your tests are completed to remove this
	 * localStorage entry.
	 */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
	 * @returns The current overrides for gates, configs (including experiments) and layers.
	 */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
	 * Clears overrides for all gates, configs (including experiments) and layers.
	 */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
	 * Returns whether the given identifiers and customAttributes align with the current
	 * set that is being used by the client.
	 *
	 * If this method returns false, then the {@link Client.updateUser},
	 * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
	 * methods can be used to re-align these values.
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @returns a flag indicating whether the clients current configuration aligns with the given values
	 */ isCurrentUser(identifiers, customAttributes) {
        return (0, $gTOGG.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $gTOGG.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current checkGate value
	 * @param gateName
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
	 * Subscribe to updates where the given callback will be called with the current experiment value
	 * @param experimentName
	 * @param parameterName
	 * @param defaultValue
	 * @param callback
	 * @param options
	 * @returns off function to unsubscribe from updates
	 */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
	 * Subscribe so on any update the callback will be called.
	 * NOTE: The callback will be called whenever the values are updated even if the values have not
	 * changed.
	 * @param callback
	 * @returns off function to unsubscribe from updates
	 */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
	 * This method initializes the client using a network call to fetch the bootstrap values for the
	 * given user.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @private
	 */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $geRnF.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $geRnF.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
	 * This method initializes the client using a set of boostrap values obtained from one of the
	 * server-side SDKs.
	 *
	 * @param clientOptions
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValues
	 * @private
	 */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $gTOGG.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $9eb64a79b39eb78f$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $9eb64a79b39eb78f$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $6fSfj.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.user = (0, $gTOGG.toStatsigUser)(identifiers, customAttributes);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $4SQvv.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $4SQvv.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $4SQvv.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $4SQvv.StatsigClient)($9eb64a79b39eb78f$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
	 * This method updates the user for this client with the bootstrap values returned from a given
	 * Promise.
	 * It uses the customAttributes from fetching experiment values to update the Statsig user but
	 * uses the customAttributes from given input to check if the user has changed.
	 *
	 * @param {Identifiers} identifiers
	 * @param {CustomAttributes} customAttributes
	 * @param {Promise<InitializeValues>} getInitializeValues
	 * @private
	 */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
	 * This method updates the user on the nested Statsig client
	 *
	 * @param identifiers
	 * @param customAttributes
	 * @param initializeValuesPromise
	 * @private
	 */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $gTOGG.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
	 * @returns string version of the current package in semver style.
	 */ getPackageVersion() {
        return 0, $fJxAt.CLIENT_VERSION;
    }
    /**
	 * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
	 *
	 * @param {string} layerName - The name of the layer
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
	 * @returns A layer
	 * @example
	 * ```ts
	 * const layer = client.getLayer('example-layer-name');
	 * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
	 * ```
	 */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $8TzEk.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $8TzEk.Layer).fromLayer((0, $4SQvv._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
	 * Returns the value of a given parameter in a layer config.
	 *
	 * @template T
	 * @param {string} layerName - The name of the layer
	 * @param {string} parameterName - The name of the parameter to fetch from the layer config
	 * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
	 * returned value does not match the expected type.
	 * @param {Object} options
	 * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
	 * layer. Defaults to true. To log an exposure event manually at a later time, use
	 * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
	 * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
	 * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
	 * @example
	 * ``` ts
	 * type ValidColor = 'blue' | 'red' | 'yellow';
	 * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
	 *
	 * const isValidColor: ValidColorTypeCheck =
	 *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
	 *
	 * const buttonColor: ValidColor = client.getLayerValue(
	 *    'example-layer-name',
	 *    'backgroundColor',
	 *    'yellow',
	 *    {
	 *        typeGuard: isValidColor
	 *    }
	 * );
	 * ```
	 */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("cAZIH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2c84c4e4270ac91$export$2e2bcd8739ae039);

var $cm6iB = parcelRequire("cm6iB");
const $a2c84c4e4270ac91$export$a66cbd9b2289cd78 = '@all-features';
class $a2c84c4e4270ac91$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($cm6iB)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($a2c84c4e4270ac91$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($a2c84c4e4270ac91$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($a2c84c4e4270ac91$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $a2c84c4e4270ac91$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("iEUd5", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $af8b118c91b569be$export$6dc24881a3d96325);

var $gTOGG = parcelRequire("gTOGG");
class $af8b118c91b569be$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $af8b118c91b569be$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $gTOGG.migrateEvaluationDetails)(experiment.details), (0, $gTOGG.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("gTOGG", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $d005b910f24a14c8$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $d005b910f24a14c8$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $d005b910f24a14c8$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $d005b910f24a14c8$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $d005b910f24a14c8$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $d005b910f24a14c8$export$55fd683752d01e67);

var $aSDDo = parcelRequire("aSDDo");

var $km2o0 = parcelRequire("km2o0");

var $6fSfj = parcelRequire("6fSfj");
const $d005b910f24a14c8$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $aSDDo.isFedRamp)() ? (0, $6fSfj.PerimeterType).FEDRAMP_MODERATE : (0, $6fSfj.PerimeterType).COMMERCIAL,
        ...options
    });
const $d005b910f24a14c8$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $d005b910f24a14c8$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $d005b910f24a14c8$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $d005b910f24a14c8$var$evaluationReasonMappings = Object.entries((0, $km2o0.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $d005b910f24a14c8$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $d005b910f24a14c8$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $km2o0.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $d005b910f24a14c8$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("aSDDo", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $7809fa247ed2fb82$export$64d6499adf9b2e51);

function $7809fa247ed2fb82$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $758f26253b3d4f8b$export$ce553301d55c2fd8);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
const $758f26253b3d4f8b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $758f26253b3d4f8b$export$f005e2e9f707cb5f = 'commercial';
const $758f26253b3d4f8b$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $758f26253b3d4f8b$export$a739cd5aac835909 = 'stg';
const $758f26253b3d4f8b$export$42dd0cdd351a4a9 = 'prod';
const $758f26253b3d4f8b$export$404582bc18fe4d9e = 'dev';


parcelRegister("km2o0", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $26f0c81db4dff7a0$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $26f0c81db4dff7a0$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("6fSfj", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $4eaee7caa191a1bd$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $4eaee7caa191a1bd$export$c42b7bbc5e7ba555);
var $4eaee7caa191a1bd$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $4eaee7caa191a1bd$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $4eaee7caa191a1bd$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("8TzEk", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $1d3af5ddbc94bff8$export$936d0764594b6eb3);

var $gTOGG = parcelRequire("gTOGG");
class $1d3af5ddbc94bff8$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $1d3af5ddbc94bff8$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $gTOGG.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $gTOGG.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $gTOGG.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("geRnF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac57a69bdef6068a$export$2e2bcd8739ae039);

var $6fSfj = parcelRequire("6fSfj");

var $fJxAt = parcelRequire("fJxAt");

var $azSoy = parcelRequire("azSoy");
const $ac57a69bdef6068a$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $ac57a69bdef6068a$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $ac57a69bdef6068a$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $ac57a69bdef6068a$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $ac57a69bdef6068a$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $ac57a69bdef6068a$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $ac57a69bdef6068a$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $ac57a69bdef6068a$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $ac57a69bdef6068a$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $ac57a69bdef6068a$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $ac57a69bdef6068a$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $azSoy.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $azSoy.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $ac57a69bdef6068a$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $6fSfj.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $6fSfj.FeatureGateEnvironment).Production:
                return $ac57a69bdef6068a$export$18c93900db9358a4;
            case (0, $6fSfj.FeatureGateEnvironment).Staging:
                return $ac57a69bdef6068a$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $6fSfj.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $6fSfj.FeatureGateEnvironment).Development:
                return $ac57a69bdef6068a$export$f058dbf75c3bc647;
            case (0, $6fSfj.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $ac57a69bdef6068a$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $ac57a69bdef6068a$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $ac57a69bdef6068a$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $ac57a69bdef6068a$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $fJxAt.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $ac57a69bdef6068a$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$ac57a69bdef6068a$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$ac57a69bdef6068a$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("fJxAt", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $3e1c74d1259bda95$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $3e1c74d1259bda95$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("azSoy", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $a78f904c488501f1$export$286baf652d0b1206);
class $a78f904c488501f1$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("1qKIL", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $49e84892a6e04c0f$export$55fffef3474104af);

var $4SQvv = parcelRequire("4SQvv");
class $49e84892a6e04c0f$export$55fffef3474104af extends (0, $4SQvv.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
	 * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
	 * after the Statsig client has been created!
	 */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $4SQvv.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $4SQvv._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $4SQvv._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $4SQvv._getStorageKey)(this._getSdkKey(), user);
        return `${0, $4SQvv.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("cqhuj", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $503218d23cc1062a$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $503218d23cc1062a$export$bcb28fbac1def494);

var $bRnho = parcelRequire("bRnho");
const $503218d23cc1062a$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $503218d23cc1062a$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $503218d23cc1062a$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $503218d23cc1062a$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $503218d23cc1062a$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $503218d23cc1062a$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $503218d23cc1062a$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $503218d23cc1062a$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $503218d23cc1062a$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $503218d23cc1062a$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($503218d23cc1062a$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($503218d23cc1062a$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $bRnho._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$503218d23cc1062a$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($503218d23cc1062a$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $503218d23cc1062a$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($503218d23cc1062a$var$djb2MapKey((0, $bRnho._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $503218d23cc1062a$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($503218d23cc1062a$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $bRnho._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $503218d23cc1062a$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($503218d23cc1062a$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $bRnho._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $503218d23cc1062a$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("5IRBH", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $082d1751215b1112$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $082d1751215b1112$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $082d1751215b1112$export$47fade9662f71000);

var $fELzb = parcelRequire("fELzb");
const $082d1751215b1112$export$5b78c989c8db2561 = new Map();
const $082d1751215b1112$export$2a5c8df26bb89760 = new Map();
function $082d1751215b1112$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $fELzb.redactValue)(featureFlagValue);
    $082d1751215b1112$export$5b78c989c8db2561.set(featureFlagName, value);
    $082d1751215b1112$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("fELzb", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $90c7c8b259e7ac27$export$fcc03ee4c944962f);

function $90c7c8b259e7ac27$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $90c7c8b259e7ac27$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $90c7c8b259e7ac27$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $90c7c8b259e7ac27$export$7b4abba432e57989(value) {
    return $90c7c8b259e7ac27$var$isString(value) && $90c7c8b259e7ac27$var$startsAsObject(value) || $90c7c8b259e7ac27$var$isObject(value);
}
function $90c7c8b259e7ac27$export$fcc03ee4c944962f(featureFlagValue) {
    return $90c7c8b259e7ac27$export$7b4abba432e57989(featureFlagValue) ? (0, $84d12136aa8dcfaf$export$42f4885608027d0c) : featureFlagValue;
}

});
const $84d12136aa8dcfaf$export$42f4885608027d0c = 'non_boolean';



parcelRegister("9Ei2J", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $7065d87149e88979$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $7065d87149e88979$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $7065d87149e88979$export$6f077d94b33a01aa);
var $7065d87149e88979$var$isBrowser = true;
function $7065d87149e88979$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $7065d87149e88979$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $7065d87149e88979$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $7065d87149e88979$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $7065d87149e88979$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("8MFTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5e94b59ff7910a5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f5e94b59ff7910a5$var$_default_1 = (0, $eJOHy.createContext)(null);
var $f5e94b59ff7910a5$export$2e2bcd8739ae039 = $f5e94b59ff7910a5$var$_default_1;

});

parcelRegister("91hOG", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $d1488f5cd668edfb$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $d1488f5cd668edfb$export$b40ec24ac8275656);

var $lkGqe = parcelRequire("lkGqe");
function $d1488f5cd668edfb$export$ba05d765b8392e5e(flagResolver) {
    (0, $lkGqe.setBooleanResolver)(flagResolver);
}
function $d1488f5cd668edfb$export$470e5c2be1411c89(name) {
    return (0, $lkGqe.resolveBooleanFlag)(name);
}
function $d1488f5cd668edfb$export$b40ec24ac8275656(name) {
    return (0, $lkGqe.resolveBooleanFlag)(name);
}

});
parcelRegister("lkGqe", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $307ee0087f7454ab$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $307ee0087f7454ab$export$6333b6aff9fc6275);

var $gxP2H = parcelRequire("gxP2H");

var $kRWMP = parcelRequire("kRWMP");

var $igDjg = parcelRequire("igDjg");
const $307ee0087f7454ab$var$pkgName = '@atlaskit/platform-feature-flags';
const $307ee0087f7454ab$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $307ee0087f7454ab$var$hasProcessEnv = typeof $igDjg !== 'undefined' && typeof $igDjg.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $307ee0087f7454ab$var$ENV_ENABLE_PLATFORM_FF = $307ee0087f7454ab$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $307ee0087f7454ab$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $307ee0087f7454ab$var$hasProcessEnv ? false : false;
const $307ee0087f7454ab$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $307ee0087f7454ab$var$ENV_ENABLE_PLATFORM_FF || $307ee0087f7454ab$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $307ee0087f7454ab$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $307ee0087f7454ab$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98] = $307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98] || $307ee0087f7454ab$var$DEFAULT_PFF_GLOBAL;
function $307ee0087f7454ab$export$f2b591175b3e424c(resolver) {
    $307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $307ee0087f7454ab$export$6333b6aff9fc6275(flagKey) {
    if ($307ee0087f7454ab$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kRWMP.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $307ee0087f7454ab$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $gxP2H.default).checkGate(flagKey);
        const result = $307ee0087f7454ab$var$globalVar[$307ee0087f7454ab$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kRWMP", function(module, exports) {
$parcel$export(module.exports, "debug", () => $a7e352261af22296$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $a7e352261af22296$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $a7e352261af22296$var$DEBUG_MODE = !$a7e352261af22296$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $a7e352261af22296$export$1c9f709888824e05 = (...args)=>{
    if (!$a7e352261af22296$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("5hQot", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $370eed2fbc59b7d5$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $370eed2fbc59b7d5$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $370eed2fbc59b7d5$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $370eed2fbc59b7d5$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $370eed2fbc59b7d5$export$6e17cce6446848f9);

var $8OGTc = parcelRequire("8OGTc");
const $370eed2fbc59b7d5$var$state = {
    context: null
};
function $370eed2fbc59b7d5$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $370eed2fbc59b7d5$export$f2e521e495a88544(interactionId, experienceType) {
    $370eed2fbc59b7d5$export$a1002be327997103(interactionId.replace(/-/g, ''), $370eed2fbc59b7d5$export$295213bc4d0c54ad(), experienceType);
}
function $370eed2fbc59b7d5$export$a1002be327997103(traceId, spanId, type) {
    $370eed2fbc59b7d5$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $370eed2fbc59b7d5$export$b6ac780db3a3cc77() {
    return $370eed2fbc59b7d5$var$state.context || undefined;
}
function $370eed2fbc59b7d5$export$17ab21d7be720b() {
    $370eed2fbc59b7d5$var$state.context = null;
}
function $370eed2fbc59b7d5$export$6e17cce6446848f9(_url) {
    if ($370eed2fbc59b7d5$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $370eed2fbc59b7d5$var$state.context;
    return (0, $8OGTc.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $370eed2fbc59b7d5$export$a1e7396778592551(_url) {
    const traceHeaders = $370eed2fbc59b7d5$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("8OGTc", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $fbdb66597468607f$export$1115c5277eb10d5e);
function $fbdb66597468607f$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("gfkEK", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $7afe4f70edd8473f$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $7afe4f70edd8473f$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $7afe4f70edd8473f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $7afe4f70edd8473f$export$37bca3107733ac1e);

var $eJOHy = parcelRequire("eJOHy");
const $7afe4f70edd8473f$var$listeners = new Set();
// Observable interaction ID implementation
class $7afe4f70edd8473f$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $7afe4f70edd8473f$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $7afe4f70edd8473f$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $7afe4f70edd8473f$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $7afe4f70edd8473f$export$3109542b68df9ba1 = $7afe4f70edd8473f$var$initializeGlobalDefaultInteractionID();
const $7afe4f70edd8473f$export$3e0c3023952f6774 = (listener)=>{
    $7afe4f70edd8473f$var$listeners.add(listener);
    return ()=>{
        $7afe4f70edd8473f$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $7afe4f70edd8473f$var$_default_1 = (0, $eJOHy.createContext)($7afe4f70edd8473f$export$3109542b68df9ba1);
var $7afe4f70edd8473f$export$2e2bcd8739ae039 = $7afe4f70edd8473f$var$_default_1;
const $7afe4f70edd8473f$export$37bca3107733ac1e = ()=>$7afe4f70edd8473f$export$3109542b68df9ba1;
const $7afe4f70edd8473f$export$9f6000531b78127e = ()=>$7afe4f70edd8473f$export$3109542b68df9ba1;

});

parcelRegister("1bafC", function(module, exports) {
$parcel$export(module.exports, "postInteractionLog", () => $9713086142ad73dd$export$d8f52e8f804021e8);
$parcel$export(module.exports, "interactionExtraMetrics", () => $9713086142ad73dd$export$481f88116dc8b7ad);
$parcel$export(module.exports, "segmentUnmountCache", () => $9713086142ad73dd$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $9713086142ad73dd$export$2b3954d2e8509985);
$parcel$export(module.exports, "remove", () => $9713086142ad73dd$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $9713086142ad73dd$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addMetadata", () => $9713086142ad73dd$export$12f2b6cb85d59904);
$parcel$export(module.exports, "addCustomData", () => $9713086142ad73dd$export$e4380431c2bdabee);
$parcel$export(module.exports, "addCohortingCustomData", () => $9713086142ad73dd$export$20265b12c6625451);
$parcel$export(module.exports, "addCustomTiming", () => $9713086142ad73dd$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $9713086142ad73dd$export$728e28c22a0fba4);
$parcel$export(module.exports, "markFirstSegmentLoad", () => $9713086142ad73dd$export$85d1eb835f669bf);
$parcel$export(module.exports, "addSpan", () => $9713086142ad73dd$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $9713086142ad73dd$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "extractModuleName", () => $9713086142ad73dd$export$f5a8f10de74904da);
$parcel$export(module.exports, "addHold", () => $9713086142ad73dd$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $9713086142ad73dd$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $9713086142ad73dd$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $9713086142ad73dd$export$2df109852219d16e);
$parcel$export(module.exports, "ModuleLoadingProfiler", () => $9713086142ad73dd$export$9591b52b33ccc510);
$parcel$export(module.exports, "addError", () => $9713086142ad73dd$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $9713086142ad73dd$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $9713086142ad73dd$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $9713086142ad73dd$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $9713086142ad73dd$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $9713086142ad73dd$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $9713086142ad73dd$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $9713086142ad73dd$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $9713086142ad73dd$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $9713086142ad73dd$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $9713086142ad73dd$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $9713086142ad73dd$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdexToAll", () => $9713086142ad73dd$export$ad216cc25852d44b);
$parcel$export(module.exports, "addApdex", () => $9713086142ad73dd$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $9713086142ad73dd$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $9713086142ad73dd$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $9713086142ad73dd$export$d0365e48b58231c3);
$parcel$export(module.exports, "addRedirect", () => $9713086142ad73dd$export$bbf14d79614d9818);
$parcel$export(module.exports, "interactionSpans", () => $9713086142ad73dd$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $9713086142ad73dd$export$5342dcad19138a1c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");

var $91hOG = parcelRequire("91hOG");

var $5rK25 = parcelRequire("5rK25");

var $6c1HM = parcelRequire("6c1HM");

var $20BiH = parcelRequire("20BiH");

var $kzgSc = parcelRequire("kzgSc");

var $lSSn4 = parcelRequire("lSSn4");

var $5hQot = parcelRequire("5hQot");

var $5IRBH = parcelRequire("5IRBH");

var $gfkEK = parcelRequire("gfkEK");

var $izJGy = parcelRequire("izJGy");

var $Rxmlu = parcelRequire("Rxmlu");

var $dNF44 = parcelRequire("dNF44");

var $9UwKs = parcelRequire("9UwKs");
const $9713086142ad73dd$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $9713086142ad73dd$export$d8f52e8f804021e8 = new (0, $9UwKs.default)();
const $9713086142ad73dd$export$481f88116dc8b7ad = new (0, $dNF44.default)();
const $9713086142ad73dd$var$interactionQueue = [];
const $9713086142ad73dd$var$segmentCache = new Map();
const $9713086142ad73dd$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $9713086142ad73dd$var$firstSegmentLoadMarked = false;
const $9713086142ad73dd$var$segmentObservers = [];
function $9713086142ad73dd$export$2b3954d2e8509985() {
    const interactionId = (0, $gfkEK.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $Rxmlu.interactions).get(interactionId.current);
}
function $9713086142ad73dd$var$isPerformanceTracingEnabled() {
    return (0, $6c1HM.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $9713086142ad73dd$var$performanceEventObserver;
const $9713086142ad73dd$export$17afbba0f16b4b19 = ()=>{
    $9713086142ad73dd$var$performanceEventObserver = $9713086142ad73dd$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $9713086142ad73dd$export$e6be05b411ce21a6(entry);
    });
    return $9713086142ad73dd$var$performanceEventObserver;
};
const $9713086142ad73dd$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $9713086142ad73dd$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $9713086142ad73dd$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $9713086142ad73dd$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $9713086142ad73dd$var$addSegmentObserver(observer) {
    $9713086142ad73dd$var$segmentObservers.push(observer);
    for (const segmentInfo of $9713086142ad73dd$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $9713086142ad73dd$var$removeSegmentObserver(observer) {
    const index = $9713086142ad73dd$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $9713086142ad73dd$var$segmentObservers.splice(index, 1);
}
function $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId) {
    (0, $Rxmlu.interactions).delete(interactionId);
}
function $9713086142ad73dd$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $9713086142ad73dd$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $9713086142ad73dd$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $9713086142ad73dd$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $9713086142ad73dd$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $9713086142ad73dd$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $9713086142ad73dd$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $9713086142ad73dd$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $91hOG.fg)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null && !$9713086142ad73dd$var$firstSegmentLoadMarked) {
        $9713086142ad73dd$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $9713086142ad73dd$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $Rxmlu.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $9713086142ad73dd$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $9713086142ad73dd$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $Rxmlu.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
}
function $9713086142ad73dd$export$9e04fe1a58571ec(moduleId, timestamp) {
    $9713086142ad73dd$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $9713086142ad73dd$export$6f228d1fdc911d7(identifier, start, end) {
    $9713086142ad73dd$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $9713086142ad73dd$var$moduleLoadingRequests = {};
function $9713086142ad73dd$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $9713086142ad73dd$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $9713086142ad73dd$var$labelStackToString(labelStack), name, startTime);
}
function $9713086142ad73dd$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $9713086142ad73dd$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $aXKmr.v4)();
    if (!interaction && (0, $91hOG.fg)('platform_ufo_enable_late_holds_post_interaction')) // add hold timestamp to post interaction log if interaction is complete
    $9713086142ad73dd$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    ...holdActive,
                    start: start
                });
            } else {
                interaction.holdActive.set(id, {
                    ...holdActive,
                    start: start
                });
                $9713086142ad73dd$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
                ...holdActive,
                start: start
            });
            if (!experimental) interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $9713086142ad73dd$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
            $9713086142ad73dd$var$removeHoldCriterion(id);
            const currentInteraction = (0, $Rxmlu.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
                if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
                    if (interaction.hold3pActive) {
                        const current3pHold = interaction.hold3pActive.get(id);
                        if (current3pHold != null) {
                            if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                            currentInteraction.hold3pInfo.push({
                                ...current3pHold,
                                end: end
                            });
                            interaction.hold3pActive.delete(id);
                        }
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $9713086142ad73dd$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
            } else {
                interaction.holdActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
                $9713086142ad73dd$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $9713086142ad73dd$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $9713086142ad73dd$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $Rxmlu.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $9713086142ad73dd$var$removeHoldCriterion(id);
        }
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
            if (interaction.hold3pActive) {
                const current3pHold = interaction.hold3pActive.get(id);
                if (currentInteraction != null && current3pHold != null) {
                    if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                    currentInteraction.hold3pInfo.push({
                        ...current3pHold,
                        end: end
                    });
                    interaction.hold3pActive.delete(id);
                }
            }
        }
    }
}
function $9713086142ad73dd$export$2df109852219d16e(interactionId) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $9713086142ad73dd$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $9713086142ad73dd$export$9e04fe1a58571ec($9713086142ad73dd$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $9713086142ad73dd$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $9713086142ad73dd$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $9713086142ad73dd$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $9713086142ad73dd$var$moduleLoadingRequests[info.identifier];
            $9713086142ad73dd$export$6f228d1fdc911d7($9713086142ad73dd$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $gfkEK.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $9713086142ad73dd$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $gfkEK.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $9713086142ad73dd$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $9713086142ad73dd$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $9713086142ad73dd$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $Rxmlu.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $9713086142ad73dd$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $6c1HM.getConfig)()?.postInteractionLog?.enabled) $9713086142ad73dd$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $9713086142ad73dd$var$pushToQueue(id, data) {
    $9713086142ad73dd$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $9713086142ad73dd$var$handleInteraction = $9713086142ad73dd$var$pushToQueue;
function $9713086142ad73dd$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $9713086142ad73dd$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $5IRBH.currentFeatureFlagsAccessed));
    (0, $5hQot.clearActiveTrace)();
    $9713086142ad73dd$var$callCleanUpCallbacks(data);
    if ((0, $6c1HM.getConfig)()?.vc?.stopVCAtInteractionFinish) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = data.vcObserver;
        if (observer) data.vc = observer.getVCRawData();
    }
    if (data.type === 'page_load') data.hydration = (0, $6c1HM.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $lSSn4.sanitizeUfoName)(data.ufoName);
    if (!(0, $5rK25.default)((0, $6c1HM.getPostInteractionRate)(sanitisedUfoName, data.type))) $9713086142ad73dd$export$d8f52e8f804021e8.stopVCObserver();
    if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
        const sanitisedUfoName = (0, $lSSn4.sanitizeUfoName)(data.ufoName);
        if (!(0, $5rK25.default)((0, $6c1HM.getExtraInteractionRate)(sanitisedUfoName, data.type))) $9713086142ad73dd$export$481f88116dc8b7ad.stopAll(id);
        else if (!data.hold3pActive || data.hold3pActive.size === 0) {
            if (!(0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) $9713086142ad73dd$export$cd7f480d6b8286c3(id);
        }
    } else if (!(0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) $9713086142ad73dd$export$cd7f480d6b8286c3(id);
    $9713086142ad73dd$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $9713086142ad73dd$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
            if ($9713086142ad73dd$export$481f88116dc8b7ad.finishedInteraction?.id !== id) // If this same interaction was not already handled, handle it
            $9713086142ad73dd$var$handleInteraction(id, data);
        } else $9713086142ad73dd$var$handleInteraction(id, data);
    }
    if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $9713086142ad73dd$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$9713086142ad73dd$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $9713086142ad73dd$export$9e614a29a1ac213e(sinkFn) {
    if ($9713086142ad73dd$var$handleInteraction === $9713086142ad73dd$var$pushToQueue) {
        $9713086142ad73dd$var$handleInteraction = sinkFn;
        $9713086142ad73dd$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $9713086142ad73dd$var$interactionQueue.length = 0;
    }
}
function $9713086142ad73dd$export$8a1ba7bef607358a(sinkFn) {
    $9713086142ad73dd$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $9713086142ad73dd$var$activeSubmitted = false;
function $9713086142ad73dd$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $6c1HM.getConfig)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $20BiH.getExperimentalVCMetrics)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $9713086142ad73dd$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
                if ($9713086142ad73dd$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                {
                    if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId);
                }
            } else if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId);
            $9713086142ad73dd$var$activeSubmitted = false;
        };
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const noMoreActive3pHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
            if (noMoreActiveHolds && $9713086142ad73dd$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$9713086142ad73dd$var$activeSubmitted) {
                    $9713086142ad73dd$var$finishInteraction(interactionId, interaction, endTime);
                    if ((0, $6c1HM.getConfig)()?.extraInteractionMetrics?.enabled) $9713086142ad73dd$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $6c1HM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $6c1HM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $kzgSc.onSearchPageInteractionComplete)(interactionId, interaction);
                    $9713086142ad73dd$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $20BiH.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $9713086142ad73dd$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else if (noMoreActiveHolds) {
            if (!$9713086142ad73dd$var$activeSubmitted) {
                $9713086142ad73dd$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $6c1HM.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $6c1HM.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $kzgSc.onSearchPageInteractionComplete)(interactionId, interaction);
                $9713086142ad73dd$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $6c1HM.getConfig)()?.experimentalInteractionMetrics?.enabled) (0, $20BiH.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $9713086142ad73dd$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $9713086142ad73dd$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        $9713086142ad73dd$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $9713086142ad73dd$var$finishInteraction(interactionId, interaction);
        $9713086142ad73dd$export$d8f52e8f804021e8.reset();
        $9713086142ad73dd$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) $9713086142ad73dd$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $5rK25.default)((0, $6c1HM.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $20BiH.onExperimentalInteractionComplete)(interactionId, interaction);
            $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $9713086142ad73dd$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        $9713086142ad73dd$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $9713086142ad73dd$var$finishInteraction(interactionId, interaction);
        $9713086142ad73dd$export$d8f52e8f804021e8.reset();
        $9713086142ad73dd$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) $9713086142ad73dd$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $5rK25.default)((0, $6c1HM.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $20BiH.onExperimentalInteractionComplete)(interactionId, interaction);
            $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $9713086142ad73dd$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $9713086142ad73dd$export$2b3954d2e8509985();
    const finishInteractions = (0, $6c1HM.getFinishInteractionOnTransition)();
    (0, $Rxmlu.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName) && (0, $91hOG.fg)('platform_ufo_enable_finish_interaction_transition')) hasFinished = true;
        if (!hasFinished) {
            $9713086142ad73dd$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $9713086142ad73dd$var$finishInteraction(interactionId, interaction);
        $9713086142ad73dd$export$d8f52e8f804021e8.reset();
        $9713086142ad73dd$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) $9713086142ad73dd$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $5rK25.default)((0, $6c1HM.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $20BiH.onExperimentalInteractionComplete)(interactionId, interaction);
            $9713086142ad73dd$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $9713086142ad73dd$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $Rxmlu.interactions).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $9713086142ad73dd$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $9713086142ad73dd$export$481f88116dc8b7ad.reset();
    $9713086142ad73dd$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $6c1HM.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $9713086142ad73dd$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $9713086142ad73dd$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $5rK25.default)((0, $6c1HM.getCapabilityRate)('feature_flag_access'));
    const config = (0, $6c1HM.getConfig)();
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        vcObserver = (0, $izJGy.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' && (0, $91hOG.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $5IRBH.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $9713086142ad73dd$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $9713086142ad73dd$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $5IRBH.currentFeatureFlagsAccessed).clear();
    (0, $Rxmlu.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $9713086142ad73dd$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $9713086142ad73dd$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $6c1HM.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $9713086142ad73dd$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $6c1HM.getConfig)()?.postInteractionLog?.enabled) $9713086142ad73dd$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $5rK25.default)((0, $6c1HM.getExperimentalInteractionRate)(ufoName, type))) (0, $20BiH.experimentalVC).start({
            startTime: startTime
        });
        if (config?.extraInteractionMetrics?.enabled && (0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p')) $9713086142ad73dd$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $9713086142ad73dd$export$4a759336b50e86e3(event) {
    const interaction = $9713086142ad73dd$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $9713086142ad73dd$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $9713086142ad73dd$export$ad216cc25852d44b(apdex) {
    (0, $Rxmlu.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $9713086142ad73dd$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $9713086142ad73dd$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $9713086142ad73dd$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $9713086142ad73dd$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $9713086142ad73dd$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $9713086142ad73dd$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($9713086142ad73dd$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $9713086142ad73dd$export$1c43f9ac826b6462(labelStack) {
    const key = $9713086142ad73dd$var$getSegmentCacheKey(labelStack);
    const existingSegment = $9713086142ad73dd$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $9713086142ad73dd$var$segmentCache.set(key, segmentInfo);
        $9713086142ad73dd$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $9713086142ad73dd$export$d0365e48b58231c3(labelStack) {
    const key = $9713086142ad73dd$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $9713086142ad73dd$var$segmentCache.get(key);
    if (segmentInfo) {
        $9713086142ad73dd$var$segmentCache.delete(JSON.stringify(labelStack));
        if ((0, $91hOG.fg)('platform_ufo_segment_unmount_count')) {
            const cacheKey = (0, $lSSn4.stringifyLabelStackFully)(labelStack);
            $9713086142ad73dd$export$a2b14406ded37d60.set(cacheKey, ($9713086142ad73dd$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        }
        $9713086142ad73dd$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $9713086142ad73dd$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $Rxmlu.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($9713086142ad73dd$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $9713086142ad73dd$export$6ce04c7ca6810a7e = [];
const $9713086142ad73dd$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $9713086142ad73dd$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $9713086142ad73dd$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $9713086142ad73dd$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("5rK25", function(module, exports) {
$parcel$export(module.exports, "default", () => $44860f88dc037781$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $44860f88dc037781$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $44860f88dc037781$export$2e2bcd8739ae039 = $44860f88dc037781$var$coinflip;

});

parcelRegister("6c1HM", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $13f144f4865ac3c2$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $13f144f4865ac3c2$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $13f144f4865ac3c2$export$44487a86467333c3);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $13f144f4865ac3c2$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $13f144f4865ac3c2$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $13f144f4865ac3c2$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $13f144f4865ac3c2$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $13f144f4865ac3c2$export$563f73272328c0d);
$parcel$export(module.exports, "getVCRawDataInteractionRate", () => $13f144f4865ac3c2$export$48f4e0d964030a96);
$parcel$export(module.exports, "getPostInteractionRate", () => $13f144f4865ac3c2$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $13f144f4865ac3c2$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getExtraInteractionRate", () => $13f144f4865ac3c2$export$203bd06a99c66a0d);
$parcel$export(module.exports, "getTypingPerformanceTracingMethod", () => $13f144f4865ac3c2$export$7e32aae12bf9b50f);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $13f144f4865ac3c2$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $13f144f4865ac3c2$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $13f144f4865ac3c2$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $13f144f4865ac3c2$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $13f144f4865ac3c2$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $13f144f4865ac3c2$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $13f144f4865ac3c2$export$c681731847989445);

var $91hOG = parcelRequire("91hOG");
let $13f144f4865ac3c2$var$config;
const $13f144f4865ac3c2$export$f9bb3bb330fb9609 = 'fy25.03';
const $13f144f4865ac3c2$export$d50dacda7fe6392b = 1000;
function $13f144f4865ac3c2$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (typeof enabledVCRevisions?.byExperience === 'object') $13f144f4865ac3c2$var$config = {
        ...newConfig,
        vc: {
            ...newConfig.vc,
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $13f144f4865ac3c2$export$f9bb3bb330fb9609,
                    ...enabledVCRevisions?.all,
                    ...Object.values(enabledVCRevisions?.byExperience).flat()
                ])),
                byExperience: {
                    ...enabledVCRevisions?.byExperience
                }
            }
        }
    };
    else $13f144f4865ac3c2$var$config = newConfig;
}
function $13f144f4865ac3c2$export$44487a86467333c3() {
    return $13f144f4865ac3c2$var$config;
}
const $13f144f4865ac3c2$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $13f144f4865ac3c2$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$13f144f4865ac3c2$var$config) return [];
        if ($13f144f4865ac3c2$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $13f144f4865ac3c2$var$config.vc ?? {};
            if ($13f144f4865ac3c2$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            if ($13f144f4865ac3c2$var$isValidConfigArray(enabledVCRevisions?.all)) return enabledVCRevisions.all;
            return [
                $13f144f4865ac3c2$export$f9bb3bb330fb9609
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $13f144f4865ac3c2$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $13f144f4865ac3c2$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $13f144f4865ac3c2$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $13f144f4865ac3c2$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $13f144f4865ac3c2$export$2d8f8d64dc343d7b() {
    if (!$13f144f4865ac3c2$var$config) return undefined;
    try {
        const stats = $13f144f4865ac3c2$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $13f144f4865ac3c2$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$13f144f4865ac3c2$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $13f144f4865ac3c2$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $13f144f4865ac3c2$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $13f144f4865ac3c2$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$13f144f4865ac3c2$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $13f144f4865ac3c2$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $13f144f4865ac3c2$export$48f4e0d964030a96(name, interactionType) {
    return $13f144f4865ac3c2$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $13f144f4865ac3c2$export$1d459f020c06ae34(name, interactionType) {
    return $13f144f4865ac3c2$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $13f144f4865ac3c2$export$29b9ffb14861a1d(capability) {
    if ((0, $91hOG.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$13f144f4865ac3c2$var$config) return 0;
        const { capability: capabilityRate } = $13f144f4865ac3c2$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $13f144f4865ac3c2$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$13f144f4865ac3c2$var$config) return 0;
        const gotConfig = $13f144f4865ac3c2$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $13f144f4865ac3c2$export$203bd06a99c66a0d(name, interactionType) {
    return $13f144f4865ac3c2$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $13f144f4865ac3c2$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $13f144f4865ac3c2$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$13f144f4865ac3c2$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $13f144f4865ac3c2$var$config;
        if (typingMethod != null && $13f144f4865ac3c2$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $13f144f4865ac3c2$export$2d311b3fd18dcab1() {
    try {
        if (!$13f144f4865ac3c2$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $13f144f4865ac3c2$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $13f144f4865ac3c2$export$4f4649ef27b6f5d6() {
    try {
        if (!$13f144f4865ac3c2$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $13f144f4865ac3c2$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $13f144f4865ac3c2$export$b150ddad71c80d77() {
    try {
        if (!$13f144f4865ac3c2$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $13f144f4865ac3c2$var$config;
        return minorInteractions;
    } catch (e) {
        return undefined;
    }
}
function $13f144f4865ac3c2$export$3c170167645a0eff() {
    try {
        if (!$13f144f4865ac3c2$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $13f144f4865ac3c2$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $13f144f4865ac3c2$export$d6dc9444bd15f70f() {
    try {
        if (!$13f144f4865ac3c2$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $13f144f4865ac3c2$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function $13f144f4865ac3c2$export$20e8108b8ccdd0bd() {
    try {
        if (!$13f144f4865ac3c2$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $13f144f4865ac3c2$var$config;
        return finishInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
const $13f144f4865ac3c2$export$2a8604960d7d23d9 = 60000;
function $13f144f4865ac3c2$export$c681731847989445(ufoName) {
    try {
        if (!$13f144f4865ac3c2$var$config) return $13f144f4865ac3c2$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $13f144f4865ac3c2$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $13f144f4865ac3c2$export$2a8604960d7d23d9;
    } catch (e) {
        return $13f144f4865ac3c2$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("20BiH", function(module, exports) {
$parcel$export(module.exports, "sinkExperimentalHandler", () => $8ff635be14964fa6$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $8ff635be14964fa6$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $8ff635be14964fa6$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $8ff635be14964fa6$export$d17d2b5c5e8d732e);

var $f4UEC = parcelRequire("f4UEC");

var $d7bK6 = parcelRequire("d7bK6");
const $8ff635be14964fa6$var$interactionBuffer = [];
let $8ff635be14964fa6$var$bufferInteractionData = (interactionId, data)=>{
    $8ff635be14964fa6$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $8ff635be14964fa6$var$clearInteractionBuffer() {
    $8ff635be14964fa6$var$interactionBuffer.length = 0;
}
function $8ff635be14964fa6$var$appendInteractionData(interactionId, data) {
    $8ff635be14964fa6$var$bufferInteractionData(interactionId, data);
}
function $8ff635be14964fa6$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $8ff635be14964fa6$var$interactionBuffer)handler(interactionId, data);
    $8ff635be14964fa6$var$clearInteractionBuffer();
    $8ff635be14964fa6$var$bufferInteractionData = handler;
}
function $8ff635be14964fa6$export$7aa99c40634ac65f(sinkFn) {
    $8ff635be14964fa6$export$c8a9e17ae62a073d(sinkFn);
}
function $8ff635be14964fa6$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $8ff635be14964fa6$var$appendInteractionData(interactionId, data);
        $8ff635be14964fa6$var$clearInteractionBuffer();
    }
}
class $8ff635be14964fa6$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $d7bK6.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $8ff635be14964fa6$export$81b28dca2587ec47 = new $8ff635be14964fa6$export$f9a59f57e0282541();
async function $8ff635be14964fa6$export$d17d2b5c5e8d732e(interaction) {
    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
    const vcObserver = interaction.experimentalVCObserver || $8ff635be14964fa6$export$81b28dca2587ec47.vcObserver;
    const pageVisibilityUpToTTAI = (0, $f4UEC.getPageVisibilityState)(interaction.start, interaction.end);
    if (vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            interactionType: interaction.type,
            isPageVisible: pageVisibilityUpToTTAI === 'visible',
            interactionAbortReason: interaction.abortReason
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("f4UEC", function(module, exports) {
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $f6a2b9eb9932cf6a$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $f6a2b9eb9932cf6a$export$768b2008623433e1);

var $4eDgu = parcelRequire("4eDgu");
const $f6a2b9eb9932cf6a$var$timings = [];
let $f6a2b9eb9932cf6a$var$wasHiddenFlag;
let $f6a2b9eb9932cf6a$var$setupFlag = false;
function $f6a2b9eb9932cf6a$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $f6a2b9eb9932cf6a$var$SIZE = 50;
let $f6a2b9eb9932cf6a$var$insertIndex = 0;
function $f6a2b9eb9932cf6a$var$pushHidden(isPageHiddenFlag, time) {
    $f6a2b9eb9932cf6a$var$timings[$f6a2b9eb9932cf6a$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $f6a2b9eb9932cf6a$var$insertIndex = ($f6a2b9eb9932cf6a$var$insertIndex + 1) % $f6a2b9eb9932cf6a$var$SIZE;
    $f6a2b9eb9932cf6a$var$wasHiddenFlag = isPageHiddenFlag;
}
function $f6a2b9eb9932cf6a$var$handleChange() {
    const isPageHiddenFlag = $f6a2b9eb9932cf6a$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$f6a2b9eb9932cf6a$var$wasHiddenFlag) $f6a2b9eb9932cf6a$var$pushHidden(isPageHiddenFlag);
        $f6a2b9eb9932cf6a$var$wasHiddenFlag = true;
    } else {
        if ($f6a2b9eb9932cf6a$var$wasHiddenFlag) $f6a2b9eb9932cf6a$var$pushHidden(isPageHiddenFlag);
        $f6a2b9eb9932cf6a$var$wasHiddenFlag = false;
    }
}
function $f6a2b9eb9932cf6a$var$setup() {
    (0, $4eDgu.bind)(window, {
        type: 'pageshow',
        listener: $f6a2b9eb9932cf6a$var$handleChange
    });
    (0, $4eDgu.bind)(window, {
        type: 'pagehide',
        listener: $f6a2b9eb9932cf6a$var$handleChange
    });
    (0, $4eDgu.bind)(document, {
        type: 'visibilitychange',
        listener: $f6a2b9eb9932cf6a$var$handleChange
    });
}
function $f6a2b9eb9932cf6a$export$554cefe0f0373da4() {
    if (!$f6a2b9eb9932cf6a$var$setupFlag) {
        const isPageHiddenFlag = $f6a2b9eb9932cf6a$var$isPageHidden();
        $f6a2b9eb9932cf6a$var$pushHidden(isPageHiddenFlag, 0);
        $f6a2b9eb9932cf6a$var$setup();
        $f6a2b9eb9932cf6a$var$setupFlag = true;
    }
}
function $f6a2b9eb9932cf6a$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($f6a2b9eb9932cf6a$var$timings.length === 0) return 'visible';
    const currentSize = $f6a2b9eb9932cf6a$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $f6a2b9eb9932cf6a$var$insertIndex;
    let endIdx = $f6a2b9eb9932cf6a$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($f6a2b9eb9932cf6a$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($f6a2b9eb9932cf6a$var$timings[tmpIdx] && $f6a2b9eb9932cf6a$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($f6a2b9eb9932cf6a$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $f6a2b9eb9932cf6a$var$timings[startIdx]) hiddenState = $f6a2b9eb9932cf6a$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}

});

parcelRegister("d7bK6", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $ca127f5007ba3207$export$1f70d263701b1d01);

var $6c1HM = parcelRequire("6c1HM");

var $1bafC = parcelRequire("1bafC");

var $lLxwD = parcelRequire("lLxwD");

var $6rrXy = parcelRequire("6rrXy");

var $bICws = parcelRequire("bICws");

var $jT1Gu = parcelRequire("jT1Gu");

var $i1uRk = parcelRequire("i1uRk");
const $ca127f5007ba3207$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $ca127f5007ba3207$var$UNUSED_SECTOR = 0;
function $ca127f5007ba3207$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $ca127f5007ba3207$export$1f70d263701b1d01 {
    static{
        /** config * */ this.VCParts = [
            '25',
            '50',
            '75',
            '80',
            '85',
            '90',
            '95',
            '98',
            '99'
        ];
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $6c1HM.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $ca127f5007ba3207$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $ca127f5007ba3207$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $ca127f5007ba3207$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $6rrXy.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $6rrXy.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $bICws.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $ca127f5007ba3207$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $ca127f5007ba3207$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $6c1HM.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $1bafC.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $6c1HM.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($ca127f5007ba3207$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($ca127f5007ba3207$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($ca127f5007ba3207$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $lLxwD.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        this.observers = new (0, $i1uRk.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $6c1HM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $ca127f5007ba3207$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $ca127f5007ba3207$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $ca127f5007ba3207$var$UNUSED_SECTOR && ssrTime !== $ca127f5007ba3207$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $ca127f5007ba3207$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $ca127f5007ba3207$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $ca127f5007ba3207$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $ca127f5007ba3207$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $ca127f5007ba3207$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $ca127f5007ba3207$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $6c1HM.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($ca127f5007ba3207$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $jT1Gu.getViewportWidth)();
        this.viewport.h = (0, $jT1Gu.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($ca127f5007ba3207$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($ca127f5007ba3207$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $ca127f5007ba3207$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("lLxwD", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $4d9bcf7091807176$export$9010aa71841a6887);

var $4eDgu = parcelRequire("4eDgu");

var $iFyli = parcelRequire("iFyli");

var $jT1Gu = parcelRequire("jT1Gu");
function $4d9bcf7091807176$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $4eDgu.bind)(window, {
        type: (0, $iFyli.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $iFyli.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $4eDgu.bind)(window, {
        type: (0, $iFyli.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $iFyli.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $4eDgu.bind)(window, {
        type: (0, $iFyli.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $jT1Gu.getViewportWidth)() !== initialViewPort.w || (0, $jT1Gu.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $iFyli.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("iFyli", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $cd7dffcab5c8da4a$export$199edc0307b5587f);
const $cd7dffcab5c8da4a$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("jT1Gu", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $8d0acc0c63f23d43$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $8d0acc0c63f23d43$export$4f01c15d21ef9cc6);
function $8d0acc0c63f23d43$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $8d0acc0c63f23d43$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("6rrXy", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $a06f529704fa68a3$export$72e6dda9d5859230);
function $a06f529704fa68a3$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("bICws", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $b42953eb042740cc$export$5c86a34c9becd6d0);

var $6c1HM = parcelRequire("6c1HM");

var $f4UEC = parcelRequire("f4UEC");
const $b42953eb042740cc$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $b42953eb042740cc$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $b42953eb042740cc$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $b42953eb042740cc$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $b42953eb042740cc$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $b42953eb042740cc$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $f4UEC.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $6c1HM.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $b42953eb042740cc$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $6c1HM.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $b42953eb042740cc$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});

parcelRegister("i1uRk", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $4541fb10351ee3d4$export$b65d046240060e78);

var $iFBsm = parcelRequire("iFBsm");

var $eSgQw = parcelRequire("eSgQw");

var $k0v6Z = parcelRequire("k0v6Z");

var $gE0QU = parcelRequire("gE0QU");
const $4541fb10351ee3d4$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $4541fb10351ee3d4$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $4541fb10351ee3d4$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $4541fb10351ee3d4$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $gE0QU.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $4541fb10351ee3d4$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $4541fb10351ee3d4$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $4541fb10351ee3d4$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $4541fb10351ee3d4$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $4541fb10351ee3d4$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $4541fb10351ee3d4$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $iFBsm.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $eSgQw.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $iFBsm.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$4541fb10351ee3d4$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $k0v6Z.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("iFBsm", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $d998f7d32191f998$export$f61fbc3b9c4a9019);

var $il9IO = parcelRequire("il9IO");
function $d998f7d32191f998$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $il9IO.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("il9IO", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $104ed7f0252dca6d$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $104ed7f0252dca6d$export$7028e9efe569888c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $104ed7f0252dca6d$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $104ed7f0252dca6d$export$7028e9efe569888c = {
    [$104ed7f0252dca6d$export$7674290405cc25b0]: true
};
function $104ed7f0252dca6d$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...$104ed7f0252dca6d$export$7028e9efe569888c,
        children: children
    });
}

});


parcelRegister("eSgQw", function(module, exports) {
$parcel$export(module.exports, "default", () => $58c66fd379dcffdb$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $58c66fd379dcffdb$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $58c66fd379dcffdb$export$2e2bcd8739ae039 = $58c66fd379dcffdb$var$isNonVisualStyleMutation;

});

parcelRegister("k0v6Z", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $bd438a4351bf08ea$export$166779fc0f49d4df);
const $bd438a4351bf08ea$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $bd438a4351bf08ea$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
	 * Gets the global singleton instance of RLLPlaceholderHandlers.
	 * Creates the instance if it doesn't exist and stores it in globalThis.
	 * @returns The singleton instance of RLLPlaceholderHandlers
	 */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$bd438a4351bf08ea$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$bd438a4351bf08ea$var$GLOBAL_RLL_HANDLERS_KEY] = new $bd438a4351bf08ea$export$166779fc0f49d4df();
            return globalThis[$bd438a4351bf08ea$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $bd438a4351bf08ea$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
	 * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
	 * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
	 * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
	 * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
	 */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
	 * Traverses DOM siblings to find all elements between RLL begin and end markers.
	 * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
	 * Performance optimized to minimize iterations and early exit conditions.
	 *
	 * @param fromEl - The input element with data-lazy-begin attribute
	 * @param id - The placeholder ID to match against data-lazy-end
	 * @returns Array of DOM elements between the begin/end markers
	 */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
	 * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
	 * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
	 */ getPlaceholders() {
        return this.placeholders;
    }
    /**
	 * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
	 * This is designed to be called from IntersectionObserver with the intersectionRect.
	 * Performance optimized with early exits and minimal calculations.
	 * @param intersectingRect - The intersecting rectangle from IntersectionObserver
	 * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
	 */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
	 * Compares two DOMRect objects for equality with ±1 pixel tolerance.
	 * Performance optimized to minimize calculations and early exit on major differences.
	 * @param rect1 - First rectangle to compare
	 * @param rect2 - Second rectangle to compare
	 * @returns true if rectangles are within 1 pixel tolerance for all properties
	 */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("gE0QU", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $2c3d875165db6746$export$c0102f1a1198d10f);

var $91hOG = parcelRequire("91hOG");
const $2c3d875165db6746$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $2c3d875165db6746$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $2c3d875165db6746$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $2c3d875165db6746$var$PAGE_LAYOUT_ID) return $2c3d875165db6746$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $2c3d875165db6746$var$PAGE_LAYOUT_ID) return $2c3d875165db6746$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
	 * Added this method to be utilised for testing purposes.
	 * In production it collection placeholder should only happens on constructor
	 */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $2c3d875165db6746$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
	 * Gets the effective bounding rectangle for an element, handling display: contents elements
	 * by collecting dimensions from their children instead
	 */ getEffectiveBoundingRect(el) {
        if ((0, $91hOG.fg)('platform_ufo_disable_vcnext_observations')) return el.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});




parcelRegister("kzgSc", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $ebfc4e9504b4b2db$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $ebfc4e9504b4b2db$export$74b9ce7e9d206a8);
const $ebfc4e9504b4b2db$var$interactionBuffer = [];
let $ebfc4e9504b4b2db$var$bufferInteractionData = (interactionId, data)=>{
    $ebfc4e9504b4b2db$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $ebfc4e9504b4b2db$var$clearInteractionBuffer() {
    $ebfc4e9504b4b2db$var$interactionBuffer.length = 0;
}
function $ebfc4e9504b4b2db$var$appendInteractionData(interactionId, data) {
    $ebfc4e9504b4b2db$var$bufferInteractionData(interactionId, data);
}
function $ebfc4e9504b4b2db$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $ebfc4e9504b4b2db$var$interactionBuffer)handler(interactionId, data);
    $ebfc4e9504b4b2db$var$clearInteractionBuffer();
    $ebfc4e9504b4b2db$var$bufferInteractionData = handler;
}
function $ebfc4e9504b4b2db$export$e6a07a94f3e112d4(sinkFn) {
    $ebfc4e9504b4b2db$var$installInteractionSink(sinkFn);
}
function $ebfc4e9504b4b2db$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $ebfc4e9504b4b2db$var$appendInteractionData(interactionId, data);
        $ebfc4e9504b4b2db$var$clearInteractionBuffer();
    }
}

});

parcelRegister("lSSn4", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $3c0d0806b7f0e08f$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $3c0d0806b7f0e08f$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $3c0d0806b7f0e08f$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $3c0d0806b7f0e08f$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $3c0d0806b7f0e08f$export$a0cd72da07c76b4c);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $3c0d0806b7f0e08f$export$b70bcfd92c93435e);

var $91hOG = parcelRequire("91hOG");

var $6c1HM = parcelRequire("6c1HM");

var $35uD4 = parcelRequire("35uD4");
function $3c0d0806b7f0e08f$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $3c0d0806b7f0e08f$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $6c1HM.getConfig)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    if ((0, $91hOG.fg)('platform_ufo_add_segments_count_threshold')) labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $3c0d0806b7f0e08f$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(label);
            const name = label.name;
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    else labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(label) ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $3c0d0806b7f0e08f$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $3c0d0806b7f0e08f$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        if ($3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(l)) return `${l.name}:segment`;
        return l.name;
    }).join('/');
}
function $3c0d0806b7f0e08f$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $3c0d0806b7f0e08f$export$1787b1cd413c7e2(labelStack, startWith) {
    return $3c0d0806b7f0e08f$export$caeee352b541de1f(labelStack).startsWith($3c0d0806b7f0e08f$export$caeee352b541de1f(startWith));
}
function $3c0d0806b7f0e08f$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $3c0d0806b7f0e08f$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $3c0d0806b7f0e08f$export$b70bcfd92c93435e(segments, interactionType) {
    if ((0, $91hOG.fg)('platform_ufo_add_segments_count_threshold')) {
        const config = (0, $6c1HM.getConfig)();
        const addSegmentsMap = new Map();
        const segmentThreshold = config?.segmentsThreshold;
        return segments.map(({ labelStack: labelStack, ...others })=>{
            const stringifiedLabelStack = $3c0d0806b7f0e08f$export$88f21baa687271f4(labelStack);
            const segmentsInfo = [];
            for (const ls of labelStack){
                const isSegment = $3c0d0806b7f0e08f$export$1adbaf5c2363e4ae(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    const threshold = segmentThreshold[ls.name];
                    const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push({
                    n: ls.name,
                    ...ls.segmentId ? {
                        s: ls.segmentId
                    } : {},
                    ...ls.type ? {
                        t: ls.type
                    } : {}
                });
            }
            return {
                ...others,
                labelStack: segmentsInfo
            };
        });
    }
    return segments.map(({ labelStack: labelStack, ...others })=>({
            ...others,
            labelStack: $3c0d0806b7f0e08f$export$a0cd72da07c76b4c(labelStack, (0, $35uD4.getReactUFOPayloadVersion)(interactionType))
        }));
}

});
parcelRegister("35uD4", function(module, exports) {
$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", () => $abbcb2d90bfa874f$export$e919e900fc2d7fe8);
$parcel$export(module.exports, "getReactUFOPayloadVersion", () => $abbcb2d90bfa874f$export$159168550e7449b8);
const $abbcb2d90bfa874f$export$e919e900fc2d7fe8 = '2.0.0';
function $abbcb2d90bfa874f$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $abbcb2d90bfa874f$export$e919e900fc2d7fe8;
}

});


parcelRegister("izJGy", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $b21ae206124ecbe2$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "getVCObserver", () => $b21ae206124ecbe2$export$b3bc47985717b49e);
$parcel$export(module.exports, "newVCObserver", () => $b21ae206124ecbe2$export$c69731bddfc24d85);

var $6c1HM = parcelRequire("6c1HM");

var $5Fykh = parcelRequire("5Fykh");

var $d7bK6 = parcelRequire("d7bK6");

var $6fGT7 = parcelRequire("6fGT7");

var $k0v6Z = parcelRequire("k0v6Z");

var $gE0QU = parcelRequire("gE0QU");

var $igDjg = parcelRequire("igDjg");
class $b21ae206124ecbe2$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $gE0QU.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.03') || (0, $6c1HM.isVCRevisionEnabled)('next')) this.newVCObserver = new (0, $6fGT7.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.01') || (0, $6c1HM.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $d7bK6.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $6c1HM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $6c1HM.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        if ((0, $6c1HM.isVCRevisionEnabled)('fy25.03', experienceKey)) this.newVCObserver?.stop();
        (0, $k0v6Z.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $6c1HM.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $6c1HM.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = (0, $6c1HM.isVCRevisionEnabled)('fy25.03', experienceKey) ? await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3
        }) : [];
        if (!v3v4Result) return v1v2Result ?? {};
        const ssrRatio = v3v4Result[0].ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}
// Some products set this variable to indicate it is running in SSR
let $b21ae206124ecbe2$var$isServer = Boolean(globalThis?.false);
// Other products set this other variable to indicate it is running in SSR
let $b21ae206124ecbe2$var$isReactSSR = typeof $igDjg !== 'undefined' && Boolean($igDjg?.env?.REACT_SSR || false);
function $b21ae206124ecbe2$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($b21ae206124ecbe2$var$isReactSSR || $b21ae206124ecbe2$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $b21ae206124ecbe2$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$b21ae206124ecbe2$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $5Fykh.VCObserverNOOP)() : new $b21ae206124ecbe2$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $b21ae206124ecbe2$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$b21ae206124ecbe2$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $5Fykh.VCObserverNOOP)() : new $b21ae206124ecbe2$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}

});
parcelRegister("5Fykh", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $a146d92fe11dcf9d$export$24d07287b49da906);
class $a146d92fe11dcf9d$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("6fGT7", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c3e2904923be83$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $gE0QU = parcelRequire("gE0QU");

var $3jDdE = parcelRequire("3jDdE");

var $37Fea = parcelRequire("37Fea");

var $45NOU = parcelRequire("45NOU");

var $dvoU5 = parcelRequire("dvoU5");

var $d04AS = parcelRequire("d04AS");

var $argxT = parcelRequire("argxT");

var $1NCjK = parcelRequire("1NCjK");

var $aBIbT = parcelRequire("aBIbT");

var $2jhmR = parcelRequire("2jhmR");
const $26c3e2904923be83$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $26c3e2904923be83$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $26c3e2904923be83$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $26c3e2904923be83$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $3jDdE.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        this.selectorConfig = config.selectorConfig ?? $26c3e2904923be83$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $gE0QU.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.viewportObserver = new (0, $aBIbT.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue
                };
                if (element && this.isPostInteraction && (0, $91hOG.fg)('platform_ufo_enable_late_mutation_label_stacks')) {
                    const labelStacks = $26c3e2904923be83$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler()
        });
        this.windowEventObserver = new (0, $2jhmR.default)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $26c3e2904923be83$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $26c3e2904923be83$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $dvoU5.default)(),
                    width: (0, $d04AS.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $dvoU5.default)(),
                    right: (0, $d04AS.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $45NOU.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason
        });
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        // From the next major version release (where TTVC v4 becomes the default TTVC version), the config for `includeSSRInV3` will be deprecated
        if (param.ssr && !param.includeSSRInV3 && (0, $91hOG.fg)('platform_ufo_auto_add_ssr_entry_in_ttvc_v4')) this.addSSR(param.ssr);
        // TODO on cleanup: put behind `enabledVCRevisions` config
        const calculator_next = new (0, $argxT.default)();
        const vcNext = await calculator_next.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason
        });
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        if (includeRawData && (0, $91hOG.fg)('platform_ufo_enable_vc_raw_data')) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $1NCjK.default)();
            const raw = await rawHandler.getRawData({
                entries: orderedEntries,
                startTime: start,
                stopTime: stop,
                isPageVisible: isPageVisible
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $37Fea.default)(this.selectorConfig, element);
    }
}
function $26c3e2904923be83$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $26c3e2904923be83$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>label.name).join('/');
}
function $26c3e2904923be83$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>label.name).join('/');
}
function $26c3e2904923be83$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $26c3e2904923be83$var$labelStackFromFiber(currentFiber);
                labelStackString = $26c3e2904923be83$var$labelStackToString(labelStack) || 'unknown';
                segment = $26c3e2904923be83$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $26c3e2904923be83$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $26c3e2904923be83$var$traverseFiber(fiber) : null;
}

});
parcelRegister("3jDdE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c3ff1a5972a5984$export$2e2bcd8739ae039);
class $6c3ff1a5972a5984$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("37Fea", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f3a2abdf03e376e$export$2e2bcd8739ae039);
const $4f3a2abdf03e376e$var$nameCache = new WeakMap();
function $4f3a2abdf03e376e$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $4f3a2abdf03e376e$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $4f3a2abdf03e376e$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $4f3a2abdf03e376e$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $4f3a2abdf03e376e$var$nameCache.set(element, name);
    return name;
}
var $4f3a2abdf03e376e$export$2e2bcd8739ae039 = $4f3a2abdf03e376e$var$getElementName;

});

parcelRegister("45NOU", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e4209cd0e1aabef$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $dNsNa = parcelRequire("dNsNa");

var $cov2F = parcelRequire("cov2F");

var $hb81d = parcelRequire("hb81d");

var $gGbro = parcelRequire("gGbro");

var $6fOa5 = parcelRequire("6fOa5");
const $5e4209cd0e1aabef$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $5e4209cd0e1aabef$var$REVISION_NO = 'fy25.03';
const $5e4209cd0e1aabef$var$getConsideredEntryTypes = (include3p)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // If not exclude 3p elements from ttvc,
    // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
    if (!(0, $91hOG.fg)('platform_ufo_exclude_3p_elements_from_ttvc') || include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if ((0, $91hOG.fg)('platform_ufo_enable_media_for_ttvc_v3')) entryTypes.push('mutation:media');
    return entryTypes;
};
const $5e4209cd0e1aabef$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed'
];
const $5e4209cd0e1aabef$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $5e4209cd0e1aabef$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
class $5e4209cd0e1aabef$export$2e2bcd8739ae039 extends (0, $hb81d.default) {
    constructor(revisionNo){
        super(revisionNo ?? $5e4209cd0e1aabef$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$5e4209cd0e1aabef$var$getConsideredEntryTypes(include3p).includes(entry.data.type)) return false;
        if (excludeSmartAnswersInSearch && (0, $gGbro.isEntrySmartAnswersInSearch)(entry)) return false;
        if (entry.data.type === 'mutation:media' && (0, $91hOG.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $dNsNa.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $dNsNa.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $cov2F.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || $5e4209cd0e1aabef$export$98812f4e79596e2b.includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || attributeName === 'data-aui-version' || attributeName === 'data-testid' || attributeName === 'data-vc' || attributeName === 'data-ssr-placeholder' || attributeName === 'data-ssr-placeholder-replace' || attributeName === 'data-vc-nvs' || attributeName === 'data-media-vc-wrapper' || attributeName === 'data-renderer-start-pos' || attributeName === 'data-table-local-id' || attributeName === 'spellcheck' || attributeName === 'data-auto-scrollable' || attributeName === 'id' || attributeName === 'tabindex' || attributeName === 'data-is-ttvc-ready' || attributeName === 'contenteditable' || attributeName === 'data-has-collab-initialised' || attributeName === 'translate' || $5e4209cd0e1aabef$export$44331555a87fcd9e.includes(attributeName) || $5e4209cd0e1aabef$export$c4351da6279bef53.includes(attributeName) && (0, $91hOG.fg)('platform_ufo_exclude_3p_extensions_from_ttvc')) return false;
            return true;
        }
        if ((0, $6fOa5.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($5e4209cd0e1aabef$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("dNsNa", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $75055580f2223095$export$9db1624a8af791a4);

var $gxP2H = parcelRequire("gxP2H");

var $5IRBH = parcelRequire("5IRBH");
const $75055580f2223095$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $gxP2H.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $gxP2H.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $5IRBH.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("cov2F", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $04e1bcb7f7fe62d5$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $04e1bcb7f7fe62d5$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");
const $04e1bcb7f7fe62d5$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $04e1bcb7f7fe62d5$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $04e1bcb7f7fe62d5$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(0, $91hOG.fg)('platform_editor_exclude_dnd_anchor_name_from_ttvc')) return false;
    if (!(target instanceof Element)) return false;
    return $04e1bcb7f7fe62d5$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $04e1bcb7f7fe62d5$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $04e1bcb7f7fe62d5$var$parseStyleSet(oldValue);
    const newStyles = $04e1bcb7f7fe62d5$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$04e1bcb7f7fe62d5$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$04e1bcb7f7fe62d5$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $04e1bcb7f7fe62d5$export$2e2bcd8739ae039 = $04e1bcb7f7fe62d5$export$e20e7bf2c822f3df;

});

parcelRegister("hb81d", function(module, exports) {
$parcel$export(module.exports, "default", () => $c00e03d922358bdf$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $ieujm = parcelRequire("ieujm");

var $dvoU5 = parcelRequire("dvoU5");

var $d04AS = parcelRequire("d04AS");
class $c00e03d922358bdf$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
	 * Calculate ratios for each element based on their viewport coverage.
	 */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $d04AS.default)();
        const viewportHeight = (0, $dvoU5.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = elementArea / totalViewportArea;
        }
        return ratios;
    }
    getLabelStacks(filteredEntries) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ('elementName' in entry.data && entry.data.labelStacks) labelStacks[entry.data.elementName] = {
            segment: entry.data.labelStacks.segment,
            labelStack: entry.data.labelStacks.labelStack
        };
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const vcLogs = await (0, $ieujm.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $d04AS.default)(),
                height: (0, $dvoU5.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR') && (0, $91hOG.fg)('vc_v3_ssr_ratio_fixed_range')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = entries.map((e)=>e.elementName);
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p && (0, $91hOG.fg)('platform_ufo_enable_ttai_with_3p');
        // Only calculate enhanced debug details if devtool callbacks exist
        let shouldCalculateDebugDetails = (!isPostInteraction || shouldCalculate3p) && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function');
        if ((0, $91hOG.fg)('platform_ufo_fix_post_interaction_check_vc_debug')) shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio);
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        if (isPostInteraction) result.labelStacks = this.getLabelStacks(filteredEntries);
        return result;
    }
}

});
parcelRegister("ieujm", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $0cbd72e64f2ecdfe$export$96ea73435089b05a);

var $91hOG = parcelRequire("91hOG");

var $7XqV3 = parcelRequire("7XqV3");
async function $0cbd72e64f2ecdfe$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $7XqV3.ViewportCanvas)(viewport, (0, $91hOG.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $0cbd72e64f2ecdfe$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $0cbd72e64f2ecdfe$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $7XqV3.ViewportCanvas)(viewport, (0, $91hOG.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $0cbd72e64f2ecdfe$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $0cbd72e64f2ecdfe$export$2e2bcd8739ae039 = $0cbd72e64f2ecdfe$var$calculateTTVCPercentiles;
function $0cbd72e64f2ecdfe$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $0cbd72e64f2ecdfe$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const results = new Array(elementMap.size);
    let cumulativePixels = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}

});
parcelRegister("7XqV3", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $aaa3dc9de8cebb5e$export$3e59ac9de7402fb1);

var $9dJH4 = parcelRequire("9dJH4");
class $aaa3dc9de8cebb5e$export$3e59ac9de7402fb1 {
    /**
	 * Creates a new ViewportCanvas instance.
	 * @param viewport - The dimensions of the viewport
	 * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
	 * @throws {Error} If canvas context cannot be obtained
	 */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            willReadFrequently: true,
            colorSpace: 'srgb'
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
	 * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
	 */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
	 * Clears the entire canvas by removing all drawn content.
	 * @private
	 */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
	 * Generates a unique RGB color from an incrementing counter.
	 * Uses a 24-bit color space (16,777,216 possible colors).
	 *
	 * @private
	 * @returns A unique RGB color string
	 *
	 * @example
	 * // Example bit operations for color 0x00FF8040:
	 * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
	 * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
	 * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
	 */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $aaa3dc9de8cebb5e$export$54591583ed0b20ce(rgbColor);
    }
    /**
	 * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
	 * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
	 *
	 * @param rect - The rectangle dimensions to draw
	 * @param timestamp - The timestamp to associate with this drawing operation
	 */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
	 * Calculates the number of pixels drawn for each timestamp.
	 * This method:
	 * 1. Reads the pixel data from the canvas
	 * 2. Counts pixels of each unique color
	 * 3. Maps colors back to their timestamps
	 * 4. Adjusts counts based on the scale factor
	 *
	 * @returns A Map containing timestamp to pixel count mappings
	 */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $aaa3dc9de8cebb5e$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $aaa3dc9de8cebb5e$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $aaa3dc9de8cebb5e$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $aaa3dc9de8cebb5e$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $9dJH4.default)();
    }
    return arr;
}

});
parcelRegister("9dJH4", function(module, exports) {
$parcel$export(module.exports, "default", () => $19ba3c093ea61108$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $19ba3c093ea61108$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $19ba3c093ea61108$export$2e2bcd8739ae039 = $19ba3c093ea61108$var$taskYield;

});



parcelRegister("dvoU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcf0bce2ddb683b1$export$2e2bcd8739ae039);
function $dcf0bce2ddb683b1$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $dcf0bce2ddb683b1$export$2e2bcd8739ae039 = $dcf0bce2ddb683b1$var$getViewportHeight;

});

parcelRegister("d04AS", function(module, exports) {
$parcel$export(module.exports, "default", () => $65bebbfa92e3304c$export$2e2bcd8739ae039);
function $65bebbfa92e3304c$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $65bebbfa92e3304c$export$2e2bcd8739ae039 = $65bebbfa92e3304c$var$getViewportWidth;

});


parcelRegister("gGbro", function(module, exports) {
$parcel$export(module.exports, "isEntrySmartAnswersInSearch", () => $112db76e81fda865$export$8be86f3caab7d679);

var $aDtSj = parcelRequire("aDtSj");
function $112db76e81fda865$export$8be86f3caab7d679(entry) {
    const { elementName: elementName } = entry.data;
    if (!elementName || elementName === 'START') return false;
    const doc = (0, $aDtSj.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    const entryDOMElement = doc.querySelector(elementName);
    if (!entryDOMElement) return false;
    return smartAnswersElement.contains(entryDOMElement);
}

});
parcelRegister("aDtSj", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $d9bd1449e6727e00$export$f65ca476c09acec0);
const $d9bd1449e6727e00$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("6fOa5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4b65f216b050abd$export$2e2bcd8739ae039);
function $a4b65f216b050abd$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $a4b65f216b050abd$export$2e2bcd8739ae039 = $a4b65f216b050abd$var$isViewportEntryData;

});


parcelRegister("argxT", function(module, exports) {
$parcel$export(module.exports, "default", () => $266ab560fc48ca21$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $45NOU = parcelRequire("45NOU");
// NOTE: `next` to be renamed `fy26.04` once stable
const $266ab560fc48ca21$var$REVISION_NO = 'next';
const $266ab560fc48ca21$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    if ((0, $91hOG.fg)('platform_ufo_remove_ssr_placeholder_in_ttvc_v4')) consideredEntryTypes.push('mutation:ssr-placeholder');
    return [
        'mutation:display-contents-children-element'
    ];
};
const $266ab560fc48ca21$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect'
    ];
    return excludedEntryTypes;
};
class $266ab560fc48ca21$export$2e2bcd8739ae039 extends (0, $45NOU.default) {
    constructor(){
        super($266ab560fc48ca21$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p) {
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p);
        if (isEntryIncludedInV3 && !$266ab560fc48ca21$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $266ab560fc48ca21$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("1NCjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6586ec7579f696f7$export$2e2bcd8739ae039);

var $dvoU5 = parcelRequire("dvoU5");

var $d04AS = parcelRequire("d04AS");
const $6586ec7579f696f7$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $6586ec7579f696f7$var$MAX_OBSERVATIONS = 100;
class $6586ec7579f696f7$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($6586ec7579f696f7$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: -1,
            viewport: {
                w: (0, $d04AS.default)(),
                h: (0, $dvoU5.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const observation = {
                t: Math.round(entry.time),
                r: [
                    Math.round(rect.left * 10) / 10,
                    Math.round(rect.top * 10) / 10,
                    Math.round(rect.right * 10) / 10,
                    Math.round(rect.bottom * 10) / 10
                ],
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawObservations.length > $6586ec7579f696f7$var$MAX_OBSERVATIONS) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$6586ec7579f696f7$var$MAX_OBSERVATIONS);
            rawObservations = [
                firstObservation,
                ...lastObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            // Remove unreferenced entries from maps
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid)) delete elementMapEntriesMap[eid];
            for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
            for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
        }
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: rawObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: attributeEntriesMap ?? undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $d04AS.default)(),
                h: (0, $dvoU5.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("aBIbT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f13c7eadbd75123$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $iFBsm = parcelRequire("iFBsm");

var $cov2F = parcelRequire("cov2F");

var $eSgQw = parcelRequire("eSgQw");

var $k0v6Z = parcelRequire("k0v6Z");

var $4JLp9 = parcelRequire("4JLp9");

var $gkLsy = parcelRequire("gkLsy");

var $9vBPJ = parcelRequire("9vBPJ");

var $bduru = parcelRequire("bduru");

var $hgidE = parcelRequire("hgidE");

var $6a6ZM = parcelRequire("6a6ZM");

var $5iQ9Z = parcelRequire("5iQ9Z");

var $fy4fa = parcelRequire("fy4fa");

var $jOhx2 = parcelRequire("jOhx2");
const $6f13c7eadbd75123$var$createElementMutationsWatcher = (removedNodeRects)=>({ target: target, rect: rect })=>{
        const isInIgnoreLsMarker = (0, $5iQ9Z.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $k0v6Z.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $fy4fa.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $6f13c7eadbd75123$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $6a6ZM.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                for (const { isDisplayContentsElementChildren: isDisplayContentsElementChildren, element: element } of (0, $hgidE.getMutatedElements)(addedNode)){
                    // SSR hydration logic
                    if (this.getSSRState) {
                        const ssrState = this.getSSRState();
                        const SSRStateEnum = {
                            normal: 1,
                            waitingForFirstRender: 2,
                            ignoring: 3
                        };
                        if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement) {
                            ssrState.state = SSRStateEnum.ignoring;
                            if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                            ssrState.renderStop = timestamp + 500;
                            this.intersectionObserver?.watchAndTag(element, 'ssr-hydration');
                            continue;
                        }
                        if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement) {
                            if (timestamp <= ssrState.renderStop) {
                                this.intersectionObserver?.watchAndTag(element, 'ssr-hydration');
                                continue;
                            } else ssrState.state = SSRStateEnum.normal;
                        }
                    }
                    // SSR placeholder logic - check and handle with await
                    if (this.getSSRPlaceholderHandler) {
                        const ssrPlaceholderHandler = this.getSSRPlaceholderHandler();
                        if (ssrPlaceholderHandler) {
                            if (ssrPlaceholderHandler.isPlaceholder(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element)) {
                                if (ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(element)) {
                                    this.intersectionObserver?.watchAndTag(element, 'mutation:ssr-placeholder');
                                    continue;
                                }
                            }
                            if (ssrPlaceholderHandler.isPlaceholderReplacement(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element)) {
                                const result = await ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(element);
                                if (result !== false) {
                                    this.intersectionObserver?.watchAndTag(element, 'mutation:ssr-placeholder');
                                    continue;
                                }
                            // If result is false, continue to normal mutation logic below
                            }
                        }
                    }
                    const sameDeletedNode = removedNodes.find((ref)=>{
                        const n = ref.deref();
                        if (!n || !element) return false;
                        return n.isEqualNode(element);
                    });
                    const isInIgnoreLsMarker = element instanceof HTMLElement ? (0, $5iQ9Z.default)(element) : false;
                    if (sameDeletedNode && isInIgnoreLsMarker) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:remount');
                        continue;
                    }
                    if ((0, $iFBsm.isContainedWithinMediaWrapper)(element)) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:media');
                        continue;
                    }
                    const { isWithin: isWithinThirdPartySegment } = element instanceof HTMLElement ? (0, $bduru.default)(element, 'UFOThirdPartySegment', this.mapIs3pResult) : {
                        isWithin: false
                    };
                    if (isWithinThirdPartySegment) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:third-party-element');
                        continue;
                    }
                    if (isDisplayContentsElementChildren) this.intersectionObserver?.watchAndTag(element, 'mutation:display-contents-children-element');
                    else this.intersectionObserver?.watchAndTag(element, $6f13c7eadbd75123$var$createElementMutationsWatcher(removedNodeRects));
                }
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $iFBsm.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $91hOG.fg)('platform_ufo_exclude_3p_attribute_changes')) {
                    const { isWithin: isWithinThirdPartySegment } = (0, $bduru.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                    if (isWithinThirdPartySegment) return {
                        type: 'mutation:third-party-attribute',
                        mutationData: {
                            attributeName: attributeName,
                            oldValue: oldValue,
                            newValue: newValue
                        }
                    };
                }
                if ((0, $cov2F.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $eSgQw.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const isRLLPlaceholder = (0, $k0v6Z.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $jOhx2.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $fy4fa.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $4JLp9.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $gkLsy.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $9vBPJ.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $bduru.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("4JLp9", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $6d0c379277c99a0d$export$c3799d33e0ae80a5);
function $6d0c379277c99a0d$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $6d0c379277c99a0d$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$6d0c379277c99a0d$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});

parcelRegister("gkLsy", function(module, exports) {
$parcel$export(module.exports, "default", () => $cea81807d57d2f2d$export$2e2bcd8739ae039);

var $dNsNa = parcelRequire("dNsNa");
function $cea81807d57d2f2d$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $dNsNa.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $cea81807d57d2f2d$export$2e2bcd8739ae039 = $cea81807d57d2f2d$var$createMutationObserver;

});

parcelRegister("9vBPJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db799b521a3ef7e$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $9db799b521a3ef7e$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $9db799b521a3ef7e$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $9db799b521a3ef7e$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $9db799b521a3ef7e$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $9db799b521a3ef7e$export$2e2bcd8739ae039 = $9db799b521a3ef7e$var$createPerformanceObserver;

});

parcelRegister("bduru", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $4c10d0057278d70d$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $4c10d0057278d70d$export$2e2bcd8739ae039);

var $5rK25 = parcelRequire("5rK25");

var $efjka = parcelRequire("efjka");

var $k9IaA = parcelRequire("k9IaA");
const $4c10d0057278d70d$var$DEFAULT_MAX_LEVEL = 20;
// Cache cleanup
let $4c10d0057278d70d$var$callCount = 0;
const $4c10d0057278d70d$var$CLEANUP_THRESHOLD = 50;
function $4c10d0057278d70d$var$maybeCleanup(resultCache) {
    $4c10d0057278d70d$var$callCount++;
    if ($4c10d0057278d70d$var$callCount >= $4c10d0057278d70d$var$CLEANUP_THRESHOLD && (0, $5rK25.default)(0.3)) $4c10d0057278d70d$export$6a35c3789c327630(resultCache);
}
function $4c10d0057278d70d$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $4c10d0057278d70d$var$callCount = 0;
    return resultCache;
}
function $4c10d0057278d70d$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $4c10d0057278d70d$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    let fiber = null;
    let checkedNodes = [];
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $k9IaA.default)(node, $4c10d0057278d70d$var$DEFAULT_MAX_LEVEL, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $efjka.default)(fiber, targetComponentName, $4c10d0057278d70d$var$DEFAULT_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("efjka", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b98fe7a20da97a4$export$2e2bcd8739ae039);

var $d1DXn = parcelRequire("d1DXn");
function $8b98fe7a20da97a4$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $d1DXn.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $8b98fe7a20da97a4$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("d1DXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d98cf301475a0f4$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $4d98cf301475a0f4$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("k9IaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc655370b6cc5826$export$2e2bcd8739ae039);

var $2bTsa = parcelRequire("2bTsa");
function $fc655370b6cc5826$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    const fiber = (0, $2bTsa.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    const parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $fc655370b6cc5826$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("2bTsa", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc6b59acca7dba2d$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $fc6b59acca7dba2d$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("hgidE", function(module, exports) {
$parcel$export(module.exports, "getMutatedElements", () => $8c0287b2be114eec$export$c9ea137b0af90c5e);

var $91hOG = parcelRequire("91hOG");
const $8c0287b2be114eec$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED = 3;
function $8c0287b2be114eec$export$c9ea137b0af90c5e(element, depthLevel = 0) {
    if ((0, $91hOG.fg)('platform_ufo_disable_vcnext_observations')) return [
        {
            element: element,
            isDisplayContentsElementChildren: false
        }
    ];
    if (window?.getComputedStyle(element)?.display === 'contents') {
        const mutatedElements = [];
        const nestedDisplayContentsElementChildren = [];
        for (const child of element.children){
            if (window?.getComputedStyle(child)?.display === 'contents') nestedDisplayContentsElementChildren.push(child);
            mutatedElements.push({
                element: child,
                isDisplayContentsElementChildren: true
            });
        }
        if (depthLevel < $8c0287b2be114eec$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED && nestedDisplayContentsElementChildren.length > 0) return [
            ...mutatedElements,
            ...nestedDisplayContentsElementChildren.map((element)=>$8c0287b2be114eec$export$c9ea137b0af90c5e(element, depthLevel + 1)).flat()
        ];
        return mutatedElements;
    } else return [
        {
            element: element,
            isDisplayContentsElementChildren: false
        }
    ];
}

});

parcelRegister("6a6ZM", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $58d6c79117adbf2f$export$e989c0fffaa6b27a);
function $58d6c79117adbf2f$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("5iQ9Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $f61713ed6afe9fee$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $f61713ed6afe9fee$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $f61713ed6afe9fee$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("fy4fa", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $16ffc27c46ac8681$export$fde63bc968551821);
const $16ffc27c46ac8681$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $16ffc27c46ac8681$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $16ffc27c46ac8681$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $16ffc27c46ac8681$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $16ffc27c46ac8681$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $16ffc27c46ac8681$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("jOhx2", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $aaa2170a66bdf22b$export$597b41700f7dcd36);
const $aaa2170a66bdf22b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $aaa2170a66bdf22b$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $aaa2170a66bdf22b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $aaa2170a66bdf22b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("2jhmR", function(module, exports) {
$parcel$export(module.exports, "default", () => $980a72fb61291f0d$export$2e2bcd8739ae039);

var $4eDgu = parcelRequire("4eDgu");
class $980a72fb61291f0d$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $4eDgu.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("Rxmlu", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $6db4196521a48970$export$cc97b17ef9aeb088);
const $6db4196521a48970$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("dNF44", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8bc78071745b40b$export$2e2bcd8739ae039);

var $izJGy = parcelRequire("izJGy");

var $Rxmlu = parcelRequire("Rxmlu");

var $1bafC = parcelRequire("1bafC");
class $c8bc78071745b40b$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $izJGy.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $Rxmlu.interactions).get(interactionId);
        return interaction?.type === 'page_load' || interaction?.type === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if (interaction?.type === 'page_load' || interaction?.type === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $1bafC.remove)(id);
        this.reset();
    }
    reset() {
        this.stopVCObserver();
        if (this.finishedInteraction?.id) (0, $1bafC.remove)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $1bafC.remove)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        this.sinkHandlerFn = ()=>{};
    }
}

});

parcelRegister("9UwKs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1ee103d5d15e144$export$2e2bcd8739ae039);

var $91hOG = parcelRequire("91hOG");

var $6c1HM = parcelRequire("6c1HM");

var $f4UEC = parcelRequire("f4UEC");

var $izJGy = parcelRequire("izJGy");
const $e1ee103d5d15e144$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $e1ee103d5d15e144$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $izJGy.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
	 * Set the VC result as per the last interaction
	 * Used to compare diffs of VC updates vs post interaction VC observer
	 * @param result - VC result as calculated by UFO create payload
	 */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
	 * Set the fn that would be invoked to process / send the observation data
	 */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
	 * Reset state of the log
	 */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
	 * Check if there is data in the log
	 */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
	 * Send the log if there is data
	 */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn || !this.hasData() && !(0, $91hOG.fg)('platform_ufo_always_send_post_interaction_log')) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $f4UEC.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $6c1HM.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
	 * This fn should be invoked when an interaction has finished
	 * Basic details about the finished interaction will be recorded
	 * A timeout will be setup to send the post interaction observation after some time.
	 */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $6c1HM.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $e1ee103d5d15e144$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
	 * This fn should be invoked when a React render happens after interaction has finished
	 */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
	 * Basic info about interaction that has just finished
	 */ this.lastInteractionFinish = null;
        /**
	 * Array of observed react render timings
	 */ this.reactProfilerTimings = [];
        /**
	 * Store the scheduled sink timeout Id so that it can be cancelled when needed
	 */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
	 * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
	 */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
	 * Handler function to process / send the observation data
	 */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("7r4gK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba2daebb70834d18$export$2e2bcd8739ae039);
// import uuid from 'uuid/v4';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");

var $1fjtu = parcelRequire("1fjtu");

var $iyU3r = parcelRequire("iyU3r");
const $ba2daebb70834d18$var$packageVersion = "0.0.0-use.local";
const $ba2daebb70834d18$var$originParamName = 'atlOrigin';
const $ba2daebb70834d18$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$ba2daebb70834d18$var$packageVersion}`
};
class $ba2daebb70834d18$export$2e2bcd8739ae039 {
    constructor({ id: id = $ba2daebb70834d18$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $aXKmr.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $ba2daebb70834d18$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $ba2daebb70834d18$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $iyU3r.getEnv)()).URLSearchParams();
        $ba2daebb70834d18$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $iyU3r.getEnv)()).URLSearchParams(queryString);
        });
        return $ba2daebb70834d18$export$2e2bcd8739ae039.fromEncoded(params.get($ba2daebb70834d18$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $ba2daebb70834d18$export$2e2bcd8739ae039.createEmpty();
        try {
            return $ba2daebb70834d18$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $ba2daebb70834d18$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $ba2daebb70834d18$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $iyU3r.getEnv)()).URLSearchParams(queryString);
            params.delete($ba2daebb70834d18$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $1fjtu.decode)(encodedOrigin);
        return new $ba2daebb70834d18$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $1fjtu.encode)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $ba2daebb70834d18$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $iyU3r.getEnv)()).URLSearchParams(originalQueryString);
            params.set($ba2daebb70834d18$var$originParamName, this.encode());
            return params.toString();
        });
    }
    containsOrigin(urlString) {
        const url = new ((0, $iyU3r.getEnv)()).URL(urlString);
        const params = new URLSearchParams(url.search);
        return params.has($ba2daebb70834d18$var$originParamName);
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$ba2daebb70834d18$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$ba2daebb70834d18$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$ba2daebb70834d18$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
}
class $ba2daebb70834d18$var$EmptyOriginTracer extends $ba2daebb70834d18$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$ba2daebb70834d18$var$originVersioningAttributes
        };
    }
}
class $ba2daebb70834d18$var$MalformedOriginTracer extends $ba2daebb70834d18$export$2e2bcd8739ae039 {
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$ba2daebb70834d18$var$originVersioningAttributes
        };
    }
}
function $ba2daebb70834d18$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}

});
parcelRegister("1fjtu", function(module, exports) {
$parcel$export(module.exports, "encode", () => $6d39ee5adb2ba33d$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $6d39ee5adb2ba33d$export$2f872c0f2117be69);

var $23SMO = parcelRequire("23SMO");

var $iyU3r = parcelRequire("iyU3r");
const $6d39ee5adb2ba33d$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $6d39ee5adb2ba33d$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($6d39ee5adb2ba33d$export$4bc4b533a565aabe(originData));
    const base64 = (0, $iyU3r.getEnv)().btoa(json);
    return (0, $23SMO.base64ToBase64Url)(base64);
}
function $6d39ee5adb2ba33d$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $23SMO.base64UrlToBase64)(encodedOriginString);
    const json = (0, $iyU3r.getEnv)().atob(base64);
    return $6d39ee5adb2ba33d$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $6d39ee5adb2ba33d$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $6d39ee5adb2ba33d$var$productShorthands ? $6d39ee5adb2ba33d$var$productShorthands[product] : product
    };
}
function $6d39ee5adb2ba33d$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $6d39ee5adb2ba33d$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $6d39ee5adb2ba33d$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($6d39ee5adb2ba33d$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $6d39ee5adb2ba33d$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("23SMO", function(module, exports) {
$parcel$export(module.exports, "base64ToBase64Url", () => $dceb9ef9ff97ebe3$export$3b91e21dac1023c6);
$parcel$export(module.exports, "base64UrlToBase64", () => $dceb9ef9ff97ebe3$export$47c5265a25535d02);
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $dceb9ef9ff97ebe3$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $dceb9ef9ff97ebe3$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("iyU3r", function(module, exports) {
$parcel$export(module.exports, "getEnv", () => $666b28d88cf10008$export$4bd44a2aa29d3d6e);

var $5Ovjr = parcelRequire("5Ovjr");


const $666b28d88cf10008$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $5Ovjr.Buffer) !== 'undefined' && ((encoded)=>(0, $5Ovjr.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $5Ovjr.Buffer) !== 'undefined' && ((str)=>(0, $5Ovjr.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("KQtrs")).URLSearchParams),
        URL: typeof URL === 'function' && URL || (0, (parcelRequire("KQtrs")).URL)
    });
let $666b28d88cf10008$var$env;
const $666b28d88cf10008$export$4bd44a2aa29d3d6e = ()=>$666b28d88cf10008$var$env || ($666b28d88cf10008$var$env = $666b28d88cf10008$var$validateEnv($666b28d88cf10008$export$d3cd91e0fdbfdbc0()));
const $666b28d88cf10008$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};

});



parcelRegister("e3GLQ", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $8e7e888db449b1f3$export$89b3253ddfd2e6e8);

var $iRLyr = parcelRequire("iRLyr");

var $egJLu = parcelRequire("egJLu");
class $8e7e888db449b1f3$export$89b3253ddfd2e6e8 {
    /**
	 * @callback EventPredicate
	 * @param {object} event An analytics event
	 * @returns {boolean} A flag indicating whether or not the event matches the conditions
	 */ /**
	 * @callback CompressionFunction
	 * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
	 * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
	 */ /**
	 * This constructor defines a new rule for compressing analytics events.
	 * @param {EventPredicate} predicate
	 * @param {CompressionFunction} compressFn
	 */ constructor(predicate, compressFn){
        /**
	 * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
	 * @param event
	 * @returns {boolean}
	 */ this.canCompress = (event)=>{
            try {
                return event && (0, $iRLyr.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
	 * This function compresses as many events in the given collection as possible.<p>
	 * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
	 * appended to the end of the resulting array.
	 *
	 * @param events A collection of analytic events to compress
	 * @returns {Array.<Object>} The action fields for the resulting compressed events
	 */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $egJLu.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $iRLyr.validateActionEventType)(event.eventType);
                (0, $iRLyr.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("iRLyr", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $848c062848ac0725$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $848c062848ac0725$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $848c062848ac0725$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $848c062848ac0725$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $848c062848ac0725$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $848c062848ac0725$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $848c062848ac0725$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $848c062848ac0725$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $848c062848ac0725$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $848c062848ac0725$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $848c062848ac0725$export$801b46c35394d316);

var $3cYHF = parcelRequire("3cYHF");

var $doSPJ = parcelRequire("doSPJ");
const $848c062848ac0725$var$actionEventTypes = Object.freeze([
    (0, $3cYHF.eventType).OPERATIONAL,
    (0, $3cYHF.eventType).TRACK,
    (0, $3cYHF.eventType).UI
]);
function $848c062848ac0725$export$df8ff30e3c960006(container) {
    if (!(0, $doSPJ.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $848c062848ac0725$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$848c062848ac0725$export$df8ff30e3c960006(container));
}
function $848c062848ac0725$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $3cYHF.eventType).OPERATIONAL:
        case (0, $3cYHF.eventType).TRACK:
        case (0, $3cYHF.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $848c062848ac0725$export$4a8d7476662aebcc(type) {
    if (!$848c062848ac0725$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$848c062848ac0725$var$actionEventTypes}]`);
    return true;
}
function $848c062848ac0725$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $848c062848ac0725$export$e63ea5d8477971d3(event.containers);
}
function $848c062848ac0725$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $848c062848ac0725$export$8c014fd74b0c8b99(event) {
    $848c062848ac0725$export$e0c121325c66ed4c(event);
}
function $848c062848ac0725$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $848c062848ac0725$export$e5bac0930c812e90(event) {
    $848c062848ac0725$export$e0c121325c66ed4c(event);
}
function $848c062848ac0725$export$1e561554275607ef(event) {
    $848c062848ac0725$export$e0c121325c66ed4c(event);
}
function $848c062848ac0725$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $3cYHF.isType)((0, $3cYHF.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $3cYHF.objectValues)((0, $3cYHF.userType))}]`);
}
function $848c062848ac0725$export$801b46c35394d316(productInfo) {
    if (!(0, $3cYHF.isType)((0, $3cYHF.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $3cYHF.objectValues)((0, $3cYHF.platformType))}]`);
    if (productInfo.origin === (0, $3cYHF.originType).DESKTOP && !(0, $3cYHF.isType)((0, $3cYHF.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $3cYHF.originType).WEB && !(0, $3cYHF.isType)((0, $3cYHF.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});
parcelRegister("3cYHF", function(module, exports) {
$parcel$export(module.exports, "envType", () => $06f65b596c18d265$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $06f65b596c18d265$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $06f65b596c18d265$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $06f65b596c18d265$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $06f65b596c18d265$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $06f65b596c18d265$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $06f65b596c18d265$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $06f65b596c18d265$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $06f65b596c18d265$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $06f65b596c18d265$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $06f65b596c18d265$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $06f65b596c18d265$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $06f65b596c18d265$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $06f65b596c18d265$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $06f65b596c18d265$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $06f65b596c18d265$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $06f65b596c18d265$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $06f65b596c18d265$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $06f65b596c18d265$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $06f65b596c18d265$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $06f65b596c18d265$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $06f65b596c18d265$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $06f65b596c18d265$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $06f65b596c18d265$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $06f65b596c18d265$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $06f65b596c18d265$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $06f65b596c18d265$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $06f65b596c18d265$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $06f65b596c18d265$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $06f65b596c18d265$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $06f65b596c18d265$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $06f65b596c18d265$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $06f65b596c18d265$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("doSPJ", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $5efe530341da4b3f$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $5efe530341da4b3f$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $5efe530341da4b3f$var$isObjectObject(o) {
    return $5efe530341da4b3f$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $5efe530341da4b3f$export$53b83ca8eaab0383(o) {
    if ($5efe530341da4b3f$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($5efe530341da4b3f$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("egJLu", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $b7ea12e40cd49a85$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $b7ea12e40cd49a85$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $b7ea12e40cd49a85$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $b7ea12e40cd49a85$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $b7ea12e40cd49a85$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $b7ea12e40cd49a85$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $b7ea12e40cd49a85$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $b7ea12e40cd49a85$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $b7ea12e40cd49a85$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $b7ea12e40cd49a85$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $b7ea12e40cd49a85$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $b7ea12e40cd49a85$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $b7ea12e40cd49a85$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$b7ea12e40cd49a85$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $b7ea12e40cd49a85$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});


parcelRegister("f67Z8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce4ec68dac9d6b24$export$2e2bcd8739ae039);

var $3cYHF = parcelRequire("3cYHF");

var $aDskT = parcelRequire("aDskT");

var $9UCQZ = parcelRequire("9UCQZ");

var $6Nlr9 = parcelRequire("6Nlr9");

var $dHrXC = parcelRequire("dHrXC");

var $l3Mu7 = parcelRequire("l3Mu7");

var $3F0Nk = parcelRequire("3F0Nk");

var $iRLyr = parcelRequire("iRLyr");

var $57BvD = parcelRequire("57BvD");

var $36mTv = parcelRequire("36mTv");

var $l61Iw = parcelRequire("l61Iw");

var $3gXEp = parcelRequire("3gXEp");

var $capmA = parcelRequire("capmA");

var $5g5S2 = parcelRequire("5g5S2");

var $2WA8S = parcelRequire("2WA8S");

var $esU8m = parcelRequire("esU8m");

var $fStKR = parcelRequire("fStKR");

var $jbKHk = parcelRequire("jbKHk");

var $5QK0a = parcelRequire("5QK0a");

var $g2xf0 = parcelRequire("g2xf0");

var $hjBwJ = parcelRequire("hjBwJ");

var $9kZLF = parcelRequire("9kZLF");

var $2TH30 = parcelRequire("2TH30");
const $ce4ec68dac9d6b24$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $ce4ec68dac9d6b24$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $ce4ec68dac9d6b24$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $ce4ec68dac9d6b24$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $ce4ec68dac9d6b24$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $9UCQZ.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $9UCQZ.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($ce4ec68dac9d6b24$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($ce4ec68dac9d6b24$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($ce4ec68dac9d6b24$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $3cYHF.eventType).UI:
                case (0, $3cYHF.eventType).OPERATIONAL:
                case (0, $3cYHF.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $3cYHF.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $3cYHF.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
   * Calling this function in the intialisation of the client in product
   * captures specified 'origin tracing' URL params and fires a single origin landed event
   * <p>
   * This function expects a mapping between the keys for any URL parameters
   *  that should be captured and removed for origin tracing
   * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
   * Each handler function should return an object with two items
   * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
   * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
   *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
   * </p>
   * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
   * e.g. from a share or email
   *
   * An example calling this function using an external decoding library, with taskSessionId specified to persist
   * analyticsWebClient.setOriginTracingHandlers({
        atlOrigin: encodedOrigin => {
            const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
            return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
        },
    });
   *
   * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
   * @this {AnalyticsWebClient}
   */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $3cYHF.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $3cYHF.isType)((0, $3cYHF.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $3cYHF.objectValues)((0, $3cYHF.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $iRLyr.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $3cYHF.isType)((0, $3cYHF.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $3cYHF.objectValues)((0, $3cYHF.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $3cYHF.isType)((0, $3cYHF.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $3cYHF.objectValues)((0, $3cYHF.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $3cYHF.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
	 * @deprecated
	 * please use {@link sendScreenEvent instead)
	 */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
	 * send screen event
	 * @param event The event / For retrocompatibility event name is still supported here.
	 * @param callback
	 * @param attributes. Deprecated, will get ignored if using an event object as first param.
	 */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $iRLyr.validateScreenEvent)(screenName);
            (0, $iRLyr.validateContainers)(screenContainers);
            const builtEvent = (0, $l3Mu7.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $9kZLF.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $iRLyr.validateTrackEvent)(event);
            const builtEvent = (0, $l3Mu7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3cYHF.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $l3Mu7.buildActionName)(event), builtEvent, this._context, (0, $9kZLF.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $iRLyr.validateUIEvent)(event);
            const builtEvent = (0, $l3Mu7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3cYHF.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $l3Mu7.buildActionName)(event), builtEvent, this._context, (0, $9kZLF.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $iRLyr.validateOperationalEvent)(event);
            const builtEvent = (0, $l3Mu7.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $3cYHF.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $l3Mu7.buildActionName)(event), builtEvent, this._context, (0, $9kZLF.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $5QK0a.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $3cYHF.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3cYHF.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3cYHF.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $3cYHF.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $3cYHF.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $3cYHF.objectValues)((0, $3cYHF.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $3cYHF.isType)((0, $3cYHF.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $3cYHF.objectValues)((0, $3cYHF.envType))}]`);
        if (productInfo.perimeter && !(0, $3cYHF.isType)((0, $3cYHF.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $3cYHF.objectValues)((0, $3cYHF.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $3cYHF.originType).WEB;
        else if (!(0, $3cYHF.isType)((0, $3cYHF.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $3cYHF.objectValues)((0, $3cYHF.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $3cYHF.originType).WEB ? (0, $3cYHF.platformType).WEB : (0, $3cYHF.platformType).DESKTOP;
        else (0, $iRLyr.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $dHrXC.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $dHrXC.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $l3Mu7.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $2WA8S.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $capmA.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $2TH30.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $36mTv.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $57BvD.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $ce4ec68dac9d6b24$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $3gXEp.default)();
        this._tabTracking = new (0, $esU8m.default)();
        this._sessionTracking = new (0, $5g5S2.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $fStKR.default)();
        this._originTracing = new (0, $l61Iw.default)();
        // Init Apdex
        this._apdexEvent = new (0, $aDskT.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $g2xf0.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $3F0Nk.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $jbKHk.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = crypto.randomUUID();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $6Nlr9.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $hjBwJ.TestSupport).isGeminiVREnvironment() && !(0, $hjBwJ.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $hjBwJ.TestSupport).isGeminiVREnvironment() && !(0, $hjBwJ.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties. They are not part of the public
	 * API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get task() {
        return this._task;
    }
    /**
	 * @private
	 * @deprecated
	 * Please avoid using internal properties.
	 * They are not part of the public API and may change without notice.
	 *
	 * This property has been exposed for backward compatibility with existing
	 * tests in external code
	 */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("aDskT", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfcbe8a8bb2322a2$export$2e2bcd8739ae039);

var $3cYHF = parcelRequire("3cYHF");

var $3gXEp = parcelRequire("3gXEp");

var $gbOWJ = parcelRequire("gbOWJ");
class $cfcbe8a8bb2322a2$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $3cYHF.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
		 * For initialLoad type:
		 * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
		 *
		 * For transition type:
		 * 1. active status is tracked in active events map (_isActiveEvents)
		 *
		 * For any type, if startTime or stopTime is specified:
		 * 1. If currently active (!_isHidden)
		 */ if (event.type === (0, $3cYHF.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $3cYHF.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $3cYHF.isType)((0, $3cYHF.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
		 * For a transition, if the startTime was not specified,
		 * the start event should have been present.
		 */ if (!event.startTime && event.type === (0, $3cYHF.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $3gXEp.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $gbOWJ.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("3gXEp", function(module, exports) {
$parcel$export(module.exports, "default", () => $94941d9252c1e0da$export$2e2bcd8739ae039);
class $94941d9252c1e0da$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("gbOWJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $139cac6392f540d1$export$2e2bcd8739ae039);
class $139cac6392f540d1$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("9UCQZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7f18ab089621b07$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $d7f18ab089621b07$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $d7f18ab089621b07$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($d7f18ab089621b07$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("6Nlr9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9a262bd1fa6c77$export$2e2bcd8739ae039);

var $8dDqn = parcelRequire("8dDqn");
var $aTTl9 = parcelRequire("aTTl9");
var $26ziL = parcelRequire("26ziL");

var $91hOG = parcelRequire("91hOG");

var $3cYHF = parcelRequire("3cYHF");

var $g2xf0 = parcelRequire("g2xf0");
const $2e9a262bd1fa6c77$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $aTTl9.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $2e9a262bd1fa6c77$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = (0, $91hOG.fg)('analytics_cross_product_interaction_tracking') && options.perimeter !== (0, $3cYHF.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $26ziL.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $g2xf0.default)($2e9a262bd1fa6c77$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $aTTl9.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $aTTl9.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $8dDqn.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
	 * Validates the cross product interaction session parameters parsed from the URL (if present)
	 * If the Base64-encoded URL does not decode into a valid JSON object
	 *
	 * This method must be called out of the constructor, as the sendEventCallback we expect here
	 * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
	 */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
}

});
parcelRegister("8dDqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dbcbabcbc5b0f84$export$2e2bcd8739ae039);

var $7BW2i = parcelRequire("7BW2i");

var $91hOG = parcelRequire("91hOG");

var $dW9Qs = parcelRequire("dW9Qs");

var $ij6WI = parcelRequire("ij6WI");
const $5dbcbabcbc5b0f84$export$b9dd752fb13352ce = 'interactionSession.source';
const $5dbcbabcbc5b0f84$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $5dbcbabcbc5b0f84$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($5dbcbabcbc5b0f84$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($5dbcbabcbc5b0f84$export$b9dd752fb13352ce) : null;
        this.isEnabled = (0, $91hOG.fg)('analytics_cross_product_interaction_tracking') && !(0, $7BW2i.isFedrampModerate)();
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $dW9Qs.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $ij6WI.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($5dbcbabcbc5b0f84$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($5dbcbabcbc5b0f84$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("7BW2i", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $62553d54d33820fa$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $62553d54d33820fa$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $62553d54d33820fa$export$80638ee198476daf);
$parcel$export(module.exports, "cloudEnvironment", () => $62553d54d33820fa$export$9e04105551ffc5c4);

var $7uQfs = parcelRequire("7uQfs");

var $l24P1 = parcelRequire("l24P1");
function $62553d54d33820fa$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $l24P1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $7uQfs.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $62553d54d33820fa$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $l24P1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $7uQfs.FEDRAMP_MODERATE);
}
function $62553d54d33820fa$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    const atlCtxCookieValues = (0, $l24P1.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $62553d54d33820fa$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $62553d54d33820fa$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $l24P1.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}
function $62553d54d33820fa$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $62553d54d33820fa$var$cloudEnvironmentSsrLookup();
    return $62553d54d33820fa$var$cloudEnvironmentCookieLookup();
}
function $62553d54d33820fa$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $7uQfs.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $7uQfs.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $7uQfs.COMMERCIAL)
    };
}
function $62553d54d33820fa$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $l24P1.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $7uQfs.COMMERCIAL)
    };
    const isIc = (0, $7uQfs.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $7uQfs.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $7uQfs.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $7uQfs.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("7uQfs", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $43037b808df691a6$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $43037b808df691a6$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $43037b808df691a6$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $43037b808df691a6$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $43037b808df691a6$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $43037b808df691a6$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $43037b808df691a6$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $43037b808df691a6$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $43037b808df691a6$export$a0ffa0598c95dfb7);
const $43037b808df691a6$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $43037b808df691a6$export$f005e2e9f707cb5f = 'commercial';
const $43037b808df691a6$export$a739cd5aac835909 = 'staging';
const $43037b808df691a6$export$42dd0cdd351a4a9 = 'prod';
const $43037b808df691a6$export$404582bc18fe4d9e = 'dev';
const $43037b808df691a6$export$d8347b4aae768c2d = [
    $43037b808df691a6$export$f005e2e9f707cb5f
];
const $43037b808df691a6$export$b1b1ccc8f3e7f954 = [
    $43037b808df691a6$export$f005e2e9f707cb5f,
    $43037b808df691a6$export$ce553301d55c2fd8
];
const $43037b808df691a6$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $43037b808df691a6$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $43037b808df691a6$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("l24P1", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $d79913b627c2f1a1$export$3fa7b7af96286cc9);

var $7uQfs = parcelRequire("7uQfs");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $d79913b627c2f1a1$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $d79913b627c2f1a1$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $d79913b627c2f1a1$var$getRawCookieValue((0, $7uQfs.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $d79913b627c2f1a1$var$getRawCookieValue((0, $7uQfs.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $d79913b627c2f1a1$var$getRawCookieValue((0, $7uQfs.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("dW9Qs", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0fae2c8c9e4b53b$export$2e2bcd8739ae039);

var $f46Ze = parcelRequire("f46Ze");
const $b0fae2c8c9e4b53b$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $b0fae2c8c9e4b53b$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($b0fae2c8c9e4b53b$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$b0fae2c8c9e4b53b$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$b0fae2c8c9e4b53b$export$7bc189309d2ad463] = new (0, $f46Ze.default)();
                interactionSessionTracking = window[$b0fae2c8c9e4b53b$export$7bc189309d2ad463];
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`);
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("f46Ze", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $a2dd98bf8024dfc9$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $a2dd98bf8024dfc9$export$2e2bcd8739ae039);

var $ij6WI = parcelRequire("ij6WI");
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
const $a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $a2dd98bf8024dfc9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $a2dd98bf8024dfc9$export$285f6bddd927a06d = 1800000; // 30 minutes
const $a2dd98bf8024dfc9$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $a2dd98bf8024dfc9$export$a92e915d70316eb2 = 5000; // 5 seconds
const $a2dd98bf8024dfc9$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $a2dd98bf8024dfc9$var$INTEGER_REGEX = /^\d+$/;
const $a2dd98bf8024dfc9$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $a2dd98bf8024dfc9$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($a2dd98bf8024dfc9$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $a2dd98bf8024dfc9$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $a2dd98bf8024dfc9$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $a2dd98bf8024dfc9$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $ij6WI.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Error retrieving interaction session ID - ${err instanceof Error ? err.message : String(err)}`);
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($a2dd98bf8024dfc9$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $a2dd98bf8024dfc9$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $a2dd98bf8024dfc9$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
	 * This function retrieves the current session ID and expiry from SessionStorage
	 * It runs the necessary checks to ensure the session ID is valid and within expiry
	 *
	 * It returns the values along with a `validSession` boolean
	 */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($a2dd98bf8024dfc9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
	 * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
	 * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
	 *
	 * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
	 * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
	 *
	 * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
	 */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ]
        });
    }
}

});
parcelRegister("ij6WI", function(module, exports) {
$parcel$export(module.exports, "default", () => $69499d1fcd0d7368$export$2e2bcd8739ae039);

var $4PBJC = parcelRequire("4PBJC");

var $b4eyk = parcelRequire("b4eyk");
class $69499d1fcd0d7368$export$2e2bcd8739ae039 extends (0, $b4eyk.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $4PBJC.default);
        } catch (err) {
            storageToUse = (0, $4PBJC.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("4PBJC", function(module, exports) {
$parcel$export(module.exports, "default", () => $77007d564b328646$export$2e2bcd8739ae039);
class $77007d564b328646$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $77007d564b328646$var$inmemorystorage = new $77007d564b328646$export$90e3e001bcac59c7();
var $77007d564b328646$export$2e2bcd8739ae039 = $77007d564b328646$var$inmemorystorage;

});

parcelRegister("b4eyk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4e0b2afa5df43b2$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $4PBJC = parcelRequire("4PBJC");
const $e4e0b2afa5df43b2$export$41c06fdd37b7e9a5 = 'awc';
const $e4e0b2afa5df43b2$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $e4e0b2afa5df43b2$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $e4e0b2afa5df43b2$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $e4e0b2afa5df43b2$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $4PBJC.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($e4e0b2afa5df43b2$export$48c17662a6902497(window[$e4e0b2afa5df43b2$export$770aa8bc07b3de03])) inMemoryStorage = window[$e4e0b2afa5df43b2$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $4PBJC.default);
                if (!window[$e4e0b2afa5df43b2$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$e4e0b2afa5df43b2$export$770aa8bc07b3de03] = (0, $4PBJC.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($e4e0b2afa5df43b2$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($e4e0b2afa5df43b2$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("aTTl9", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $f23c5eac27e491d7$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $f23c5eac27e491d7$export$2e3999ec51334ffe);
const $f23c5eac27e491d7$export$81d16f1428ce0486 = 'xpis';
const $f23c5eac27e491d7$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    const urlObj = new URL(url);
    urlObj.searchParams.set($f23c5eac27e491d7$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

});

parcelRegister("26ziL", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $2097e980275610a2$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $2097e980275610a2$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("g2xf0", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $2445d9c6fdeed649$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $2445d9c6fdeed649$export$2e2bcd8739ae039);

var $5KkKW = parcelRequire("5KkKW");

var $egJLu = parcelRequire("egJLu");
const $2445d9c6fdeed649$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $2445d9c6fdeed649$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $2445d9c6fdeed649$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $5KkKW.parseUrl)(removedFragmentURL);
    const captureParams = (0, $egJLu.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $egJLu.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $5KkKW.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $2445d9c6fdeed649$export$2e2bcd8739ae039 = $2445d9c6fdeed649$var$urlParamExtractor;

});
parcelRegister("5KkKW", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $42f15956c26e9ed7$export$fac44ee5b035f737, (v) => $42f15956c26e9ed7$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $42f15956c26e9ed7$export$7a5253c0f62e0150, (v) => $42f15956c26e9ed7$export$7a5253c0f62e0150 = v);
var $42f15956c26e9ed7$export$f9380c9a627682d3;
var $42f15956c26e9ed7$export$98e6a39c04603d36;
var $42f15956c26e9ed7$export$fac44ee5b035f737;
var $42f15956c26e9ed7$export$7a5253c0f62e0150;
var $42f15956c26e9ed7$export$a8c1621ea79325d3;
var $42f15956c26e9ed7$export$357523c63a2253b9;
var $42f15956c26e9ed7$export$44c361b8ec72ef7f;
'use strict';

var $1JHoV = parcelRequire("1JHoV");

var $2iO0O = parcelRequire("2iO0O");

var $bhk36 = parcelRequire("bhk36");

var $a2hoO = parcelRequire("a2hoO");
const $42f15956c26e9ed7$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $42f15956c26e9ed7$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $42f15956c26e9ed7$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            '[',
                            $42f15956c26e9ed7$var$encode(index, options),
                            ']=',
                            $42f15956c26e9ed7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            '[]=',
                            $42f15956c26e9ed7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            ':list=',
                            $42f15956c26e9ed7$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $42f15956c26e9ed7$var$encode(key, options),
                                keyValueSep,
                                $42f15956c26e9ed7$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $42f15956c26e9ed7$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $42f15956c26e9ed7$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $42f15956c26e9ed7$var$encode(key, options),
                            '=',
                            $42f15956c26e9ed7$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $42f15956c26e9ed7$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $42f15956c26e9ed7$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $42f15956c26e9ed7$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$42f15956c26e9ed7$var$decode(item, options)) : value === null ? value : $42f15956c26e9ed7$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $42f15956c26e9ed7$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$42f15956c26e9ed7$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $42f15956c26e9ed7$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $42f15956c26e9ed7$var$encode(value, options) {
    if (options.encode) return options.strict ? $1JHoV(value) : encodeURIComponent(value);
    return value;
}
function $42f15956c26e9ed7$var$decode(value, options) {
    if (options.decode) return $2iO0O(value);
    return value;
}
function $42f15956c26e9ed7$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $42f15956c26e9ed7$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $42f15956c26e9ed7$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $42f15956c26e9ed7$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $42f15956c26e9ed7$var$extract(input) {
    input = $42f15956c26e9ed7$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $42f15956c26e9ed7$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $42f15956c26e9ed7$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $42f15956c26e9ed7$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $42f15956c26e9ed7$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $bhk36(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $42f15956c26e9ed7$var$decode(value, options);
        formatter($42f15956c26e9ed7$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $42f15956c26e9ed7$var$parseValue(value[k], options);
        else ret[key] = $42f15956c26e9ed7$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $42f15956c26e9ed7$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$42f15956c26e9ed7$export$f9380c9a627682d3 = $42f15956c26e9ed7$var$extract;
$42f15956c26e9ed7$export$98e6a39c04603d36 = $42f15956c26e9ed7$var$parse;
$42f15956c26e9ed7$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $42f15956c26e9ed7$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $42f15956c26e9ed7$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $42f15956c26e9ed7$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $42f15956c26e9ed7$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $42f15956c26e9ed7$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $42f15956c26e9ed7$var$encode(key, options) + '=' + $42f15956c26e9ed7$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$42f15956c26e9ed7$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $bhk36(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $42f15956c26e9ed7$var$parse($42f15956c26e9ed7$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $42f15956c26e9ed7$var$decode(hash, options)
    } : {});
};
$42f15956c26e9ed7$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$42f15956c26e9ed7$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $42f15956c26e9ed7$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $42f15956c26e9ed7$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $42f15956c26e9ed7$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $42f15956c26e9ed7$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $42f15956c26e9ed7$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$42f15956c26e9ed7$var$encodeFragmentIdentifier] ? $42f15956c26e9ed7$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$42f15956c26e9ed7$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$42f15956c26e9ed7$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $42f15956c26e9ed7$export$7a5253c0f62e0150(input, options);
    return $42f15956c26e9ed7$export$a8c1621ea79325d3({
        url: url,
        query: $a2hoO(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$42f15956c26e9ed7$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $42f15956c26e9ed7$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("dHrXC", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $49dedc8cb716f11a$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $49dedc8cb716f11a$export$ab34f90cc32c8960);

var $3cYHF = parcelRequire("3cYHF");
const $49dedc8cb716f11a$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $3cYHF.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $49dedc8cb716f11a$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $3cYHF.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("l3Mu7", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $3af651dab31a877e$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $3af651dab31a877e$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $3af651dab31a877e$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $3af651dab31a877e$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $3af651dab31a877e$export$7bf451af4a8e3dd9);

var $91hOG = parcelRequire("91hOG");

var $3cYHF = parcelRequire("3cYHF");

var $doSPJ = parcelRequire("doSPJ");
const $3af651dab31a877e$var$libraryVersion = "0.0.0-use.local";
function $3af651dab31a877e$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $3af651dab31a877e$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $3af651dab31a877e$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $3af651dab31a877e$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $3af651dab31a877e$var$buildAliases(aliases) {
    if ($3af651dab31a877e$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $3af651dab31a877e$var$buildGroups(groups) {
    if ($3af651dab31a877e$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $3af651dab31a877e$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $3af651dab31a877e$var$buildInteractionSession(properties) {
    // TODO: Once feature flag is removed this function can be removed and the property
    // directly added at the top level in the buildActionEvent and buildScreenEvent functions
    if ((0, $91hOG.fg)('analytics_cross_product_interaction_tracking')) return {
        interactionSession: properties
    };
    return undefined;
}
function $3af651dab31a877e$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $3af651dab31a877e$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $3af651dab31a877e$var$getProductField(productInfo.env, overrides.env);
    const product = $3af651dab31a877e$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $3af651dab31a877e$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $3af651dab31a877e$var$getProductField(productInfo.version, overrides.version);
    const origin = $3af651dab31a877e$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $3af651dab31a877e$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $3af651dab31a877e$var$isNotEmptyObject(obj) {
    return (0, $doSPJ.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $3af651dab31a877e$var$buildAttributesWithName(name, attrObject) {
    return $3af651dab31a877e$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $3af651dab31a877e$var$buildAttributes(attributes) {
    return $3af651dab31a877e$var$buildAttributesWithName('attributes', attributes);
}
function $3af651dab31a877e$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $3af651dab31a877e$export$f045f238d77c002a(containers) {
    if ($3af651dab31a877e$var$isNotEmptyObject(containers)) {
        const validContainers = $3af651dab31a877e$export$3f5115a568819c1a(containers);
        return $3af651dab31a877e$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $3af651dab31a877e$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$3af651dab31a877e$export$f045f238d77c002a(event.containers)
    };
}
function $3af651dab31a877e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $3af651dab31a877e$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $3af651dab31a877e$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $3af651dab31a877e$var$buildProductFields(productInfo);
    const tenantFields = $3af651dab31a877e$var$buildTenantFields(tenantInfo);
    const userFields = $3af651dab31a877e$var$buildUserFields(userInfo);
    const orgFields = $3af651dab31a877e$var$buildOrgFields(orgInfo);
    const workspaceFields = $3af651dab31a877e$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $3cYHF.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$3af651dab31a877e$var$buildAttributes(attributes),
        ...$3af651dab31a877e$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$3af651dab31a877e$export$f045f238d77c002a(containers),
        ...$3af651dab31a877e$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$3af651dab31a877e$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$3af651dab31a877e$var$buildAliases(aliases),
        ...$3af651dab31a877e$var$buildGroups(groups)
    };
}
function $3af651dab31a877e$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $3af651dab31a877e$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $3af651dab31a877e$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $3af651dab31a877e$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $3af651dab31a877e$var$libraryVersion
            },
            validationMode: $3af651dab31a877e$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $3af651dab31a877e$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $3af651dab31a877e$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $3af651dab31a877e$var$buildProductFields(productInfo, $3af651dab31a877e$export$e3d99b4bfec06f6e(event));
    const tenantFields = $3af651dab31a877e$var$buildTenantFields(tenantInfo);
    const orgFields = $3af651dab31a877e$var$buildOrgFields(orgInfo);
    const workspaceFields = $3af651dab31a877e$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $3af651dab31a877e$var$buildUserFields(userInfo);
    const actionFields = $3af651dab31a877e$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$3af651dab31a877e$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$3af651dab31a877e$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$3af651dab31a877e$var$buildAliases(aliases),
        ...$3af651dab31a877e$var$buildGroups(groups)
    };
}

});

parcelRegister("3F0Nk", function(module, exports) {
$parcel$export(module.exports, "default", () => $1590e6b44d2c9574$export$2e2bcd8739ae039);


var $kNPO6 = parcelRequire("kNPO6");

var $37a22 = parcelRequire("37a22");
class $1590e6b44d2c9574$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $07c351e56f78ee75$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $07c351e56f78ee75$export$8575e30be0feb909)) : (0, $07c351e56f78ee75$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $37a22.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $37a22.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $kNPO6.default)(fireDelayedEvent, compressors);
    }
}

});
const $07c351e56f78ee75$export$cf090d5281b5ae06 = 10000;
const $07c351e56f78ee75$export$8575e30be0feb909 = 30000;

parcelRegister("kNPO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11e583627f22fe4$export$2e2bcd8739ae039);

var $l3Mu7 = parcelRequire("l3Mu7");

var $egJLu = parcelRequire("egJLu");

var $463IU = parcelRequire("463IU");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $e11e583627f22fe4$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $e11e583627f22fe4$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $e11e583627f22fe4$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $e11e583627f22fe4$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $e11e583627f22fe4$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $egJLu.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $egJLu.equals)(group.userInfo, args.userInfo) && (0, $egJLu.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $l3Mu7.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $463IU.default)(compressionRules);
    }
}

});
parcelRegister("463IU", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dee478c9c55571b$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $l3Mu7 = parcelRequire("l3Mu7");

var $egJLu = parcelRequire("egJLu");

var $e3GLQ = parcelRequire("e3GLQ");
class $7dee478c9c55571b$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $l3Mu7.buildActionFields)(event, event.eventType);
                    contextFields = (0, $egJLu.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $egJLu.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $e3GLQ.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});


parcelRegister("37a22", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $3dccaba2de254b3b$export$fa6e3729c21cb8f);
var $3dccaba2de254b3b$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("57BvD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3fbbba3706dd1f7$export$2e2bcd8739ae039);

var $gCKZb = parcelRequire("gCKZb");

var $ipUsk = parcelRequire("ipUsk");

var $j21Ez = parcelRequire("j21Ez");

var $Yqz5C = parcelRequire("Yqz5C");

var $3LwH1 = parcelRequire("3LwH1");

var $ibHV1 = parcelRequire("ibHV1");

var $kYTKW = parcelRequire("kYTKW");

var $7MRLk = parcelRequire("7MRLk");

var $jNM7y = parcelRequire("jNM7y");
class $d3fbbba3706dd1f7$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $d3fbbba3706dd1f7$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $d3fbbba3706dd1f7$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $d3fbbba3706dd1f7$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $d3fbbba3706dd1f7$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $d3fbbba3706dd1f7$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $d3fbbba3706dd1f7$export$2e2bcd8739ae039 {
    constructor(options){
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $ibHV1.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $kYTKW.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $kYTKW.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $kYTKW.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $kYTKW.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $Yqz5C.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $7MRLk.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $ipUsk.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $gCKZb.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $kYTKW.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $kYTKW.SegmentEventTypes).TRACK,
            properties: (0, $jNM7y.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $kYTKW.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $kYTKW.SegmentEventTypes).PAGE,
            properties: (0, $jNM7y.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $kYTKW.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $kYTKW.SegmentEventTypes).IDENTIFY,
            traits: (0, $jNM7y.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $jNM7y.prepareEventProperties)(context);
        const segmentContext = (0, $jNM7y.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${crypto.randomUUID()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (error) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $d3fbbba3706dd1f7$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $d3fbbba3706dd1f7$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $d3fbbba3706dd1f7$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $j21Ez.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $d3fbbba3706dd1f7$var$BatchInterceptor {
    static{
        this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    }
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $d3fbbba3706dd1f7$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $d3fbbba3706dd1f7$export$133650fcdde1b226(success, statusCode, (0, $3LwH1.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $3LwH1.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $3LwH1.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $3LwH1.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $d3fbbba3706dd1f7$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d3fbbba3706dd1f7$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($d3fbbba3706dd1f7$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $d3fbbba3706dd1f7$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d3fbbba3706dd1f7$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $d3fbbba3706dd1f7$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $d3fbbba3706dd1f7$export$133650fcdde1b226(false, -1, (0, $3LwH1.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("gCKZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8466192a233cf5e$export$2e2bcd8739ae039);

var $brnGE = parcelRequire("brnGE");

var $b8466192a233cf5e$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $brnGE.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("brnGE", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $53792dcebf33197a$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $53792dcebf33197a$export$2e2bcd8739ae039);

var $33Cca = parcelRequire("33Cca");
var $frmkB = parcelRequire("frmkB");

var $9TAyj = parcelRequire("9TAyj");
var $7O5jm = parcelRequire("7O5jm");
var $8q3bf = parcelRequire("8q3bf");

var $ipUsk = parcelRequire("ipUsk");

var $lPEAS = parcelRequire("lPEAS");

var $f0Qks = parcelRequire("f0Qks");
var $1eksz = parcelRequire("1eksz");

var $iMKW4 = parcelRequire("iMKW4");
const $53792dcebf33197a$var$ONE_MINUTE = 60000;
const $53792dcebf33197a$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $53792dcebf33197a$var$ONE_MINUTE,
    minRetryDelay: $53792dcebf33197a$var$ONE_MINUTE,
    maxRetryDelay: $53792dcebf33197a$var$ONE_MINUTE
};
const $53792dcebf33197a$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $53792dcebf33197a$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $7O5jm.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $f0Qks.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $f0Qks.default)({
            ...$53792dcebf33197a$var$LONG_POLLING_OPTIONS,
            waitInterval: $53792dcebf33197a$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $ipUsk.default)();
        this.networkStatus = new (0, $lPEAS.default)((status)=>{
            if (status === (0, $iMKW4.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $8q3bf.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $iMKW4.NetworkStatusEnum).OFFLINE) {
            done((0, $1eksz.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $9TAyj.CallbackProcessingErrorName)) {
                done((0, $1eksz.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $33Cca.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $frmkB.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $8q3bf.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $1eksz.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $1eksz.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $1eksz.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $53792dcebf33197a$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $53792dcebf33197a$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $53792dcebf33197a$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $53792dcebf33197a$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $53792dcebf33197a$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $53792dcebf33197a$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $53792dcebf33197a$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $53792dcebf33197a$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $53792dcebf33197a$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("33Cca", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e8f8913d5cb8547$export$2e2bcd8739ae039);

var $5val4 = parcelRequire("5val4");

var $8iTsq = parcelRequire("8iTsq");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $4e8f8913d5cb8547$var$validSuffixs = Object.values((0, $5val4.LocalStorageKeySuffix));
var $4e8f8913d5cb8547$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $4e8f8913d5cb8547$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $5val4.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $8iTsq.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("5val4", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $9446f0d05b752451$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $9446f0d05b752451$export$8bb2c1fb2b1765a9);
var $9446f0d05b752451$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $9446f0d05b752451$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("8iTsq", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $7622cab4908ffd22$export$8433d54f767cbec5);

var $5val4 = parcelRequire("5val4");
const $7622cab4908ffd22$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $5val4.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $5val4.LocalStorageKeySuffix).ACK}`,
        [(0, $5val4.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $5val4.LocalStorageKeySuffix).QUEUE}`,
        [(0, $5val4.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $5val4.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $5val4.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $5val4.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $5val4.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $5val4.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("frmkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbad9e56d0ea2a27$export$2e2bcd8739ae039);

var $5val4 = parcelRequire("5val4");

var $8iTsq = parcelRequire("8iTsq");
const $dbad9e56d0ea2a27$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $dbad9e56d0ea2a27$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $5val4.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $5val4.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $dbad9e56d0ea2a27$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $dbad9e56d0ea2a27$var$promisedSetTimeout((0, $5val4.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $5val4.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $dbad9e56d0ea2a27$var$promisedSetTimeout((0, $5val4.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $5val4.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $dbad9e56d0ea2a27$var$reclaim(options, callback);
};
const $dbad9e56d0ea2a27$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $dbad9e56d0ea2a27$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $dbad9e56d0ea2a27$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $dbad9e56d0ea2a27$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $dbad9e56d0ea2a27$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = crypto.randomUUID();
    const queuesToReclaim = $dbad9e56d0ea2a27$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$dbad9e56d0ea2a27$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $8iTsq.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("9TAyj", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $396df140b2342705$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $396df140b2342705$export$2e2bcd8739ae039);
const $396df140b2342705$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $396df140b2342705$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $396df140b2342705$export$2e2bcd8739ae039.prototype);
        this.name = $396df140b2342705$export$a409c8de90e11e14;
    }
}

});

parcelRegister("7O5jm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cb9adf81748c37a$export$2e2bcd8739ae039);

var $gvoa7 = parcelRequire("gvoa7");

var $8q3bf = parcelRequire("8q3bf");

var $9TAyj = parcelRequire("9TAyj");
var $3cb9adf81748c37a$export$2e2bcd8739ae039 = (0, $gvoa7.default);

});
parcelRegister("gvoa7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a22209269f45d02$export$2e2bcd8739ae039);

var $8q3bf = parcelRequire("8q3bf");

var $3VhfY = parcelRequire("3VhfY");
var $iV2si = parcelRequire("iV2si");

var $gNku0 = parcelRequire("gNku0");

var $iZd2n = parcelRequire("iZd2n");

var $7cEkl = parcelRequire("7cEkl");
class $2a22209269f45d02$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $7cEkl.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $gNku0.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $3VhfY.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $iZd2n.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $iV2si.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $8q3bf.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $iZd2n.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $8q3bf.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("8q3bf", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $c525ee0f12008eb0$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $c525ee0f12008eb0$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $c525ee0f12008eb0$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $c525ee0f12008eb0$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $c525ee0f12008eb0$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $c525ee0f12008eb0$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $c525ee0f12008eb0$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $c525ee0f12008eb0$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $c525ee0f12008eb0$export$7710d69e6f450f20);
const $c525ee0f12008eb0$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $c525ee0f12008eb0$export$8cad224051643259 = 'analytics-web-client';
const $c525ee0f12008eb0$export$3d8420be07b276ab = 'analytics-resilience';
const $c525ee0f12008eb0$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $c525ee0f12008eb0$export$89d9c1ff8ac91862 = 'timeAdded';
const $c525ee0f12008eb0$export$a37d385bcd713809 = 'retryAttempts';
const $c525ee0f12008eb0$export$6d8635fed0e4b14d = 15000;
var $c525ee0f12008eb0$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $c525ee0f12008eb0$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("3VhfY", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c38afdafc1f50df$export$2e2bcd8739ae039);
const $2c38afdafc1f50df$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $2c38afdafc1f50df$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2c38afdafc1f50df$export$2e2bcd8739ae039.prototype);
        this.name = $2c38afdafc1f50df$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("iV2si", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $72eef78cfa780686$export$74101021e0969375);

var $apDaY = parcelRequire("apDaY");

var $9TAyj = parcelRequire("9TAyj");

var $hdHiM = parcelRequire("hdHiM");
const $72eef78cfa780686$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $apDaY.AbandonWriteErrorName) || errorWithName.name === (0, $9TAyj.CallbackProcessingErrorName) || errorWithName.name === (0, $hdHiM.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("apDaY", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $28bd781346cd8ad2$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $28bd781346cd8ad2$export$2e2bcd8739ae039);
const $28bd781346cd8ad2$export$ba95206613c96b28 = 'AbandonWriteError';
class $28bd781346cd8ad2$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $28bd781346cd8ad2$export$2e2bcd8739ae039.prototype);
        this.name = $28bd781346cd8ad2$export$ba95206613c96b28;
    }
}

});

parcelRegister("hdHiM", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $11b14e0d3bb548eb$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $11b14e0d3bb548eb$export$2e2bcd8739ae039);
const $11b14e0d3bb548eb$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $11b14e0d3bb548eb$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $11b14e0d3bb548eb$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("gNku0", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ec22149c2ace88$export$2e2bcd8739ae039);

var $8q3bf = parcelRequire("8q3bf");

var $eXtR6 = parcelRequire("eXtR6");

var $9TAyj = parcelRequire("9TAyj");
var $hdHiM = parcelRequire("hdHiM");
var $3VhfY = parcelRequire("3VhfY");
var $iV2si = parcelRequire("iV2si");

var $lRy7I = parcelRequire("lRy7I");

var $7cEkl = parcelRequire("7cEkl");
class $72ec22149c2ace88$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $3VhfY.default)());
                    }, (0, $8q3bf.INDEXEDDB_TIMEOUT));
                    /*
				 * The database version number can never change.
				 * An upgrade transaction is limited to only one connection to the database.
				 * Once this is done, we cannot open any connections with older versions of the schema.
				 * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
				 *
				 * Due to the nature of how AWC is used (multiple tabs that are very long lived),
				 * we will not be able to run version upgrades via indexeddb.
				 *
				 * This does not mean we cant change what is stored in the tables,
				 * this limitation just prevents us from:
				 *   - Creating new ObjectStores in this database connection, and
				 *   - Creating new indexes on our ObjectStores
				 *
				 * Any upgrades we wish to run in the future will have to create a new database,
				 * and migrate all the data from older databases.
				 *
				 * This also means any migrations we make will have to be supported until we have evidence
				 * that no events are coming from old versions of the database.
				 * This may take a long time.
				 */ const request = window.indexedDB.open((0, $8q3bf.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $8q3bf.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $8q3bf.TIME_TO_PROCESS_AFTER_INDEX), (0, $8q3bf.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $8q3bf.RETRY_INDEX), (0, $8q3bf.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $8q3bf.TIME_ADDED_INDEX), (0, $8q3bf.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $8q3bf.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $3VhfY.default)());
                    };
                    try {
                        await (0, $7cEkl.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $3VhfY.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $3VhfY.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $8q3bf.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $7cEkl.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $8q3bf.GuardPolicy).IGNORE) throw new (0, $hdHiM.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $iV2si.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $8q3bf.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $7cEkl.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $iV2si.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $eXtR6.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $eXtR6.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $8q3bf.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $eXtR6.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $7cEkl.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $7cEkl.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $7cEkl.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $7cEkl.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $8q3bf.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $7cEkl.requestToPromise)(request);
            await (0, $7cEkl.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $eXtR6.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $9TAyj.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $7cEkl.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $8q3bf.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $8q3bf.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $7cEkl.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $3VhfY.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
		 *
		 * This class will enforce the number of analytics events we can store in our IndexedDB object store
		 * if asked before adding items to the object store.
		 */ this.globalEventLimitGuard = new (0, $lRy7I.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $8q3bf.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("eXtR6", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $4600b0e1aedc496f$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $4600b0e1aedc496f$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $4600b0e1aedc496f$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $4600b0e1aedc496f$export$1188664dfff364c8);
const $4600b0e1aedc496f$export$b6df3d334cec060f = 7;
const $4600b0e1aedc496f$export$14ef152a03a4b6ee = 60000;
const $4600b0e1aedc496f$export$da9ab7b2fd5998e8 = 10;
const $4600b0e1aedc496f$export$1188664dfff364c8 = 5000;

});

parcelRegister("lRy7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $4440524294a1f10d$export$2e2bcd8739ae039);

var $8q3bf = parcelRequire("8q3bf");

var $apDaY = parcelRequire("apDaY");

var $7cEkl = parcelRequire("7cEkl");
class $4440524294a1f10d$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
	 * This query fetches the oldest events currently stored in AWC IndexedDb object store
	 * and deletes them sequentially
	 */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $8q3bf.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $7cEkl.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
	 * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
	 *
	 * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ async insertItems(objectStore, items, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $8q3bf.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $8q3bf.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $8q3bf.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $7cEkl.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $7cEkl.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $apDaY.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
	 * This query returns the count of items held in AWC IndexedDB object store per product.
	 */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $8q3bf.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $7cEkl.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("7cEkl", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $caf4f7708f88397b$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $caf4f7708f88397b$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $caf4f7708f88397b$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $caf4f7708f88397b$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $caf4f7708f88397b$export$342d941b6f724995);

var $eXtR6 = parcelRequire("eXtR6");
const $caf4f7708f88397b$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || crypto.randomUUID(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $caf4f7708f88397b$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $eXtR6.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $eXtR6.EVENT_COUNT_LIMIT)
    });
const $caf4f7708f88397b$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $caf4f7708f88397b$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $caf4f7708f88397b$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $caf4f7708f88397b$export$2a5213bce1720b42(transaction);
};
const $caf4f7708f88397b$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("iZd2n", function(module, exports) {
$parcel$export(module.exports, "default", () => $a97be6fff4d39104$export$2e2bcd8739ae039);

var $8q3bf = parcelRequire("8q3bf");

var $eXtR6 = parcelRequire("eXtR6");

var $9TAyj = parcelRequire("9TAyj");
var $hdHiM = parcelRequire("hdHiM");

var $2aEB8 = parcelRequire("2aEB8");

var $7cEkl = parcelRequire("7cEkl");
class $a97be6fff4d39104$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $7cEkl.createOptionsWithDefaults)(options);
        /**
		 * This class will enforce the number of analytics events we can store in our MemoryDb
		 */ this.globalEventLimitGuard = new (0, $2aEB8.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
	 * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
	 * to removes oldest events when limit is reached.
	 */ async addItem(item, options = {}, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        if (policy === (0, $8q3bf.GuardPolicy).IGNORE) throw new (0, $hdHiM.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $7cEkl.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $7cEkl.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
	 * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
	 */ bulkAddItemWrapperType(items, policy = (0, $8q3bf.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $eXtR6.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $eXtR6.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $eXtR6.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $eXtR6.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $9TAyj.default)(error);
        }
    }
    storeType() {
        return (0, $8q3bf.StoreType).MEMORY;
    }
    /**
	 * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
	 * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
	 * memoryStore much faster.
	 *
	 * @param itemsToAdd
	 */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
	 * This function checks the number of events currently in AWC MemoryDb and if necessary,
	 * will evict the oldest events in favour of the events we want to add.
	 *
	 * @param countOfEventsToAdd - The number of events we are proposing to add.
	 */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("2aEB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d801cdc06755a9a$export$2e2bcd8739ae039);

var $8q3bf = parcelRequire("8q3bf");

var $apDaY = parcelRequire("apDaY");
class $9d801cdc06755a9a$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
	 * Unlike IndexedDb, we cannot take advantage of any index. So we are,
	 * treating the memory store as a sorted set when adding items.
	 */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $8q3bf.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $8q3bf.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $8q3bf.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $apDaY.default)((0, $8q3bf.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("ipUsk", function(module, exports) {
$parcel$export(module.exports, "default", () => $99166d2567c46f68$export$2e2bcd8739ae039);

var $iMKW4 = parcelRequire("iMKW4");
class $99166d2567c46f68$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $iMKW4.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $99166d2567c46f68$var$cachedMetricsClient = null;
var $99166d2567c46f68$export$2e2bcd8739ae039 = ()=>{
    if (!$99166d2567c46f68$var$cachedMetricsClient) $99166d2567c46f68$var$cachedMetricsClient = new $99166d2567c46f68$export$4b62ee5120ab50a8();
    return $99166d2567c46f68$var$cachedMetricsClient;
};

});
parcelRegister("iMKW4", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $52aac7412e4ef7c5$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $52aac7412e4ef7c5$export$ee138fa712d11b84);
var $52aac7412e4ef7c5$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $52aac7412e4ef7c5$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("lPEAS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5a92ded9633da28$export$2e2bcd8739ae039);

var $iMKW4 = parcelRequire("iMKW4");
class $d5a92ded9633da28$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iMKW4.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iMKW4.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $iMKW4.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $iMKW4.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $iMKW4.NetworkStatusEnum).ONLINE;
        return (0, $iMKW4.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("f0Qks", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76c0c969638cef6$export$2e2bcd8739ae039);

var $a3vjn = parcelRequire("a3vjn");

var $1eksz = parcelRequire("1eksz");
const $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $c76c0c969638cef6$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $c76c0c969638cef6$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $1eksz.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $1eksz.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $a3vjn.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $1eksz.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $c76c0c969638cef6$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $a3vjn.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("a3vjn", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $17eda9bf33cbac2c$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $17eda9bf33cbac2c$export$590a718599f8f8b3);
var $17eda9bf33cbac2c$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $17eda9bf33cbac2c$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $17eda9bf33cbac2c$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("1eksz", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $65df5164066a287a$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $65df5164066a287a$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("j21Ez", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $322f3cbdabd1102e$export$c21270cab66ab290);

var $kYTKW = parcelRequire("kYTKW");
function $322f3cbdabd1102e$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $kYTKW.SegmentEventTypes).PAGE || item.msg.type === (0, $kYTKW.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $kYTKW.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $322f3cbdabd1102e$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$322f3cbdabd1102e$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("kYTKW", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $37d72d31f9d36b8b$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $37d72d31f9d36b8b$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $37d72d31f9d36b8b$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $37d72d31f9d36b8b$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $37d72d31f9d36b8b$export$96f086dcf574a9e2);
class $37d72d31f9d36b8b$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $37d72d31f9d36b8b$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $37d72d31f9d36b8b$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $37d72d31f9d36b8b$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $37d72d31f9d36b8b$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $37d72d31f9d36b8b$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $37d72d31f9d36b8b$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
}
class $37d72d31f9d36b8b$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $37d72d31f9d36b8b$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("Yqz5C", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $799a8a8703f4abd1$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $799a8a8703f4abd1$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $799a8a8703f4abd1$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $799a8a8703f4abd1$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $799a8a8703f4abd1$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $799a8a8703f4abd1$export$6f1c008dd0c3b67e);
const $799a8a8703f4abd1$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $799a8a8703f4abd1$export$8fddcd1eff390364 = 60000; // 60 seconds
const $799a8a8703f4abd1$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $799a8a8703f4abd1$export$6649d5c857717efe = 5000; // 5 seconds
const $799a8a8703f4abd1$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $799a8a8703f4abd1$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("3LwH1", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $ba63e922ca769a8e$export$ba118f9de1e5ac63);
const $ba63e922ca769a8e$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("ibHV1", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $7fdd8f0385b08675$export$8e8f0180c1b41fad);

var $LFmXM = parcelRequire("LFmXM");

var $kYTKW = parcelRequire("kYTKW");
const $7fdd8f0385b08675$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $7fdd8f0385b08675$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $7fdd8f0385b08675$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $kYTKW.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $7fdd8f0385b08675$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $7fdd8f0385b08675$var$getCorsForUrl = (0, $LFmXM.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});

parcelRegister("7MRLk", function(module, exports) {
$parcel$export(module.exports, "default", () => $17ede8ba37c749a2$export$2e2bcd8739ae039);

var $lw3Pj = parcelRequire("lw3Pj");

var $dGck7 = parcelRequire("dGck7");
var $l8RAv = parcelRequire("l8RAv");

var $gOavb = parcelRequire("gOavb");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $17ede8ba37c749a2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $17ede8ba37c749a2$var$SAFE = 'SAFE';
const $17ede8ba37c749a2$var$UNSAFE = 'UNSAFE';
const $17ede8ba37c749a2$var$NOT_FOUND = 'NOT_FOUND';
const $17ede8ba37c749a2$var$COOKIE = 'COOKIE';
const $17ede8ba37c749a2$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $17ede8ba37c749a2$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $gOavb.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $l8RAv.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
		 * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
		 * If not set in localStorage, check cookies. Also set localStorage for future attempts.
		 * If not in cookies, generate a new one. Set both cookie and localStorage keys.
		 */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $dGck7.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $dGck7.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $17ede8ba37c749a2$var$LOCAL_STORAGE ? this.store.getItem((0, $dGck7.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $dGck7.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $17ede8ba37c749a2$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $17ede8ba37c749a2$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
				 * Segments new Analytics-next client will store strings as strings without stringifing.
				 * The legacy Segment client and AWC always stringify and parse cookies and values.
				 * If the new Segment analytics-client stores a cookie and local storage value first, it will
				 * breaking old clients.
				 *
				 * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
				 *
				 * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
				 */ return unsafeValue;
            }
        }
        return {
            type: $17ede8ba37c749a2$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($17ede8ba37c749a2$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $lw3Pj.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $17ede8ba37c749a2$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $17ede8ba37c749a2$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $17ede8ba37c749a2$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $17ede8ba37c749a2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($17ede8ba37c749a2$var$COOKIE);
        switch(cookieValue.type){
            case $17ede8ba37c749a2$var$SAFE:
            case $17ede8ba37c749a2$var$UNSAFE:
                this.store.setItem((0, $dGck7.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $17ede8ba37c749a2$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return crypto.randomUUID();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("dGck7", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $687a368677b6ee69$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $687a368677b6ee69$export$d4cb17942ea57c95);
var $687a368677b6ee69$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $687a368677b6ee69$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $687a368677b6ee69$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $687a368677b6ee69$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $687a368677b6ee69$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $687a368677b6ee69$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $687a368677b6ee69$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $687a368677b6ee69$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $687a368677b6ee69$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $687a368677b6ee69$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("l8RAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8d29c84e5e33ec4$export$2e2bcd8739ae039);

var $5H4WP = parcelRequire("5H4WP");

var $dGck7 = parcelRequire("dGck7");

var $7EMDB = parcelRequire("7EMDB");

var $12on9 = parcelRequire("12on9");
class $d8d29c84e5e33ec4$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $12on9.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))) : new (0, $7EMDB.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $dGck7.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $dGck7.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $dGck7.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $12on9.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $dGck7.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $dGck7.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $dGck7.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $dGck7.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("7EMDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $391e1ef3dee24a9e$export$2e2bcd8739ae039);

var $gOavb = parcelRequire("gOavb");
class $391e1ef3dee24a9e$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $gOavb.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("gOavb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bc01aca8d58a14d$export$2e2bcd8739ae039);

var $cJTvQ = parcelRequire("cJTvQ");

var $jnGZ0 = parcelRequire("jnGZ0");
class $0bc01aca8d58a14d$export$2e2bcd8739ae039 extends (0, $jnGZ0.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $cJTvQ.default);
        } catch (err) {
            storageToUse = (0, $cJTvQ.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("cJTvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7d1ca267f2e1598$export$2e2bcd8739ae039);
class $b7d1ca267f2e1598$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $b7d1ca267f2e1598$var$inmemorystorage = new $b7d1ca267f2e1598$export$90e3e001bcac59c7();
var $b7d1ca267f2e1598$export$2e2bcd8739ae039 = $b7d1ca267f2e1598$var$inmemorystorage;

});

parcelRegister("jnGZ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b83f398d01123804$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $3cYHF = parcelRequire("3cYHF");

var $cJTvQ = parcelRequire("cJTvQ");
const $b83f398d01123804$export$41c06fdd37b7e9a5 = 'awc';
const $b83f398d01123804$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $b83f398d01123804$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $b83f398d01123804$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $cJTvQ.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($b83f398d01123804$export$48c17662a6902497(window[$b83f398d01123804$export$770aa8bc07b3de03])) inMemoryStorage = window[$b83f398d01123804$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $cJTvQ.default);
                if (!window[$b83f398d01123804$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$b83f398d01123804$export$770aa8bc07b3de03] = (0, $cJTvQ.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($b83f398d01123804$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $3cYHF.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($b83f398d01123804$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("12on9", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $d916c1579301b304$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $d916c1579301b304$export$de6821eed3d5f32d);

var $5H4WP = parcelRequire("5H4WP");

var $LFmXM = parcelRequire("LFmXM");

var $dGck7 = parcelRequire("dGck7");
const $d916c1579301b304$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $d916c1579301b304$export$eb80e1beaa8dacf8 = (0, $dGck7.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $d916c1579301b304$export$19164982d36535d8 = 'tld_test';
const $d916c1579301b304$export$de6821eed3d5f32d = (0, $LFmXM.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).set($d916c1579301b304$export$eb80e1beaa8dacf8, $d916c1579301b304$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get($d916c1579301b304$export$eb80e1beaa8dacf8) === $d916c1579301b304$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove($d916c1579301b304$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("jNM7y", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $fdcddd29c440c4bd$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $fdcddd29c440c4bd$export$44d22e5fb02cc68e);
// @ts-ignore

var $2Ow0n = parcelRequire("2Ow0n");
const $fdcddd29c440c4bd$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $fdcddd29c440c4bd$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $fdcddd29c440c4bd$var$nestedRemoveUndefinedValues(properties, '$.properties');
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Ow0n)))(propertiesWithoutUndefined);
};
// This function will essentially deepClone as well
const $fdcddd29c440c4bd$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});


parcelRegister("36mTv", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $fd7443052474882d$export$1ac223ae496131c9);

var $lPEAS = parcelRequire("lPEAS");

var $brnGE = parcelRequire("brnGE");

var $f0Qks = parcelRequire("f0Qks");
var $1eksz = parcelRequire("1eksz");

var $iMKW4 = parcelRequire("iMKW4");

var $capmA = parcelRequire("capmA");

var $hjBwJ = parcelRequire("hjBwJ");

var $Yqz5C = parcelRequire("Yqz5C");

var $15ZaT = parcelRequire("15ZaT");

var $kYTKW = parcelRequire("kYTKW");
class $fd7443052474882d$export$1ac223ae496131c9 {
    static{
        this.INITIAL_REFRESH_DELAY = 1;
    }
    static{
        this.Factory = (apiHostProtocol, apiHost, product)=>{
            return new $fd7443052474882d$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $capmA.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            minRetryDelay: (0, $Yqz5C.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $Yqz5C.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $f0Qks.default)({
            ...this._options,
            waitInterval: (0, $Yqz5C.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
	 * Starts the metadata client. This will start the scheduler and begin
	 * fetching metadata.
	 *
	 * @param allowRestart - If false, the client will not be restarted if it has already been stopped
	 *						 by a call to stop().
	 */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $fd7443052474882d$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $lPEAS.default)((status)=>{
            if (status === (0, $iMKW4.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $hjBwJ.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $15ZaT.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $Yqz5C.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $kYTKW.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $kYTKW.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $kYTKW.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $iMKW4.NetworkStatusEnum).OFFLINE) {
            done((0, $1eksz.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $1eksz.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $1eksz.DoneState).ERROR);
        }
    }
    /**
	 * Schedules a refresh of the metadata when the user or tenant info changes. There is
	 * a short delay to allow for multiple changes to be batched together, such as when the
	 * callers sets the user info and tenant info in quick succession.
	 */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $Yqz5C.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $brnGE.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $brnGE.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $brnGE.DEFAULT_POLLING_OPTIONS).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $brnGE.DEFAULT_POLLING_OPTIONS).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $brnGE.DEFAULT_POLLING_OPTIONS).flushWaitMs,
            maxItems: options?.maxItems || (0, $brnGE.DEFAULT_POLLING_OPTIONS).maxItems,
            maxAttempts: options?.maxAttempts || (0, $brnGE.DEFAULT_POLLING_OPTIONS).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $brnGE.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $brnGE.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("capmA", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $cae4815c18efb9d5$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $cae4815c18efb9d5$export$83a9dd8d74be72c);

var $3cYHF = parcelRequire("3cYHF");
const $cae4815c18efb9d5$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $cae4815c18efb9d5$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $cae4815c18efb9d5$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $cae4815c18efb9d5$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $cae4815c18efb9d5$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $cae4815c18efb9d5$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $cae4815c18efb9d5$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cae4815c18efb9d5$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $cae4815c18efb9d5$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $cae4815c18efb9d5$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $3cYHF.envType).LOCAL || env === (0, $3cYHF.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $3cYHF.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $3cYHF.envType).PROD ? $cae4815c18efb9d5$var$FEDRAMP_PROD_HOST : $cae4815c18efb9d5$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $3cYHF.envType).PROD ? $cae4815c18efb9d5$var$STARGATE_FEDRAMP_PROD_HOST : $cae4815c18efb9d5$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $cae4815c18efb9d5$var$STARGATE_PROXY_PATH;
};
const $cae4815c18efb9d5$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $3cYHF.envType).PROD ? $cae4815c18efb9d5$var$PROD_HOST : $cae4815c18efb9d5$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $3cYHF.envType).PROD ? $cae4815c18efb9d5$var$STARGATE_PROD_HOST : $cae4815c18efb9d5$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $cae4815c18efb9d5$var$STARGATE_PROXY_PATH;
};
function $cae4815c18efb9d5$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $3cYHF.perimeterType).FEDRAMP_MODERATE) return $cae4815c18efb9d5$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $cae4815c18efb9d5$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $cae4815c18efb9d5$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $cae4815c18efb9d5$var$STARGATE_PROXY_PATH;
}

});

parcelRegister("hjBwJ", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $0383426782db0e27$export$44b578549c42d779);
class $0383426782db0e27$export$44b578549c42d779 {
    static{
        this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    }
    static{
        this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    }
    static{
        this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    }
    static{
        this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    }
    static isGeminiVREnvironment() {
        try {
            for(const k in $parcel$global){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($0383426782db0e27$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($0383426782db0e27$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($0383426782db0e27$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($0383426782db0e27$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) return $parcel$global[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) {
            const value = $parcel$global[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("15ZaT", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $7720db784235cd50$export$55b0d0261469055);

var $LFmXM = parcelRequire("LFmXM");

var $kYTKW = parcelRequire("kYTKW");
const $7720db784235cd50$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $7720db784235cd50$var$createRequestAbortController(timeout, signal);
    const corsOptions = $7720db784235cd50$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $kYTKW.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $7720db784235cd50$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $7720db784235cd50$var$getCorsForUrl = (0, $LFmXM.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("l61Iw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6b484f36f8205ab$export$2e2bcd8739ae039);

var $3cYHF = parcelRequire("3cYHF");

var $g2xf0 = parcelRequire("g2xf0");
class $c6b484f36f8205ab$export$2e2bcd8739ae039 {
    constructor(){
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $3cYHF.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $g2xf0.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});

parcelRegister("5g5S2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8251db774aedd68$export$2e2bcd8739ae039);

var $gOavb = parcelRequire("gOavb");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $a8251db774aedd68$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $a8251db774aedd68$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $a8251db774aedd68$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $a8251db774aedd68$export$285f6bddd927a06d = 1800000; // 30 minutes
const $a8251db774aedd68$export$a92e915d70316eb2 = 5000; // 5 seconds
const $a8251db774aedd68$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $a8251db774aedd68$export$5702a91a6f42969f = ()=>{};
class $a8251db774aedd68$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($a8251db774aedd68$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($a8251db774aedd68$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $a8251db774aedd68$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $a8251db774aedd68$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $a8251db774aedd68$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $a8251db774aedd68$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $gOavb.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($a8251db774aedd68$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($a8251db774aedd68$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$a8251db774aedd68$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("2WA8S", function(module, exports) {
$parcel$export(module.exports, "default", () => $d223d98a26391449$export$2e2bcd8739ae039);

var $cJTvQ = parcelRequire("cJTvQ");

var $jnGZ0 = parcelRequire("jnGZ0");
class $d223d98a26391449$export$2e2bcd8739ae039 extends (0, $jnGZ0.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $cJTvQ.default);
        } catch (err) {
            storageToUse = (0, $cJTvQ.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("esU8m", function(module, exports) {
$parcel$export(module.exports, "default", () => $979f0fbb65845144$export$2e2bcd8739ae039);

var $2WA8S = parcelRequire("2WA8S");
const $979f0fbb65845144$var$STORAGE_KEY = 'tab.id';
class $979f0fbb65845144$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = crypto.randomUUID();
            this._safeSessionStorage.setItem($979f0fbb65845144$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $2WA8S.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($979f0fbb65845144$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("fStKR", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ffd1b20e420a481$export$2e2bcd8739ae039);

var $5KkKW = parcelRequire("5KkKW");

var $3cYHF = parcelRequire("3cYHF");

var $egJLu = parcelRequire("egJLu");

var $2WA8S = parcelRequire("2WA8S");

var $g2xf0 = parcelRequire("g2xf0");
const $4ffd1b20e420a481$var$STORAGE_KEY = 'taskSessions';
const $4ffd1b20e420a481$var$INIT_KEY = 'taskSessionsInit';
const $4ffd1b20e420a481$var$AWC_PARAM_PREFIX = 'awc.';
const $4ffd1b20e420a481$var$TASK_SESSION_RELOAD_TIME = 3000;
class $4ffd1b20e420a481$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($4ffd1b20e420a481$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($4ffd1b20e420a481$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($4ffd1b20e420a481$var$INIT_KEY) || '0', 10) < currentTimestamp - $4ffd1b20e420a481$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($4ffd1b20e420a481$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($4ffd1b20e420a481$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($4ffd1b20e420a481$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($4ffd1b20e420a481$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = crypto.randomUUID();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $5KkKW.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $egJLu.pick)(currentState, includedTaskSessions) : (0, $egJLu.omit)(currentState, Object.values((0, $3cYHF.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $egJLu.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$4ffd1b20e420a481$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $5KkKW.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $egJLu.mapKeys)((0, $g2xf0.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $2WA8S.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($4ffd1b20e420a481$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("jbKHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e14d1c02119e2a8$export$2e2bcd8739ae039);

var $5H4WP = parcelRequire("5H4WP");

var $dGck7 = parcelRequire("dGck7");

var $hjBwJ = parcelRequire("hjBwJ");
const $9e14d1c02119e2a8$var$MAX_CACHE_SIZE = 100;
const $9e14d1c02119e2a8$var$COOKIE_NAME = (0, $dGck7.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $9e14d1c02119e2a8$var$DEBUG_TAG = 'synthetic';
class $9e14d1c02119e2a8$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $9e14d1c02119e2a8$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $9e14d1c02119e2a8$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($9e14d1c02119e2a8$var$DEBUG_TAG)) event.tags.push($9e14d1c02119e2a8$var$DEBUG_TAG);
        } else event.tags = [
            $9e14d1c02119e2a8$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $hjBwJ.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get($9e14d1c02119e2a8$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).remove($9e14d1c02119e2a8$var$COOKIE_NAME);
        }
        return false;
    }
}
var $9e14d1c02119e2a8$export$2e2bcd8739ae039 = $9e14d1c02119e2a8$var$TestingCache;

});

parcelRegister("5QK0a", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ede2404833ec912$export$2e2bcd8739ae039);

var $3cYHF = parcelRequire("3cYHF");

var $8MM4N = parcelRequire("8MM4N");

var $gOavb = parcelRequire("gOavb");
const $1ede2404833ec912$var$DEFAULT_DELAY = 2000; // 2 seconds
const $1ede2404833ec912$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $1ede2404833ec912$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $1ede2404833ec912$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $1ede2404833ec912$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $8MM4N.getDocument)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $3cYHF.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $1ede2404833ec912$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $1ede2404833ec912$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $1ede2404833ec912$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $1ede2404833ec912$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $gOavb.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("8MM4N", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $9d3bd21945c69218$export$f65ca476c09acec0);
const $9d3bd21945c69218$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("9kZLF", function(module, exports) {
$parcel$export(module.exports, "default", () => $750cdabc306e738f$export$2e2bcd8739ae039);
function $750cdabc306e738f$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("2TH30", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $a050fdaecae3c463$export$fbe53bbbe682bcdd);

var $3wdeG = parcelRequire("3wdeG");
const $a050fdaecae3c463$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $3wdeG.createTimeoutXid)()), (0, $3wdeG.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $3wdeG.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("3wdeG", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $c6dbef7e2c323f3a$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $c6dbef7e2c323f3a$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $c6dbef7e2c323f3a$export$fa341d0c750d705b);

var $fUQVG = parcelRequire("fUQVG");
const $c6dbef7e2c323f3a$export$545bcbd53afabfa3 = 5000;
const $c6dbef7e2c323f3a$export$af4087e36d63846 = ()=>[
        {
            type: (0, $fUQVG.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $fUQVG.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $c6dbef7e2c323f3a$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $fUQVG.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $fUQVG.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("fUQVG", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $278dc2fd526bef5d$export$92ca0438bcb0d396);
var $278dc2fd526bef5d$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $278dc2fd526bef5d$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("5nOCm", function(module, exports) {
$parcel$export(module.exports, "canCompress", () => $f10e6c034e7a5fc0$export$ec3662f84d9f778c);
$parcel$export(module.exports, "buildCompressionFunction", () => $f10e6c034e7a5fc0$export$20de0576abb0bcc5);
const $f10e6c034e7a5fc0$export$ec3662f84d9f778c = (event)=>event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
const $f10e6c034e7a5fc0$export$ca25d5d7792a4f37 = (events, batchSize = 50)=>{
    if (!events || events.length <= 0) return [];
    if (batchSize <= 0) throw new Error('Batch size must be greater than 0');
    // Extract evaluations and reduce into a single array
    const flagEvaluations = events.map((currentEvent)=>{
        const { flagKey: flagKey, value: value, reason: reason, ruleId: ruleId, errorKind: errorKind } = currentEvent.attributes;
        return {
            key: flagKey,
            value: value,
            ...reason && {
                reason: reason
            },
            ...ruleId && {
                ruleId: ruleId
            },
            ...errorKind && {
                errorKind: errorKind
            }
        };
    });
    // Batch evaluations into specified batchSize
    return $f10e6c034e7a5fc0$var$createBatches(flagEvaluations, batchSize);
};
const $f10e6c034e7a5fc0$var$createBatches = (array, batchSize)=>{
    let compressedEvaluations = [];
    for(let i = 0; i < array.length; i += batchSize){
        let evaluationBatch = array.slice(i, i + batchSize);
        compressedEvaluations.push({
            actionSubject: 'features',
            action: 'exposed',
            eventType: 'operational',
            attributes: {
                evaluations: evaluationBatch
            },
            tags: [
                'measurement'
            ],
            source: '@atlassian/exposure-events-compressor'
        });
    }
    return compressedEvaluations;
};
const $f10e6c034e7a5fc0$export$20de0576abb0bcc5 = (batchSize)=>(events)=>$f10e6c034e7a5fc0$export$ca25d5d7792a4f37(events, batchSize);

});

parcelRegister("eEpig", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aa9dd696a8a4fb6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6NtES = parcelRequire("6NtES");

var $9XJuu = parcelRequire("9XJuu");

var $cjn0E = parcelRequire("cjn0E");

var $6PF3E = parcelRequire("6PF3E");
const $0aa9dd696a8a4fb6$var$EngagementProviderWithEvents = (0, $6NtES.default)()((0, $6PF3E.EngagementProvider));
const $0aa9dd696a8a4fb6$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($0aa9dd696a8a4fb6$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $cjn0E.default)(props.config)
    });
};
var $0aa9dd696a8a4fb6$export$2e2bcd8739ae039 = (0, $9XJuu.default)($0aa9dd696a8a4fb6$var$EngagementProviderWithDefaultStore);

});
parcelRegister("9XJuu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9412abb3e2f0e3f9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $9412abb3e2f0e3f9$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, $gt9Am.jsx)(PreventNestedInstancesContext.Consumer, {
            children: (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, $gt9Am.jsx)(PreventNestedInstancesContext.Provider, {
                    value: true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                        ...props
                    })
                })
        }));
    };
}

});

parcelRegister("cjn0E", function(module, exports) {
$parcel$export(module.exports, "store", () => $d70629d0ed1e2e19$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $d70629d0ed1e2e19$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");

var $7HHI1 = parcelRequire("7HHI1");

var $gALD1 = parcelRequire("gALD1");

var $3BTSQ = parcelRequire("3BTSQ");

var $7nZJO = parcelRequire("7nZJO");

var $6rgoy = parcelRequire("6rgoy");
const $d70629d0ed1e2e19$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $d70629d0ed1e2e19$var$processMessagesCancellationToken = (0, $gALD1.createCancellationToken)();
function $d70629d0ed1e2e19$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $d70629d0ed1e2e19$export$6f57813fe9f31bf9 = (0, $7HHI1.createStore)((state = $d70629d0ed1e2e19$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $7nZJO.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $7nZJO.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $7nZJO.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $d70629d0ed1e2e19$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $7nZJO.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $7nZJO.RESET_STORE:
            return $d70629d0ed1e2e19$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $d70629d0ed1e2e19$export$2e2bcd8739ae039 = (config)=>{
    const state = $d70629d0ed1e2e19$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $d70629d0ed1e2e19$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $d70629d0ed1e2e19$var$processMessagesCancellationToken.isCancelled = true;
        $d70629d0ed1e2e19$var$processMessagesCancellationToken = (0, $gALD1.createCancellationToken)();
        $d70629d0ed1e2e19$export$6f57813fe9f31bf9.dispatch((0, $7nZJO.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $d70629d0ed1e2e19$export$6f57813fe9f31bf9.dispatch((0, $7nZJO.initialize)(newConfig));
    if ((0, $3BTSQ.isMessagingEnabled)()) (0, $6rgoy.processMessages)($d70629d0ed1e2e19$export$6f57813fe9f31bf9, newConfig, $d70629d0ed1e2e19$var$processMessagesCancellationToken);
    return $d70629d0ed1e2e19$export$6f57813fe9f31bf9;
};

});
parcelRegister("gALD1", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $a7dccaf04fdf62bc$export$eac027797b968991);
function $a7dccaf04fdf62bc$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("3BTSQ", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $6e91269648f8f87f$export$a77934ac158768dd);

var $aSDDo = parcelRequire("aSDDo");
function $6e91269648f8f87f$export$a77934ac158768dd() {
    return !(0, $aSDDo.isFedRamp)();
}

});

parcelRegister("7nZJO", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $7c1aa9732d4ed1f6$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $7c1aa9732d4ed1f6$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $7c1aa9732d4ed1f6$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $7c1aa9732d4ed1f6$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $7c1aa9732d4ed1f6$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $7c1aa9732d4ed1f6$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $7c1aa9732d4ed1f6$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $7c1aa9732d4ed1f6$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $7c1aa9732d4ed1f6$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $7c1aa9732d4ed1f6$export$96105f873ade39d7);
const $7c1aa9732d4ed1f6$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $7c1aa9732d4ed1f6$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $7c1aa9732d4ed1f6$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $7c1aa9732d4ed1f6$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $7c1aa9732d4ed1f6$export$a9319af002a4c677 = 'SET_CURRENT';
const $7c1aa9732d4ed1f6$export$a20a1205b2a2b7e4 = ()=>({
        type: $7c1aa9732d4ed1f6$export$874c5149d7f0e3b8
    });
const $7c1aa9732d4ed1f6$export$2a47f398eeff8b01 = (config)=>({
        type: $7c1aa9732d4ed1f6$export$eacd3ec165715d8,
        config: config
    });
const $7c1aa9732d4ed1f6$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $7c1aa9732d4ed1f6$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $7c1aa9732d4ed1f6$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $7c1aa9732d4ed1f6$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $7c1aa9732d4ed1f6$export$96105f873ade39d7() {
    return {
        type: $7c1aa9732d4ed1f6$export$cb5041d68cb18859
    };
}

});

parcelRegister("6rgoy", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $bb12b70d32c1e0ed$export$d2e92820f98a2592);

var $hux7u = parcelRequire("hux7u");

var $7nZJO = parcelRequire("7nZJO");

var $cjn0E = parcelRequire("cjn0E");
const $bb12b70d32c1e0ed$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $bb12b70d32c1e0ed$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $cjn0E.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $hux7u.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $bb12b70d32c1e0ed$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $7nZJO.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $bb12b70d32c1e0ed$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});
parcelRegister("hux7u", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $9e6ea31fb67205ce$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $9e6ea31fb67205ce$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $9e6ea31fb67205ce$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $9e6ea31fb67205ce$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $9e6ea31fb67205ce$export$3683393f780c6905);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths -- Preventing pre-commit error from being thrown when importing NO_CONTENT from controllers folder*/ 
var $l4vpb = parcelRequire("l4vpb");

var $aOXOW = parcelRequire("aOXOW");


var $1d5yV = parcelRequire("1d5yV");
const $9e6ea31fb67205ce$export$f4d1b02d312560f5 = '2';
const $9e6ea31fb67205ce$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
async function $9e6ea31fb67205ce$export$8c20ab16ac9cf14f(cloudId, stargateUrl, product, locale) {
    return (0, $1d5yV.stargateFetch)(`${stargateUrl}${$9e6ea31fb67205ce$var$inProductMessagesUrlTemplate.expand({
        cloudId: cloudId,
        product: product,
        schema: $9e6ea31fb67205ce$export$f4d1b02d312560f5,
        locale: locale
    })}`).then((0, $1d5yV.errorIfNotOk)).then((r)=>r.json().then((messages)=>({
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
            })));
}
function $9e6ea31fb67205ce$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $576a115f874e345f$export$3288b14b6745c572);
}
const $9e6ea31fb67205ce$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const $9e6ea31fb67205ce$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const $9e6ea31fb67205ce$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
var $9e6ea31fb67205ce$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $9e6ea31fb67205ce$var$choreographerPlugin;
async function $9e6ea31fb67205ce$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options?.enableChoreographer) return $9e6ea31fb67205ce$var$startMessageWithChoreographer(startMessageConfig, options);
    return $9e6ea31fb67205ce$var$startMessageWithCoordination(startMessageConfig);
}
async function $9e6ea31fb67205ce$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options?.enableChoreographer) return $9e6ea31fb67205ce$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $9e6ea31fb67205ce$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $9e6ea31fb67205ce$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$9e6ea31fb67205ce$var$choreographerPlugin) $9e6ea31fb67205ce$var$choreographerPlugin = new (0, $aOXOW.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $9e6ea31fb67205ce$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$9e6ea31fb67205ce$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $9e6ea31fb67205ce$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$9e6ea31fb67205ce$var$choreographerPlugin) $9e6ea31fb67205ce$var$choreographerPlugin = new (0, $aOXOW.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $9e6ea31fb67205ce$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$9e6ea31fb67205ce$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $9e6ea31fb67205ce$var$startMessageWithCoordination(startMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: startMessageConfig.cloudId,
        orgId: startMessageConfig.orgId,
        workspaceId: startMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $1d5yV.stargateFetch)(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${$9e6ea31fb67205ce$var$startMessageWithVariationIdUrlTemplate.expand({
        messageId: startMessageConfig.messageId,
        variationId: startMessageConfig.variationId
    })}` : `${startMessageConfig.stargateUrl}${$9e6ea31fb67205ce$var$startMessageUrlTemplate.expand({
        messageId: startMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $1d5yV.pullResponseTextIfNotOk)).then($9e6ea31fb67205ce$var$handleStartStopMessageResponse);
}
async function $9e6ea31fb67205ce$var$stopMessageWithCoordination(stopMessageConfig, choreographerEnabled = false) {
    const requestBody = {
        cloudId: stopMessageConfig.cloudId,
        orgId: stopMessageConfig.orgId,
        workspaceId: stopMessageConfig.workspaceId,
        choreographerEnabled: choreographerEnabled
    };
    return (0, $1d5yV.stargateFetch)(`${stopMessageConfig.stargateUrl}${$9e6ea31fb67205ce$var$stopMessageUrlTemplate.expand({
        messageId: stopMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $1d5yV.pullResponseTextIfNotOk)).then($9e6ea31fb67205ce$var$handleStartStopMessageResponse);
}
const $9e6ea31fb67205ce$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
async function $9e6ea31fb67205ce$export$e1fd1449cf83c1f5(cloudId, stargateUrl, messageId, payload) {
    return (0, $1d5yV.stargateFetch)(`${stargateUrl}${$9e6ea31fb67205ce$var$userResponseUrlTemplate.expand({
        cloudId: cloudId,
        messageId: messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $1d5yV.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}
const $9e6ea31fb67205ce$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
async function $9e6ea31fb67205ce$export$3683393f780c6905(seenMessageConfig) {
    const requestBody = {
        cloudId: seenMessageConfig.cloudId,
        orgId: seenMessageConfig.orgId,
        workspaceId: seenMessageConfig.workspaceId
    };
    return (0, $1d5yV.stargateFetch)(`${seenMessageConfig.stargateUrl}${$9e6ea31fb67205ce$var$markSeenAndFatigueUrlTemplate.expand({
        messageId: seenMessageConfig.messageId
    })}`, {
        method: 'post',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((0, $1d5yV.pullResponseTextIfNotOk)).then(()=>Promise.resolve());
}

});
parcelRegister("aOXOW", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $e4fc774e099b8775$export$da23bd36e2d631b);

var $kSVww = parcelRequire("kSVww");

var $jabQz = parcelRequire("jabQz");

var $6NQXg = parcelRequire("6NQXg");

var $2BsJ0 = parcelRequire("2BsJ0");

var $cRSpi = parcelRequire("cRSpi");
const $e4fc774e099b8775$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $e4fc774e099b8775$export$da23bd36e2d631b extends (0, $cRSpi.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $jabQz.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
	 * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
	 * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
	 * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
	 * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
	 * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
	 * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
	 * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
	 * actually fired off, and will keep just the log entries from which we can derive some actual value.
	 *
	 * @param event OperationalEventPayload
	 * @returns boolean
	 */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $jabQz.MessageAction).START || event.action !== (0, $jabQz.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $kSVww.Choreographer).getInstance().getCurrentMessage() ?? (0, $kSVww.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $e4fc774e099b8775$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $6NQXg.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $jabQz.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
		 * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
		 * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
		 * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
		 * will block the subsequest start request attempt altogether), by checking the Choreographer's
		 * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
		 * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
		 */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $2BsJ0.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $jabQz.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
		 * Dispatch the request to start the message, and return the response, which will
		 * either be 'started' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $jabQz.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $6NQXg.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
		 * Dispatch the request to stop the message, and return the response, which will
		 * either be 'stopped' if successful, and anything else if unsuccessful. Convert
		 * that value with a boolean check, because the consumer only cares about true/false.
		 */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $jabQz.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("kSVww", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $204d42917b83bd1b$export$236158f15971c92e);

var $91hOG = parcelRequire("91hOG");

var $jabQz = parcelRequire("jabQz");

var $6NQXg = parcelRequire("6NQXg");

var $2BsJ0 = parcelRequire("2BsJ0");

var $Hifh2 = parcelRequire("Hifh2");

var $gI1fJ = parcelRequire("gI1fJ");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $204d42917b83bd1b$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $204d42917b83bd1b$var$singleton;
class $204d42917b83bd1b$export$236158f15971c92e {
    /**
	 * Static method to create and/or return a singleton of the choreographer API.
	 *
	 * @returns Shared instance of choreographer API.
	 */ static getInstance() {
        const isWindowRegisteredSingleton = (0, $91hOG.fg)('post-office_choreographer_window_singleton');
        if (isWindowRegisteredSingleton) {
            if (typeof window !== 'undefined' && window.postOffice?.choreographer?.singleton) return window.postOffice.choreographer.singleton;
            if (typeof window !== 'undefined') {
                window.postOffice = {
                    ...window.postOffice,
                    choreographer: {
                        ...window.postOffice?.choreographer,
                        singleton: new this()
                    }
                };
                return window.postOffice.choreographer.singleton;
            }
        }
        if (!$204d42917b83bd1b$var$singleton) $204d42917b83bd1b$var$singleton = new this();
        return $204d42917b83bd1b$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            /*
		 * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
		 * of how many transactional messages we are showing to users.
		 *
		 * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
		 * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
		 * messages that are actually being shown to users.
		 *
		 * Thus, we track which messages have been seen and only log the first time we see a transactional message.
		 */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = props?.messageType === (0, $jabQz.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $91hOG.fg)('post-office_choreographer_log_transactional_msg');
            const seen = props?.messageId && this.state.seenTransactionalMessages.get(productId)?.has(props.messageId);
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && props?.[toggleableProp];
            if (isTransactional && props?.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                this.state.seenTransactionalMessages.get(productId)?.add(props.messageId);
                const logger = new (0, $2BsJ0.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: this.getCurrentMessage()?.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $Hifh2.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
	 * Enables the message queue, and logs which message everybody else is queueing up behind.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request blocking others.
	 * @param messageId Unique identifier for the messageId blocking others.
	 */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
	 * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
	 * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
	 * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
	 * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
	 * its startMessage request is processed.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request being queued.
	 * @param messageId Unique identifier for the messageId being queued.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
	 * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
	 * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
	 * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
	 * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
	 * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
	 */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
	 * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
	 * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
	 * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
	 * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
	 * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
	 *
	 * @param [plugin] An optional plugin instance
	 */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $jabQz.MessageAction).START;
            const logger = new (0, $2BsJ0.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $6NQXg.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: this.state.currentMessage?.productId,
                blockedByMessageId: this.state.currentMessage?.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $jabQz.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                }
            });
            resolve((0, $jabQz.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
	 * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param AnalyticsClient The analytics client to be used for logging/metrics.
	 * @param metricsData Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
	 */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        const isCustomTtlEnabled = (0, $91hOG.fg)('post-office_choreographer_custom_message_ttl');
        // If feature flag is off, always use default TTL
        if (!isCustomTtlEnabled) {
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $204d42917b83bd1b$var$CHOREOGRAPHER_MESSAGE_TTL);
            return;
        }
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $204d42917b83bd1b$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
	 * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
	 *
	 * @param productId Unique identifier for the product being checked for a current message match.
	 * @param messageId Unique identifier for the messageId being checked for a current message match.
	 */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
	 * Returns the currentMessage object.
	 */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
	 * Returns the queueingBehindMessage object.
	 */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
	 * Clears the timeout that was established for the currently-displayed message.
	 */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
	 * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
	 * may conflict with messages shown in parent frames.
	 *
	 * If called outside an iframe then this function is a noop.
	 *
	 * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
	 */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $gI1fJ.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
	 * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
	 *
	 * @param [exceptFor] An optional plugin instance.
	 */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
	 * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
	 */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
	 * A callback used to remove a plugin from the list of subscribers for the choreographer service.
	 *
	 * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
	 */ unregisterPlugin(productId) {
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (this.state.currentMessage?.productId === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
	 * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
	 *
	 * @returns A value reflecting whether a message is currently being displayed on screen.
	 */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
	 * This function is intended for test cleanup purposes only, *not* to be called by external callers.
	 *
	 * @ignore
	 * @param productId Unique identifier for the product whose messages are being requested
	 * @returns A Map of IMessage objects, keyed by unique messageId strings.
	 */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
	 * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
	 * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
	 * or a message TTL timeout has expired.
	 *
	 * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
	 * @param messageId Unique identifier for the messageId that triggered this message timeout.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $6NQXg.DebugLogger)(productId, messageId);
        const actionSubject = (0, $jabQz.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2BsJ0.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $jabQz.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $jabQz.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${this.state.queueingBehindMessage?.productId} ${this.state.queueingBehindMessage?.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                logger.blocked({
                    blockedByProductId: this.state.currentMessage?.productId,
                    blockedByMessageId: this.state.currentMessage?.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $jabQz.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: this.state.currentMessage?.productId,
                        blockedByMessageId: this.state.currentMessage?.messageId
                    }
                });
                return (0, $jabQz.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await message.start?.() ?? true;
            if (didStart) {
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                message.onStart?.();
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $jabQz.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $jabQz.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $jabQz.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $jabQz.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $jabQz.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $jabQz.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $6NQXg.DebugLogger)(productId, messageId);
        const actionSubject = (0, $jabQz.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2BsJ0.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $jabQz.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $jabQz.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await message.stop?.() ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    message.onStop?.();
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $jabQz.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $jabQz.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $jabQz.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $jabQz.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $jabQz.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $jabQz.MessageDeliveryStatus).ERROR;
        }
    }
    /**
	 * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
	 *
	 * @param productId Unique identifier for the product making the current stopMessage request.
	 * @param messageId Unique identifier for the messageId to be stopped.
	 * @param analyticsClient The analytics client to be used for logging/metrics.
	 * @param [metricsData] Additional data from plugin to be sent for metrics logging.
	 * @param [plugin] An optional plugin instance.
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
	 * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId Unique identifier to register as the product owner of this plugin.
	 * @param plugin A plugin instance to be registered with the choreographer instance.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
	 * Validates that a message record is present and ready to be retrieved and/or manipulated.
	 * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
	 *
	 * @param productId Unique identifier to retrieve map of IMessage objects.
	 * @param messageId Unique identifier for the messageId to be retrieved.
	 * @returns IMessage object for the requested productId/messageId combination.
	 */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
	 * Checks for the existance of a message record for a given productId/messageId combination.
	 *
	 * @param productId Unique identifier to check for a map of IMessage objects.
	 * @param messageId Unique identifier to check for within the map of productId IMessage objects.
	 * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
	 */ hasMessageRecord(productId, messageId) {
        return Boolean(this.state.messages.get(productId)?.has?.(messageId));
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for this message subscription.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
	 */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
	 *
	 * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
	 * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
	 */ off(productId, messageId) {
        this.state.messages.get(productId)?.delete?.(messageId);
    }
    /**
	 * This should only be used for test cleanup purposes.
	 * Clears the seen transactional messages cache for a given productId.
	 *
	 * @param productId Unique identifier to clear the seen transactional messages cache for.
	 */ clearSeenTransactionalMessages(productId) {
        this.state.seenTransactionalMessages.get(productId)?.clear();
    }
}

});
parcelRegister("jabQz", function(module, exports) {
$parcel$export(module.exports, "MessageEventType", () => $f0ae3e23f046d599$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $f0ae3e23f046d599$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $f0ae3e23f046d599$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $f0ae3e23f046d599$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $f0ae3e23f046d599$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $f0ae3e23f046d599$export$865c0eaaa43d90f8);
const $f0ae3e23f046d599$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $f0ae3e23f046d599$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $f0ae3e23f046d599$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    return ProductIds;
}({});
const $f0ae3e23f046d599$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $f0ae3e23f046d599$export$dbe9e38c9d6f26d0 = [
    $f0ae3e23f046d599$export$94e85cf3348f045a.ENGAGEMENT,
    $f0ae3e23f046d599$export$94e85cf3348f045a.MARKETING
];
const $f0ae3e23f046d599$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $f0ae3e23f046d599$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("6NQXg", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $a3cb8115465e8fe5$export$21e6cc849c1dc1ab);
function $a3cb8115465e8fe5$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $a3cb8115465e8fe5$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($a3cb8115465e8fe5$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $a3cb8115465e8fe5$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($a3cb8115465e8fe5$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $a3cb8115465e8fe5$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. log.info and log.verbose, which are functions that take an
	 * object of any key/value pairs, which will be merged with the productId
	 * and the messageId values passed to the constructor, and output via
	 * console.table.
	 *
	 * Example: debugLogger.log({
	 *   info: { foo: true },
	 *   verbose: {
	 *     foo: true,
	 *     bar: 123,
	 *     baz 'abc',
	 *     timestamp: performance.now()
	 *   },
	 * });
	 *
	 * @param messages Record<LoggingLevels, Record<string, unknown>> An object
	 * keyed by the desired log-level, with each value being an object of any
	 * key/value pairs to be output to console.table.
	 */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $a3cb8115465e8fe5$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
	 * A function that takes an object of properties for each logging level
	 * name, e.g. trace.info and trace.verbose, which are functions that take
	 * a string to be used as the label for a stack trace via console.trace.
	 *
	 * Example: debugLogger.trace({
	 *   info: 'This is a stack trace',
	 *   verbose: `This is a stack trace with a much more verbose message which
	 * contains data about the ${productId} and ${messageId} within my function,
	 * invoked at ${performance.now()}ms`,
	 * });
	 *
	 * @param messages Record<LoggingLevels, string> An object keyed by the
	 * desired log-level, with each value being a string to be output as the
	 * label to console.trace.
	 */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $a3cb8115465e8fe5$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("2BsJ0", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $13c95089de646938$export$efa9a398d6368992);

var $jabQz = parcelRequire("jabQz");
class $13c95089de646938$export$efa9a398d6368992 {
    /**
	 * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
	 *
	 * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
	 * @param actionSubjectId Unique messageId to be logged with this even.
	 * @param metricsData Additional data from plugin to be sent with event for metrics logging.
	 * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
	 * @param [plugin] An optional plugin instance.
	 */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
	 * Send operational event to the Analytics web client for logging/metrics.
	 *
	 * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
	 */ sendOperationalEvent(action, additionalAttributes) {
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if (plugin?.shouldLogEvent?.(event) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $jabQz.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("Hifh2", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $60847cd9e6922c7e$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $60847cd9e6922c7e$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $60847cd9e6922c7e$export$7c574bc7a8b74124);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jabQz = parcelRequire("jabQz");
const $60847cd9e6922c7e$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions?.enableChoreographer) && props?.messageType !== undefined && (0, $jabQz.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $60847cd9e6922c7e$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $eJOHy.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $60847cd9e6922c7e$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $eJOHy.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ChoreographedComponent, {
                ...rest
            });
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...rest
        });
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("gI1fJ", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $957c25658639b542$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $957c25658639b542$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("cRSpi", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $8269b54507501564$export$71324a662782c710);

var $f67Z8 = parcelRequire("f67Z8");
var $3cYHF = parcelRequire("3cYHF");

var $kSVww = parcelRequire("kSVww");
class $8269b54507501564$export$71324a662782c710 {
    /**
	 * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
	 * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
	 * between individual products for tracking purposes.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @param env The environment type for the product, to be used for analytics events.
	 * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
	 * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
	 */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
		 * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
		 * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
		 * .on, .onStart, and .onStop function registrations.
		 *
		 * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
		 * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
		 * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
		 * in the plugin, and would continue blocking messages.
		 *
		 * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
		 * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
		 * whether or not an actual start or stop callback was registered by the consumer.
		 */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
	 * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
	 */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
	 * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
	 * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
	 * container to be present, or checks with some external API to tell it whether a message is being displayed, or
	 * anything else. The logic is up to the consumer to implement, if something custom is desired.
	 *
	 * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
	 */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
	 * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
	 */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
	 * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
	 */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
	 * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ disable() {
        this.state.isDisabled = true;
    }
    /**
	 * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
	 * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
	 * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
	 */ enable() {
        this.state.isDisabled = false;
    }
    /**
	 * Returns the Analytics Web Client instance for this plugin.
	 *
	 * @returns AnalyticsWebClient instance
	 */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
	 * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
	 * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
	 *
	 * @param messageId The messageId for the message to be started through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message start request
	 * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
	 */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $kSVww.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
	 * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
	 *
	 * @param messageId The messageId for the message to be stopped through the choreographer API.
	 * @param additionalData An object containing additional metadata to be sent along with the message stop request
	 * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
	 */ async stopMessage(messageId, additionalData = {}) {
        return (0, $kSVww.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
	 * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
	 */ on(messageId, options = {}) {
        return (0, $kSVww.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param startCallback A callback to be invoked upon successful requests to startMessage.
	 */ onStart(messageId, startCallback) {
        return (0, $kSVww.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
	 * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
	 * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
	 */ onStop(messageId, stopCallback) {
        return (0, $kSVww.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
	 * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
	 *
	 * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
	 */ off(messageId) {
        return (0, $kSVww.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp) {
        return (0, $kSVww.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
	 * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
	 *
	 * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
	 * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
	 */ registerPlugin(productId) {
        return (0, $kSVww.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
	 * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
	 *
	 * @param env environment type used to create the analytics client
	 * @returns AnalyticsWebClient instance
	 */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $f67Z8.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $3cYHF.originType).WEB
        });
        return analyticsClient;
    }
}

});


const $576a115f874e345f$export$3288b14b6745c572 = 204;
const $576a115f874e345f$export$c09e7ea0fc79f34f = 409;
const $576a115f874e345f$export$974c37534b0191b1 = 503;

parcelRegister("1d5yV", function(module, exports) {
$parcel$export(module.exports, "errorIfNotOk", () => $72e5a9d7643317a0$export$4adbd37839ed7718);
$parcel$export(module.exports, "pullResponseTextIfNotOk", () => $72e5a9d7643317a0$export$2ba4cde277adb6b1);
$parcel$export(module.exports, "stargateFetch", () => $72e5a9d7643317a0$export$317bcea84a3bea48);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $c2BIs = parcelRequire("c2BIs");
const $72e5a9d7643317a0$export$1f86472c1374185a = 3;
const $72e5a9d7643317a0$export$a2d611d5c7be4bb1 = 0.1;
const $72e5a9d7643317a0$export$957d605a51548b59 = 2;
const $72e5a9d7643317a0$export$80aa83cae6a6c290 = 1000;
async function $72e5a9d7643317a0$export$4adbd37839ed7718(response) {
    if (!response.ok) // We use the response body for two reasons:
    // 1. To ensure that we consume the response body, so that it gets reported on in Chrome DevTools
    // 2. It could have some useful information relevant to the error
    throw Error(`${response.status}: ${await response.text()}`);
    return response;
}
async function $72e5a9d7643317a0$export$2ba4cde277adb6b1(response) {
    if (!response.ok) await response.text();
    return response;
}
function $72e5a9d7643317a0$export$317bcea84a3bea48(input, reqOptions) {
    return $72e5a9d7643317a0$var$fetchWithRetry({
        input: input,
        reqOptions: reqOptions,
        numRetries: 0,
        maxRetries: $72e5a9d7643317a0$export$1f86472c1374185a,
        waitTimeMs: $72e5a9d7643317a0$export$80aa83cae6a6c290,
        backoffFn: $72e5a9d7643317a0$export$924aee1254634401
    });
}
function $72e5a9d7643317a0$var$fetchWithRetry({ input: input, reqOptions: reqOptions, numRetries: numRetries = 0, maxRetries: maxRetries = 0, waitTimeMs: waitTimeMs = 0, backoffFn: backoffFn = $72e5a9d7643317a0$export$924aee1254634401 }) {
    if (numRetries > maxRetries) throw new Error(`Failed to fetch ${input}: Max retries exceeded`);
    const options = {
        ...reqOptions,
        credentials: (0, $c2BIs.default).includes(location.host) ? 'include' : 'same-origin'
    };
    const retryAttempt = ()=>new Promise((resolve)=>{
            setTimeout(()=>{
                resolve($72e5a9d7643317a0$var$fetchWithRetry({
                    input: input,
                    reqOptions: reqOptions,
                    numRetries: numRetries + 1,
                    maxRetries: maxRetries,
                    waitTimeMs: backoffFn(waitTimeMs),
                    backoffFn: backoffFn
                }));
            }, waitTimeMs);
        });
    return fetch(input, options).then((response)=>{
        if (response.status >= 500 && response.status <= 599) return retryAttempt();
        return response;
    }).catch(()=>{
        return retryAttempt();
    });
}
function $72e5a9d7643317a0$export$924aee1254634401(waitTimeMs) {
    const nextWaitTime = waitTimeMs * $72e5a9d7643317a0$export$957d605a51548b59;
    const jitter = nextWaitTime * $72e5a9d7643317a0$export$a2d611d5c7be4bb1 * Math.random();
    return nextWaitTime + jitter;
}

});
parcelRegister("c2BIs", function(module, exports) {
$parcel$export(module.exports, "default", () => $438b836b936c3348$export$2e2bcd8739ae039);
var $438b836b936c3348$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    'bitbucket-pipelines.dev.public.atl-paas.net',
    'bitbucket-pipelines.staging.public.atl-paas.net',
    'bitbucket-pipelines.prod.public.atl-paas.net'
];

});





parcelRegister("6PF3E", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $ce322dfd3d48167c$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ee5Jg = parcelRequire("ee5Jg");

var $bx11l = parcelRequire("bx11l");

var $cT3Ey = parcelRequire("cT3Ey");

var $02u1x = parcelRequire("02u1x");

var $1HngN = parcelRequire("1HngN");
var $lbs30 = parcelRequire("lbs30");

var $jabQz = parcelRequire("jabQz");
var $Hifh2 = parcelRequire("Hifh2");

var $hux7u = parcelRequire("hux7u");

var $9gdSI = parcelRequire("9gdSI");

var $i70uW = parcelRequire("i70uW");

var $4TFKT = parcelRequire("4TFKT");

var $3BTSQ = parcelRequire("3BTSQ");

var $7nZJO = parcelRequire("7nZJO");

var $fR7l8 = parcelRequire("fR7l8");
const $ce322dfd3d48167c$var$MAX_EVENT_QUEUE_SIZE = 100;
const $ce322dfd3d48167c$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $ce322dfd3d48167c$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $ce322dfd3d48167c$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $ce322dfd3d48167c$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($ee5Jg)))(payload, trigger);
    });
}
function $ce322dfd3d48167c$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $1HngN.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $ce322dfd3d48167c$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $ce322dfd3d48167c$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $ce322dfd3d48167c$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $hux7u.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $hux7u.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $ce322dfd3d48167c$var$fireExposureEvent($ce322dfd3d48167c$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $hux7u.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions?.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $jabQz.MessageDeliveryStatus).STARTED : (0, $jabQz.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $ce322dfd3d48167c$var$fireExposureEvent($ce322dfd3d48167c$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $7nZJO.setCurrent)(eventMapping));
        }
    } else {
        $ce322dfd3d48167c$var$fireExposureEvent($ce322dfd3d48167c$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $7nZJO.setCurrent)(eventMapping));
    }
}
class $ce322dfd3d48167c$export$83b8ae7ce7b4d59c extends (0, $eJOHy.Component) {
    static{
        this.componentConfig = new Map();
    }
    static{
        this.childContextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).func
        };
    }
    static{
        this.defaultProps = {
            eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($02u1x)))
        };
    }
    static{
        /*
	 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
	 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
	 */ this.hasInitializedAtLeastOneEngagementProvider = false;
    }
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$ce322dfd3d48167c$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $i70uW.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $ce322dfd3d48167c$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $ce322dfd3d48167c$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $ce322dfd3d48167c$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $4TFKT.default)({
                eventName: $ce322dfd3d48167c$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $3BTSQ.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $ce322dfd3d48167c$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if (eventMapping.component?.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $ce322dfd3d48167c$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $ce322dfd3d48167c$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $ce322dfd3d48167c$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean(this.props.coordinationOptions?.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig?.messageType ? // regardless of the EngagementProvider's coordinationOptions
                (0, $Hifh2.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $ce322dfd3d48167c$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($ce322dfd3d48167c$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $ce322dfd3d48167c$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $9gdSI.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $9gdSI.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $9gdSI.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $fR7l8.default)($ce322dfd3d48167c$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $hux7u.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig?.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $jabQz.MessageDeliveryStatus).STOPPED : (0, $jabQz.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $ce322dfd3d48167c$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $7nZJO.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbs30.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lbs30.default), {
                channel: "engagement",
                onEvent: this.onEngagementEvent,
                children: this.props.children
            })
        });
    }
}

});
parcelRegister("9gdSI", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $69ab6896beee0839$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $69ab6896beee0839$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $69ab6896beee0839$export$e5f89b51c6d4e36b);
function $69ab6896beee0839$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $69ab6896beee0839$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $69ab6896beee0839$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("i70uW", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $148b5dc5229a3638$export$6c724a6ffa2dc3e1);
const $148b5dc5229a3638$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $148b5dc5229a3638$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $148b5dc5229a3638$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $148b5dc5229a3638$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $148b5dc5229a3638$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $148b5dc5229a3638$export$cda2203640e08931;
}

});

parcelRegister("4TFKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c291a8ef323f0ac0$export$2e2bcd8739ae039);
const $c291a8ef323f0ac0$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $c291a8ef323f0ac0$export$2e2bcd8739ae039 = $c291a8ef323f0ac0$var$createCustomEvent;

});

parcelRegister("fR7l8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa078645a51872b5$export$2e2bcd8739ae039);
class $fa078645a51872b5$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});



parcelRegister("7Ll1b", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $e7836b41ab725622$export$c73a6a6f0bf7d425);
$parcel$export(module.exports, "isLoaderError", () => $e7836b41ab725622$export$16a03aca4a3508b4);
const $e7836b41ab725622$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $e7836b41ab725622$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$e7836b41ab725622$export$6aa69c1258005366]: true
    });
    return error;
};
const $e7836b41ab725622$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($e7836b41ab725622$export$6aa69c1258005366);

});

parcelRegister("anTtz", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $b6323eff8e7a83e3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $b6323eff8e7a83e3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $b6323eff8e7a83e3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $d0A2n = parcelRequire("d0A2n");

var $ljiBz = parcelRequire("ljiBz");

var $aVJnj = parcelRequire("aVJnj");
let $b6323eff8e7a83e3$var$CURRENT_PHASE = (0, $d0A2n.PHASE).PAINT;
const $b6323eff8e7a83e3$export$5f80f094fd31fffd = (phase)=>{
    $b6323eff8e7a83e3$var$CURRENT_PHASE = phase;
    (0, $ljiBz.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $b6323eff8e7a83e3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $aVJnj.createSubscribe)((0, $ljiBz.LISTENERS)),
    currentValue: ()=>$b6323eff8e7a83e3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $b6323eff8e7a83e3$export$5f80f094fd31fffd((0, $d0A2n.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$b6323eff8e7a83e3$export$5f80f094fd31fffd((0, $d0A2n.PHASE).PAINT)
    }
});
const $b6323eff8e7a83e3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($b6323eff8e7a83e3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("d0A2n", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $e45dad1697b3bb29$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $e45dad1697b3bb29$export$4831ef3968ea94ef);
const $e45dad1697b3bb29$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $e45dad1697b3bb29$export$4831ef3968ea94ef = new Map();

});

parcelRegister("ljiBz", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $6ea2463fe2e43ae2$export$81b9c458a026d68f);
const $6ea2463fe2e43ae2$export$81b9c458a026d68f = [];

});

parcelRegister("aVJnj", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $ccfde25d5e6165ec$export$364097d812234b3f);
const $ccfde25d5e6165ec$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});


parcelRegister("aNGm2", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $b62333b6e71974d1$export$256c542058532d6f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $eJOHy = parcelRequire("eJOHy");

var $1Vjc9 = parcelRequire("1Vjc9");

var $iKsw2 = parcelRequire("iKsw2");
var $fwTjO = parcelRequire("fwTjO");

var $4uKxL = parcelRequire("4uKxL");
class $b62333b6e71974d1$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.state = {
            getIsBoundaryInitialized: ()=>Boolean(this.hydrationFallback),
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted && !(0, $iKsw2.getConfig)().react18) this.forceUpdate();
            },
            name: this.props.name
        }, this.hydrationFallback = null, this.mounted = false, this.renderedSuspenseFallback = false, this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                if (!outsideSuspense) this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        }, this.DynamicReact18Fallback = ({ children: children })=>{
            (0, $eJOHy.useLayoutEffect)(()=>{
                this.renderedSuspenseFallback = true;
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    // - this is more "stable" way that tracking completion inside createComponentClient
                    // - we are done when fallback is removed
                    this.state.setFallback(null);
                };
            }, []);
            if ((0, $iKsw2.getConfig)().mode === (0, $fwTjO.MODE).HYDRATE) return children(this.props.fallback);
            return children(this.hydrationFallback || this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
        this.DynamicReact18Fallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
        // It is possible that the fallback is never rendered if React already
        // knows the lazy component was already resolved. In our case this means
        // nothing has suspended in the last render cycle. In that case, when the
        // component is mounted, renderedSuspenseFallback will not be set and
        // there is nothing that can clean up the hydration fallback, and we
        // can immediately clean it here.
        // Also see https://atlassian.slack.com/archives/CFGR2NAUA/p1741009492576969
        if (!this.renderedSuspenseFallback) this.state.setFallback(null);
    }
    shouldComponentUpdate() {
        const { mode: mode, react18: react18 } = (0, $iKsw2.getConfig)();
        if (react18 && mode === (0, $fwTjO.MODE).HYDRATE) // This is a workaround to prevent Suspense during hydration
        // from switching to the fallback if a re-render occurs
        // https://github.com/facebook/react/issues/22692
        // is shouldComponentUpdate => false if it's "busy"
        return this.hydrationFallback ? false : true;
        return true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderReact18Fallback() {
        const { DynamicReact18Fallback: DynamicReact18Fallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicReact18Fallback, null, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4uKxL.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4uKxL.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        const { react18: react18 } = (0, $iKsw2.getConfig)();
        if (react18) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4uKxL.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderReact18Fallback()
        }, this.props.children));
        return (0, $1Vjc9.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("1Vjc9", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $93cb44906eaed801$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $93cb44906eaed801$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $93cb44906eaed801$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $93cb44906eaed801$export$62bf630d0de3d781);

var $4yRIH = parcelRequire("4yRIH");
const $93cb44906eaed801$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $93cb44906eaed801$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $93cb44906eaed801$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $93cb44906eaed801$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("4yRIH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb952ff681fbbb1$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $1eb952ff681fbbb1$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("iKsw2", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $3262489094fd722f$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $3262489094fd722f$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("fwTjO")).MODE);

var $fwTjO = parcelRequire("fwTjO");
const $3262489094fd722f$var$DEFAULT_CROSS_ORIGIN = undefined;
const $3262489094fd722f$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $3262489094fd722f$var$DEFAULT_MODE = (0, $fwTjO.MODE).HYDRATE;
const $3262489094fd722f$var$DEFAULT_RETRY = 2;
const $3262489094fd722f$var$nullFunction = ()=>{};
const $3262489094fd722f$var$config = {
    crossOrigin: $3262489094fd722f$var$DEFAULT_CROSS_ORIGIN,
    manifest: $3262489094fd722f$var$DEFAULT_MANIFEST,
    mode: $3262489094fd722f$var$DEFAULT_MODE,
    retry: $3262489094fd722f$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $3262489094fd722f$var$nullFunction,
    usePostTaskPhases: false,
    trackDuplicateLazyIds: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $3262489094fd722f$export$44487a86467333c3 = ()=>$3262489094fd722f$var$config;
const $3262489094fd722f$export$940a7873bb071df8 = (nextConfig)=>{
    $3262489094fd722f$var$config.crossOrigin = nextConfig.crossOrigin ?? $3262489094fd722f$var$DEFAULT_CROSS_ORIGIN;
    $3262489094fd722f$var$config.manifest = nextConfig.manifest ?? $3262489094fd722f$var$DEFAULT_MANIFEST;
    $3262489094fd722f$var$config.mode = nextConfig.mode ?? $3262489094fd722f$var$DEFAULT_MODE;
    $3262489094fd722f$var$config.retry = nextConfig.retry ?? $3262489094fd722f$var$DEFAULT_RETRY;
    $3262489094fd722f$var$config.react18 = nextConfig.react18 ?? false;
    $3262489094fd722f$var$config.onChunkRender = nextConfig.onChunkRender ?? $3262489094fd722f$var$nullFunction;
    $3262489094fd722f$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $3262489094fd722f$var$config.trackDuplicateLazyIds = nextConfig.trackDuplicateLazyIds ?? false;
    $3262489094fd722f$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $3262489094fd722f$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $3262489094fd722f$var$config.environment = nextConfig.environment ?? undefined;
};

});
parcelRegister("fwTjO", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $0452e95bed2c3c75$export$e48589d9e4824227);
const $0452e95bed2c3c75$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("4uKxL", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $7eeddd461307a7b5$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");

var $iKsw2 = parcelRequire("iKsw2");
var $fwTjO = parcelRequire("fwTjO");
const $7eeddd461307a7b5$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        if ((0, $iKsw2.getConfig)().mode === (0, $fwTjO.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});


parcelRegister("9LdGp", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $6e494ef427950626$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $8dknI = parcelRequire("8dknI");
const $6e494ef427950626$export$9ba3fe09d15de47b = (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $8dknI.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("8dknI", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $adcd67fefcc80c90$export$276c7dbda7675aec);
const $adcd67fefcc80c90$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("i5VSy", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $c38bf8a10deecd10$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $c38bf8a10deecd10$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $c38bf8a10deecd10$export$488013bae63b21da);

var $4fidM = parcelRequire("4fidM");

var $canmk = parcelRequire("canmk");

var $iKsw2 = parcelRequire("iKsw2");

var $d0A2n = parcelRequire("d0A2n");

var $1Vjc9 = parcelRequire("1Vjc9");
var $4yRIH = parcelRequire("4yRIH");

var $gSjyx = parcelRequire("gSjyx");

var $f4ubo = parcelRequire("f4ubo");

var $f6tE0 = parcelRequire("f6tE0");

var $6cijW = parcelRequire("6cijW");

var $50pXd = parcelRequire("50pXd");

var $e99jZ = parcelRequire("e99jZ");

var $7Ll1b = parcelRequire("7Ll1b");
function $c38bf8a10deecd10$var$noop() {}
function $c38bf8a10deecd10$var$deferToPhase(phase) {
    switch(phase){
        case (0, $d0A2n.PHASE).PAINT:
            return (0, $canmk.postTask)($c38bf8a10deecd10$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $d0A2n.PHASE).AFTER_PAINT:
            return (0, $canmk.postTask)($c38bf8a10deecd10$var$noop, {
                priority: 'user-visible'
            });
        case (0, $d0A2n.PHASE).LAZY:
            return (0, $canmk.postTask)($c38bf8a10deecd10$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $c38bf8a10deecd10$var$lazyProxy(loader, { defer: defer = (0, $d0A2n.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $1Vjc9.isNodeEnvironment)();
    const dataLazyId = (0, $4yRIH.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $f4ubo.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $gSjyx.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $6cijW.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $iKsw2.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$c38bf8a10deecd10$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $e99jZ.retry)(deferredLoader, {
                    delay: (0, $f6tE0.RETRY_DELAY),
                    factor: (0, $f6tE0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $1Vjc9.displayNameFromId)(moduleId)})`;
    /**
	 * Allows getting module chunks urls
	 */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $iKsw2.getConfig)();
        return (0, $4fidM.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
	 * Allows imperatively preload/ prefetch the module chunk asset
	 */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $d0A2n.PHASE).PAINT ? (0, $f6tE0.PRIORITY).HIGH : (0, $f6tE0.PRIORITY).LOW);
        return (0, $50pXd.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $c38bf8a10deecd10$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $d0A2n.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $d0A2n.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $d0A2n.PHASE).LAZY
    }
};
function $c38bf8a10deecd10$export$c952e5f94576010e(loader, opts) {
    return $c38bf8a10deecd10$var$lazyProxy(loader, {
        ...$c38bf8a10deecd10$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $c38bf8a10deecd10$export$291dd592399bdafa(loader, opts) {
    return $c38bf8a10deecd10$var$lazyProxy(loader, {
        ...$c38bf8a10deecd10$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $c38bf8a10deecd10$export$488013bae63b21da(loader, opts) {
    return $c38bf8a10deecd10$var$lazyProxy(loader, {
        ...$c38bf8a10deecd10$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}

});
parcelRegister("4fidM", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $b1a584442bec5e3f$export$303f43e55cf1ef2f);
const $b1a584442bec5e3f$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("canmk", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $66773dc2cbe6f661$export$13c9d02ca54955a3);
async function $66773dc2cbe6f661$var$toPromise(callback) {
    return callback();
}
function $66773dc2cbe6f661$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $66773dc2cbe6f661$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $66773dc2cbe6f661$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("2Z49U")).then(()=>$66773dc2cbe6f661$var$getScheduler(globalThis).postTask(callback, options));
        return $66773dc2cbe6f661$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("2Z49U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("f3z8H").then(()=>parcelRequire('57cTu'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});




parcelRegister("gSjyx", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $06e39e6aab124bb0$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("vIgIV");
var $j3vko = parcelRequire("j3vko");

var $iKsw2 = parcelRequire("iKsw2");
var $fwTjO = parcelRequire("fwTjO");

var $d0A2n = parcelRequire("d0A2n");

var $9LdGp = parcelRequire("9LdGp");

var $anTtz = parcelRequire("anTtz");

var $i1oZ6 = parcelRequire("i1oZ6");

var $4uKxL = parcelRequire("4uKxL");

var $7Ll1b = parcelRequire("7Ll1b");

var $8uanK = parcelRequire("8uanK");

var $3vcYe = parcelRequire("3vcYe");

var $jp3Yl = parcelRequire("jp3Yl");
const $06e39e6aab124bb0$var$reportedDuplicate = new Set();
function $06e39e6aab124bb0$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $d0A2n.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $d0A2n.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases, trackDuplicateLazyIds: trackDuplicateLazyIds } = (0, $iKsw2.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $eJOHy.useContext)((0, $4uKxL.LazySuspenseContext));
        const profiler = (0, $eJOHy.useContext)((0, $i1oZ6.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $7Ll1b.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $eJOHy.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $jp3Yl.useSubscription)({
                context: (0, $9LdGp.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $d0A2n.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $jp3Yl.useSubscription)({
                context: (0, $anTtz.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $eJOHy.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            const contentLength = (0, $d0A2n.COLLECTED).get(dataLazyId)?.length || 0;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $d0A2n.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            if (trackDuplicateLazyIds && contentLength > 1 && !$06e39e6aab124bb0$var$reportedDuplicate.has(dataLazyId)) {
                // This means there are multiple components for the same lazyId
                // This can cause performance issues, so we should log it and resolve it later on
                $06e39e6aab124bb0$var$reportedDuplicate.add(dataLazyId);
                (0, $j3vko.default)({
                    error: new Error(`Duplicate components for ${dataLazyId} found, module name is ${moduleId}, total count: ${$06e39e6aab124bb0$var$reportedDuplicate.size}`),
                    meta: {
                        id: 'rll-duplicate-error',
                        packageName: 'reactLooselyLazy',
                        teamName: 'jfp-magma'
                    },
                    attributes: {
                        moduleName: moduleId
                    }
                });
            }
            // override Suspense fallback with magic input wrappers
            const component = (0, $iKsw2.getConfig)().mode === (0, $fwTjO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3vcYe.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8uanK.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases,
            trackDuplicateLazyIds
        ]);
        (0, $eJOHy.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $iKsw2.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $fwTjO.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("vIgIV", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("8NP0A")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("j3vko")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("j3vko")).initialiseErrorAnalyticsClient);
$parcel$export(module.exports, "ReportErrors", () => (parcelRequire("eGqF3")).default);

var $8NP0A = parcelRequire("8NP0A");

var $j3vko = parcelRequire("j3vko");

var $eGqF3 = parcelRequire("eGqF3");

});
parcelRegister("8NP0A", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $6f510de03cc178e7$export$f5282963edea4a68);

var $fIBwY = parcelRequire("fIBwY");
const $6f510de03cc178e7$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $fIBwY.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $6f510de03cc178e7$export$f5282963edea4a68 = (location, error, details = {})=>(0, $fIBwY.default).captureException(location, error, details);

});
parcelRegister("fIBwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a482af1c2a9f7dac$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $gamVI = parcelRequire("gamVI");
var $kObcn = parcelRequire("kObcn");
var $1Djp3 = parcelRequire("1Djp3");

var $35yDm = parcelRequire("35yDm");
var $caZl3 = parcelRequire("caZl3");
var $iZ7wR = parcelRequire("iZ7wR");
var $g7tNk = parcelRequire("g7tNk");

var $jvwCK = parcelRequire("jvwCK");
const $a482af1c2a9f7dac$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $a482af1c2a9f7dac$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $a482af1c2a9f7dac$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $a482af1c2a9f7dac$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $a482af1c2a9f7dac$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $kObcn.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $a482af1c2a9f7dac$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$a482af1c2a9f7dac$var$getFilteredIntegrations(integrations),
                new $caZl3.Dedupe(),
                new $iZ7wR.ExtraErrorData(),
                new $g7tNk.Transaction(),
                new $35yDm.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $1Djp3.init({
        ...defaultConfig,
        ...config
    });
    try {
        $gamVI.setExtras(getExtraContext());
    } catch (e) {
        $gamVI.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $a482af1c2a9f7dac$var$tags = [
    'packageName',
    'teamName'
];
const $a482af1c2a9f7dac$var$captureException = (location, error, details)=>{
    $gamVI.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($a482af1c2a9f7dac$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $gamVI.captureException(error);
};
const $a482af1c2a9f7dac$var$sentryErrorHandler = {
    installGlobalHandler: $a482af1c2a9f7dac$var$installGlobalHandler,
    captureException: $a482af1c2a9f7dac$var$captureException
};
var $a482af1c2a9f7dac$export$2e2bcd8739ae039 = $a482af1c2a9f7dac$var$sentryErrorHandler;

});
parcelRegister("1Djp3", function(module, exports) {
$parcel$export(module.exports, "init", () => $13087c0028ca9729$export$2cd8252107eb640b);

var $dnskZ = parcelRequire("dnskZ");

var $kObcn = parcelRequire("kObcn");
var $6k1Bx = parcelRequire("6k1Bx");
var $3xJqq = parcelRequire("3xJqq");
parcelRequire("9M5tS");
var $gxSvp = parcelRequire("gxSvp");
var $faeBy = parcelRequire("faeBy");
var $bfMNh = parcelRequire("bfMNh");
var $IakcK = parcelRequire("IakcK");

var $5VxHJ = parcelRequire("5VxHJ");

var $ey2qH = parcelRequire("ey2qH");

var $jCxri = parcelRequire("jCxri");

var $2rSpj = parcelRequire("2rSpj");
var $bVGq2 = parcelRequire("bVGq2");
var $dmbk6 = parcelRequire("dmbk6");
var $9AVP9 = parcelRequire("9AVP9");
var $iMcMT = parcelRequire("iMcMT");
var $5xA0y = parcelRequire("5xA0y");
var $13087c0028ca9729$export$5ef831fccfce35e5 = [
    new (0, $3xJqq).InboundFilters(),
    new (0, $3xJqq).FunctionToString(),
    new (0, $iMcMT.TryCatch)(),
    new (0, $2rSpj.Breadcrumbs)(),
    new (0, $dmbk6.GlobalHandlers)(),
    new (0, $9AVP9.LinkedErrors)(),
    new (0, $bVGq2.Dedupe)(),
    new (0, $5xA0y.UserAgent)()
];
function $13087c0028ca9729$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $13087c0028ca9729$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $faeBy.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $6k1Bx.initAndBind)((0, $5VxHJ.BrowserClient), options);
    if (options.autoSessionTracking) $13087c0028ca9729$var$startSessionTracking();
}
function $13087c0028ca9729$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $kObcn.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $13087c0028ca9729$export$5d4e9fd7fac8e617() {
    return (0, $kObcn.getCurrentHub)().lastEventId();
}
function $13087c0028ca9729$export$a3f323d81eede727() {
// Noop
}
function $13087c0028ca9729$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $13087c0028ca9729$export$4909b86c8034bf73(timeout) {
    var client = (0, $kObcn.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Cannot flush events. No client defined.');
    return (0, $IakcK.resolvedSyncPromise)(false);
}
function $13087c0028ca9729$export$8360e631d277ea4d(timeout) {
    var client = (0, $kObcn.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $IakcK.resolvedSyncPromise)(false);
}
function $13087c0028ca9729$export$4997ffc0176396a6(fn) {
    return (0, $jCxri.wrap)(fn)();
}
function $13087c0028ca9729$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $13087c0028ca9729$var$startSessionTracking() {
    var window = (0, $faeBy.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $kObcn.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $13087c0028ca9729$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $gxSvp.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $13087c0028ca9729$var$startSessionOnHub((0, $kObcn.getCurrentHub)());
    });
}

});
parcelRegister("6k1Bx", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $49a5daf6d2c38857$export$5333c3f1c58d9bc1);

var $kObcn = parcelRequire("kObcn");
parcelRequire("9M5tS");
var $bfMNh = parcelRequire("bfMNh");

var $5hDuh = parcelRequire("5hDuh");
function $49a5daf6d2c38857$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $5hDuh.IS_DEBUG_BUILD) (0, $bfMNh.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $kObcn.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("9M5tS", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("71dWo")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("bn3Qd")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("bn3Qd")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("lebt9")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("lebt9")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("6Mvy8")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("faeBy")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("gxSvp")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("13jtF")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("13jtF")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("13jtF")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("13jtF")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("13jtF")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("13jtF")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("13jtF")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("13jtF")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("13jtF")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("13jtF")).isThenable);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("bfMNh")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("bfMNh")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("5s4cI")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("5s4cI")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("5s4cI")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("5s4cI")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("5s4cI")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("5s4cI")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("lNdH5")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("lNdH5")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("iuyb9")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("iuyb9")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("iuyb9")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("iuyb9")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("iuyb9")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("iuyb9")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("7Xe34")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("kdnv0")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("lM8QO")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("lM8QO")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("aMG5L")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("8Qyzc")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("8Qyzc")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("8Qyzc")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("5MpRJ")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("5MpRJ")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("5MpRJ")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("IakcK")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("IakcK")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("IakcK")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("1hGZu")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("1hGZu")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("1hGZu")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("FldJJ")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("3Vdd6")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("3Vdd6")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("3Vdd6")).updateRateLimits);
parcelRequire("71dWo");
parcelRequire("bn3Qd");
parcelRequire("lebt9");

parcelRequire("6Mvy8");
parcelRequire("faeBy");
parcelRequire("gxSvp");
parcelRequire("13jtF");
parcelRequire("bfMNh");

parcelRequire("5s4cI");

var $efOxq = parcelRequire("efOxq");
parcelRequire("lNdH5");
parcelRequire("iuyb9");

parcelRequire("7Xe34");
parcelRequire("kdnv0");
parcelRequire("lM8QO");
parcelRequire("aMG5L");
parcelRequire("8Qyzc");
parcelRequire("5MpRJ");
parcelRequire("IakcK");

var $ax9nW = parcelRequire("ax9nW");


parcelRequire("1hGZu");
parcelRequire("FldJJ");
parcelRequire("3Vdd6");
$parcel$exportWildcard(module.exports, $efOxq);
$parcel$exportWildcard(module.exports, $ax9nW);

});
parcelRegister("71dWo", function(module, exports) {
$parcel$export(module.exports, "forget", () => $51c370bd269dd782$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51c370bd269dd782$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("bn3Qd", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $8474d27d6a4e37e7$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $8474d27d6a4e37e7$export$1cfafeee2987818b);

var $faeBy = parcelRequire("faeBy");

var $13jtF = parcelRequire("13jtF");
function $8474d27d6a4e37e7$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8474d27d6a4e37e7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8474d27d6a4e37e7$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $13jtF.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $8474d27d6a4e37e7$export$1cfafeee2987818b() {
    var global = (0, $faeBy.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("faeBy", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $b0a31e63cd10148e$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $b0a31e63cd10148e$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $efOxq = parcelRequire("efOxq");
var $b0a31e63cd10148e$var$fallbackGlobalObject = {};
function $b0a31e63cd10148e$export$256479dc0cea61c4() {
    return (0, $efOxq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $b0a31e63cd10148e$var$fallbackGlobalObject;
}
function $b0a31e63cd10148e$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $b0a31e63cd10148e$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("efOxq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $OmRdr = parcelRequire("OmRdr");

var $igDjg = parcelRequire("igDjg");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $OmRdr.isBrowserBundle)() && Object.prototype.toString.call(typeof $igDjg !== 'undefined' ? $igDjg : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("OmRdr", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $0976669d38ceaeb3$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0976669d38ceaeb3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("13jtF", function(module, exports) {
$parcel$export(module.exports, "isError", () => $0c452e17d185028e$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $0c452e17d185028e$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $0c452e17d185028e$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $0c452e17d185028e$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $0c452e17d185028e$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $0c452e17d185028e$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $0c452e17d185028e$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $0c452e17d185028e$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $0c452e17d185028e$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $0c452e17d185028e$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $0c452e17d185028e$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $0c452e17d185028e$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $0c452e17d185028e$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $0c452e17d185028e$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $0c452e17d185028e$var$objectToString = Object.prototype.toString;
function $0c452e17d185028e$export$e6127cc7fe7395c3(wat) {
    switch($0c452e17d185028e$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $0c452e17d185028e$export$49034edbe6b62415(wat, Error);
    }
}
function $0c452e17d185028e$var$isBuiltin(wat, ty) {
    return $0c452e17d185028e$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $0c452e17d185028e$export$9f9636d330b71954(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'ErrorEvent');
}
function $0c452e17d185028e$export$ef9e2056653f0c8e(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'DOMError');
}
function $0c452e17d185028e$export$12e869b2a583f783(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'DOMException');
}
function $0c452e17d185028e$export$844ec244b1367d54(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'String');
}
function $0c452e17d185028e$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $0c452e17d185028e$export$53b83ca8eaab0383(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'Object');
}
function $0c452e17d185028e$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $0c452e17d185028e$export$49034edbe6b62415(wat, Event);
}
function $0c452e17d185028e$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $0c452e17d185028e$export$49034edbe6b62415(wat, Element);
}
function $0c452e17d185028e$export$49841c62b9eff15(wat) {
    return $0c452e17d185028e$var$isBuiltin(wat, 'RegExp');
}
function $0c452e17d185028e$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $0c452e17d185028e$export$bc2894c7158efbac(wat) {
    return $0c452e17d185028e$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $0c452e17d185028e$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $0c452e17d185028e$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("lebt9", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $f743cd58804c5e98$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $f743cd58804c5e98$export$128827c3562ec0cb);

var $dnskZ = parcelRequire("dnskZ");

var $6Mvy8 = parcelRequire("6Mvy8");

var $fzgli = parcelRequire("fzgli");
/** Regular expression used to parse a Dsn. */ var $f743cd58804c5e98$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f743cd58804c5e98$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $f743cd58804c5e98$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $f743cd58804c5e98$var$dsnFromString(str) {
    var match = $f743cd58804c5e98$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $6Mvy8.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $dnskZ.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f743cd58804c5e98$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f743cd58804c5e98$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $f743cd58804c5e98$var$validateDsn(dsn) {
    if (!(0, $fzgli.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $6Mvy8.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $6Mvy8.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$f743cd58804c5e98$var$isValidProtocol(protocol)) throw new (0, $6Mvy8.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $6Mvy8.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $f743cd58804c5e98$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $f743cd58804c5e98$var$dsnFromString(from) : $f743cd58804c5e98$var$dsnFromComponents(from);
    $f743cd58804c5e98$var$validateDsn(components);
    return components;
}

});
parcelRegister("6Mvy8", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $4effb2e17a43acac$export$5949942ba2a7c0e2);

var $dnskZ = parcelRequire("dnskZ");

var $dmGsa = parcelRequire("dmGsa");
/** An error emitted by Sentry SDKs and related utilities. */ var $4effb2e17a43acac$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $dmGsa.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("dmGsa", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $9bae42c9dba809a9$export$1cb0d91350beb6cc);
var $9bae42c9dba809a9$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $9bae42c9dba809a9$var$setProtoOf : $9bae42c9dba809a9$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9bae42c9dba809a9$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9bae42c9dba809a9$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("fzgli", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $b556cd2ac8bf3928$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $b556cd2ac8bf3928$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("gxSvp", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $c0ba02121747460a$export$285b9172a3741fb7);

var $dnskZ = parcelRequire("dnskZ");

var $fzgli = parcelRequire("fzgli");

var $faeBy = parcelRequire("faeBy");

var $13jtF = parcelRequire("13jtF");

var $bfMNh = parcelRequire("bfMNh");

var $iuyb9 = parcelRequire("iuyb9");

var $lM8QO = parcelRequire("lM8QO");

var $5MpRJ = parcelRequire("5MpRJ");
var $c0ba02121747460a$var$global = (0, $faeBy.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $c0ba02121747460a$var$handlers = {};
var $c0ba02121747460a$var$instrumented = {};
/** Instruments given API */ function $c0ba02121747460a$var$instrument(type) {
    if ($c0ba02121747460a$var$instrumented[type]) return;
    $c0ba02121747460a$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $c0ba02121747460a$var$instrumentConsole();
            break;
        case 'dom':
            $c0ba02121747460a$var$instrumentDOM();
            break;
        case 'xhr':
            $c0ba02121747460a$var$instrumentXHR();
            break;
        case 'fetch':
            $c0ba02121747460a$var$instrumentFetch();
            break;
        case 'history':
            $c0ba02121747460a$var$instrumentHistory();
            break;
        case 'error':
            $c0ba02121747460a$var$instrumentError();
            break;
        case 'unhandledrejection':
            $c0ba02121747460a$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $fzgli.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $c0ba02121747460a$export$285b9172a3741fb7(type, callback) {
    $c0ba02121747460a$var$handlers[type] = $c0ba02121747460a$var$handlers[type] || [];
    $c0ba02121747460a$var$handlers[type].push(callback);
    $c0ba02121747460a$var$instrument(type);
}
/** JSDoc */ function $c0ba02121747460a$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$c0ba02121747460a$var$handlers[type]) return;
    try {
        for(var _b = (0, $dnskZ.__values)($c0ba02121747460a$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $fzgli.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $lM8QO.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $c0ba02121747460a$var$instrumentConsole() {
    if (!('console' in $c0ba02121747460a$var$global)) return;
    (0, $bfMNh.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $c0ba02121747460a$var$global.console)) return;
        (0, $iuyb9.fill)($c0ba02121747460a$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $c0ba02121747460a$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($c0ba02121747460a$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $c0ba02121747460a$var$instrumentFetch() {
    if (!(0, $5MpRJ.supportsNativeFetch)()) return;
    (0, $iuyb9.fill)($c0ba02121747460a$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $c0ba02121747460a$var$getFetchMethod(args),
                    url: $c0ba02121747460a$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $c0ba02121747460a$var$triggerHandlers('fetch', (0, $dnskZ.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($c0ba02121747460a$var$global, args).then(function(response) {
                $c0ba02121747460a$var$triggerHandlers('fetch', (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $c0ba02121747460a$var$triggerHandlers('fetch', (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $c0ba02121747460a$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $c0ba02121747460a$var$global && (0, $13jtF.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $c0ba02121747460a$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $c0ba02121747460a$var$global && (0, $13jtF.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $c0ba02121747460a$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $c0ba02121747460a$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $iuyb9.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $13jtF.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $13jtF.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $c0ba02121747460a$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $iuyb9.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $iuyb9.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $c0ba02121747460a$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $c0ba02121747460a$var$lastHref;
/** JSDoc */ function $c0ba02121747460a$var$instrumentHistory() {
    if (!(0, $5MpRJ.supportsHistory)()) return;
    var oldOnPopState = $c0ba02121747460a$var$global.onpopstate;
    $c0ba02121747460a$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $c0ba02121747460a$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $c0ba02121747460a$var$lastHref;
        $c0ba02121747460a$var$lastHref = to;
        $c0ba02121747460a$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $c0ba02121747460a$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $c0ba02121747460a$var$lastHref = to;
                $c0ba02121747460a$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $iuyb9.fill)($c0ba02121747460a$var$global.history, 'pushState', historyReplacementFunction);
    (0, $iuyb9.fill)($c0ba02121747460a$var$global.history, 'replaceState', historyReplacementFunction);
}
var $c0ba02121747460a$var$debounceDuration = 1000;
var $c0ba02121747460a$var$debounceTimerID;
var $c0ba02121747460a$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $c0ba02121747460a$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c0ba02121747460a$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $c0ba02121747460a$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $c0ba02121747460a$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($c0ba02121747460a$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($c0ba02121747460a$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c0ba02121747460a$var$lastCapturedEvent = event;
        } else if ($c0ba02121747460a$var$shouldShortcircuitPreviousDebounce($c0ba02121747460a$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $c0ba02121747460a$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c0ba02121747460a$var$debounceTimerID);
        $c0ba02121747460a$var$debounceTimerID = $c0ba02121747460a$var$global.setTimeout(function() {
            $c0ba02121747460a$var$debounceTimerID = undefined;
        }, $c0ba02121747460a$var$debounceDuration);
    };
}
/** JSDoc */ function $c0ba02121747460a$var$instrumentDOM() {
    if (!('document' in $c0ba02121747460a$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $c0ba02121747460a$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $c0ba02121747460a$var$makeDOMEventHandler(triggerDOMHandler, true);
    $c0ba02121747460a$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $c0ba02121747460a$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $c0ba02121747460a$var$global[target] && $c0ba02121747460a$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $iuyb9.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $c0ba02121747460a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $iuyb9.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $c0ba02121747460a$var$_oldOnErrorHandler = null;
/** JSDoc */ function $c0ba02121747460a$var$instrumentError() {
    $c0ba02121747460a$var$_oldOnErrorHandler = $c0ba02121747460a$var$global.onerror;
    $c0ba02121747460a$var$global.onerror = function(msg, url, line, column, error) {
        $c0ba02121747460a$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($c0ba02121747460a$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $c0ba02121747460a$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $c0ba02121747460a$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $c0ba02121747460a$var$instrumentUnhandledRejection() {
    $c0ba02121747460a$var$_oldOnUnhandledRejectionHandler = $c0ba02121747460a$var$global.onunhandledrejection;
    $c0ba02121747460a$var$global.onunhandledrejection = function(e) {
        $c0ba02121747460a$var$triggerHandlers('unhandledrejection', e);
        if ($c0ba02121747460a$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $c0ba02121747460a$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("bfMNh", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $8316f1dba9e8f335$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $8316f1dba9e8f335$export$af88d00dbe7f521);

var $dnskZ = parcelRequire("dnskZ");

var $fzgli = parcelRequire("fzgli");

var $faeBy = parcelRequire("faeBy");
// TODO: Implement different loggers for different environments
var $8316f1dba9e8f335$var$global = (0, $faeBy.getGlobalObject)();
/** Prefix for logging strings */ var $8316f1dba9e8f335$var$PREFIX = 'Sentry Logger ';
var $8316f1dba9e8f335$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $8316f1dba9e8f335$export$cda52e2a8927a2ca(callback) {
    var global = (0, $faeBy.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $8316f1dba9e8f335$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $8316f1dba9e8f335$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $fzgli.IS_DEBUG_BUILD) $8316f1dba9e8f335$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $8316f1dba9e8f335$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $8316f1dba9e8f335$var$global.console)[name].apply(_a, (0, $dnskZ.__spread)([
                    $8316f1dba9e8f335$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $8316f1dba9e8f335$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $8316f1dba9e8f335$export$af88d00dbe7f521;
if (0, $fzgli.IS_DEBUG_BUILD) $8316f1dba9e8f335$export$af88d00dbe7f521 = (0, $faeBy.getGlobalSingleton)('logger', $8316f1dba9e8f335$var$makeLogger);
else $8316f1dba9e8f335$export$af88d00dbe7f521 = $8316f1dba9e8f335$var$makeLogger();

});

parcelRegister("iuyb9", function(module, exports) {
$parcel$export(module.exports, "fill", () => $d7658a88455069a1$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $d7658a88455069a1$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $d7658a88455069a1$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $d7658a88455069a1$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $d7658a88455069a1$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $d7658a88455069a1$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $d7658a88455069a1$export$b0244d5063c0b61b);

var $dnskZ = parcelRequire("dnskZ");

var $bn3Qd = parcelRequire("bn3Qd");

var $13jtF = parcelRequire("13jtF");

var $8Qyzc = parcelRequire("8Qyzc");
function $d7658a88455069a1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $d7658a88455069a1$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $d7658a88455069a1$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $d7658a88455069a1$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $d7658a88455069a1$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $d7658a88455069a1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $d7658a88455069a1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $d7658a88455069a1$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $13jtF.isError)(value)) newObj = (0, $dnskZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $d7658a88455069a1$var$getOwnProperties(value));
    else if ((0, $13jtF.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $dnskZ.__assign)({
            type: event_1.type,
            target: $d7658a88455069a1$var$serializeEventTarget(event_1.target),
            currentTarget: $d7658a88455069a1$var$serializeEventTarget(event_1.currentTarget)
        }, $d7658a88455069a1$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $13jtF.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $d7658a88455069a1$var$serializeEventTarget(target) {
    try {
        return (0, $13jtF.isElement)(target) ? (0, $bn3Qd.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d7658a88455069a1$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $d7658a88455069a1$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($d7658a88455069a1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $8Qyzc.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $8Qyzc.truncate)(serialized, maxLength);
    }
    return '';
}
function $d7658a88455069a1$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $13jtF.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $dnskZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $d7658a88455069a1$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($d7658a88455069a1$export$d25f2688db1bb433);
    return val;
}
function $d7658a88455069a1$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $13jtF.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("8Qyzc", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $670dfe4e4646a6cb$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $670dfe4e4646a6cb$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $670dfe4e4646a6cb$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $670dfe4e4646a6cb$export$cdded5b28a5f8c6d);

var $13jtF = parcelRequire("13jtF");
function $670dfe4e4646a6cb$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $670dfe4e4646a6cb$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $670dfe4e4646a6cb$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $670dfe4e4646a6cb$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $13jtF.isString)(value)) return false;
    if ((0, $13jtF.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $670dfe4e4646a6cb$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("lM8QO", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $fda4f23b2c122ccd$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $fda4f23b2c122ccd$export$aad197c7121a6651);

var $dnskZ = parcelRequire("dnskZ");
var $fda4f23b2c122ccd$var$STACKTRACE_LIMIT = 50;
function $fda4f23b2c122ccd$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $dnskZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $dnskZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $fda4f23b2c122ccd$export$c55c24c0eeba0205(frames);
    };
}
function $fda4f23b2c122ccd$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $fda4f23b2c122ccd$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $fda4f23b2c122ccd$var$defaultFunctionName = '<anonymous>';
function $fda4f23b2c122ccd$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $fda4f23b2c122ccd$var$defaultFunctionName;
        return fn.name || $fda4f23b2c122ccd$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $fda4f23b2c122ccd$var$defaultFunctionName;
    }
}

});

parcelRegister("5MpRJ", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $43557fcc1a7e8ae0$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $43557fcc1a7e8ae0$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $43557fcc1a7e8ae0$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $43557fcc1a7e8ae0$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $43557fcc1a7e8ae0$export$67fc34576016d6ec);

var $fzgli = parcelRequire("fzgli");

var $faeBy = parcelRequire("faeBy");

var $bfMNh = parcelRequire("bfMNh");
function $43557fcc1a7e8ae0$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $43557fcc1a7e8ae0$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $43557fcc1a7e8ae0$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $43557fcc1a7e8ae0$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $faeBy.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $43557fcc1a7e8ae0$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $43557fcc1a7e8ae0$export$c82d238e23c40b21() {
    if (!$43557fcc1a7e8ae0$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $faeBy.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($43557fcc1a7e8ae0$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $43557fcc1a7e8ae0$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fzgli.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $43557fcc1a7e8ae0$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $faeBy.getGlobalObject)();
}
function $43557fcc1a7e8ae0$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$43557fcc1a7e8ae0$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $43557fcc1a7e8ae0$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $faeBy.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("5s4cI", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $3f82d41ac5cd17bb$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $3f82d41ac5cd17bb$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $3f82d41ac5cd17bb$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $3f82d41ac5cd17bb$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $3f82d41ac5cd17bb$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $3f82d41ac5cd17bb$export$6de4ffac6a2f1098);

var $dnskZ = parcelRequire("dnskZ");

var $faeBy = parcelRequire("faeBy");

var $iuyb9 = parcelRequire("iuyb9");

var $8Qyzc = parcelRequire("8Qyzc");
function $3f82d41ac5cd17bb$export$19f53698e68b2496() {
    var global = (0, $faeBy.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $3f82d41ac5cd17bb$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $3f82d41ac5cd17bb$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $3f82d41ac5cd17bb$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $3f82d41ac5cd17bb$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $3f82d41ac5cd17bb$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $3f82d41ac5cd17bb$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $3f82d41ac5cd17bb$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $3f82d41ac5cd17bb$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $3f82d41ac5cd17bb$export$d364f2020ab30578(input) {
    var match = input.match($3f82d41ac5cd17bb$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $3f82d41ac5cd17bb$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $8Qyzc.snipLine)(line, 0);
    });
    frame.context_line = (0, $8Qyzc.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $8Qyzc.snipLine)(line, 0);
    });
}
function $3f82d41ac5cd17bb$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $3f82d41ac5cd17bb$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $iuyb9.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("lNdH5", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $fdd8cbea2371cba7$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $fdd8cbea2371cba7$export$23fbbb20bed71033);

var $dnskZ = parcelRequire("dnskZ");

var $13jtF = parcelRequire("13jtF");

var $304z8 = parcelRequire("304z8");

var $iuyb9 = parcelRequire("iuyb9");

var $lM8QO = parcelRequire("lM8QO");
function $fdd8cbea2371cba7$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $fdd8cbea2371cba7$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $fdd8cbea2371cba7$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $fdd8cbea2371cba7$export$a3295358bff77e(object, depth);
    if ($fdd8cbea2371cba7$var$jsonSize(normalized) > maxSize) return $fdd8cbea2371cba7$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $fdd8cbea2371cba7$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $304z8.memoBuilder)();
    var _a = (0, $dnskZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $13jtF.isNaN)(value)) return value;
    var stringified = $fdd8cbea2371cba7$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $13jtF.isError)(value) || (0, $13jtF.isEvent)(value) ? (0, $iuyb9.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $fdd8cbea2371cba7$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $fdd8cbea2371cba7$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $13jtF.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $lM8QO.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $fdd8cbea2371cba7$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $fdd8cbea2371cba7$var$jsonSize(value) {
    return $fdd8cbea2371cba7$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("304z8", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $22f4e9d11c96483b$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $22f4e9d11c96483b$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("7Xe34", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $5ca8f0d8ea4cca2f$export$85a4f67f852183e6);

var $6Mvy8 = parcelRequire("6Mvy8");

var $IakcK = parcelRequire("IakcK");
function $5ca8f0d8ea4cca2f$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $IakcK.rejectedSyncPromise)(new (0, $6Mvy8.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $IakcK.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $IakcK.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("IakcK", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $084c1e7b6263847c$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $084c1e7b6263847c$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $084c1e7b6263847c$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $13jtF = parcelRequire("13jtF");
function $084c1e7b6263847c$export$1fda8aa4d135f8aa(value) {
    return new $084c1e7b6263847c$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $084c1e7b6263847c$export$78e43115b553f358(reason) {
    return new $084c1e7b6263847c$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $084c1e7b6263847c$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $13jtF.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("kdnv0", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $eb773ff46ecf55b9$export$e01cef29b4327697);

var $lHwN4 = parcelRequire("lHwN4");

var $27GBI = parcelRequire("27GBI");
function $eb773ff46ecf55b9$var$isSupportedSeverity(level) {
    return (0, $27GBI.SeverityLevels).indexOf(level) !== -1;
}
function $eb773ff46ecf55b9$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $lHwN4.Severity).Warning;
    if ($eb773ff46ecf55b9$var$isSupportedSeverity(level)) return level;
    return (0, $lHwN4.Severity).Log;
}

});
parcelRegister("lHwN4", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $fcc70c9f0fe834da$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $fcc70c9f0fe834da$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($fcc70c9f0fe834da$export$918a9776c0a3cf27 || ($fcc70c9f0fe834da$export$918a9776c0a3cf27 = {}));
var $fcc70c9f0fe834da$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("27GBI", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $18bd4923541c8c87$export$484b1ea9aec914c);
var $18bd4923541c8c87$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("aMG5L", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $7d9f09a521c15a2d$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $7d9f09a521c15a2d$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("ax9nW", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $faeBy = parcelRequire("faeBy");

var $efOxq = parcelRequire("efOxq");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $faeBy.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $efOxq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $efOxq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $faeBy.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("1hGZu", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $0ef8ba1262c565a2$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $0ef8ba1262c565a2$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $0ef8ba1262c565a2$export$32f9b428425aac85);

var $dnskZ = parcelRequire("dnskZ");

var $13jtF = parcelRequire("13jtF");
function $0ef8ba1262c565a2$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $0ef8ba1262c565a2$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $dnskZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $dnskZ.__spread)(items, [
            newItem
        ])
    ];
}
function $0ef8ba1262c565a2$export$d84939284bbafcd4(envelope) {
    var _a = (0, $dnskZ.__read)(envelope, 2), _b = (0, $dnskZ.__read)(_a[1], 1), _c = (0, $dnskZ.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $0ef8ba1262c565a2$export$32f9b428425aac85(envelope) {
    var _a = (0, $dnskZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $dnskZ.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $13jtF.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("FldJJ", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $07c44a6940e2b267$export$f3b9ed77c03eeb00);

var $1hGZu = parcelRequire("1hGZu");

var $ax9nW = parcelRequire("ax9nW");
function $07c44a6940e2b267$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $ax9nW.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $1hGZu.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("3Vdd6", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $2db0f141fb2624ee$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $2db0f141fb2624ee$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $2db0f141fb2624ee$export$699aff705e0d49d4);

var $dnskZ = parcelRequire("dnskZ");
var $2db0f141fb2624ee$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $2db0f141fb2624ee$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $2db0f141fb2624ee$export$b09ce39faaeb1e7c;
}
function $2db0f141fb2624ee$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $2db0f141fb2624ee$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $2db0f141fb2624ee$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $2db0f141fb2624ee$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $dnskZ.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $dnskZ.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $dnskZ.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $2db0f141fb2624ee$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("5hDuh", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $3d8d2bac37e4bf55$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $3d8d2bac37e4bf55$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("3xJqq", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("ARgcG")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("84Wwk")).InboundFilters);

var $ARgcG = parcelRequire("ARgcG");

var $84Wwk = parcelRequire("84Wwk");

});
parcelRegister("ARgcG", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $06ecad4d9f9d5e05$export$da4704525c20ae79);
parcelRequire("9M5tS");
var $iuyb9 = parcelRequire("iuyb9");
var $06ecad4d9f9d5e05$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $06ecad4d9f9d5e05$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $06ecad4d9f9d5e05$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $iuyb9.getOriginalFunction)(this) || this;
            return $06ecad4d9f9d5e05$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("84Wwk", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $5e1c176598a0c920$export$2ffbb5359dcc6be4);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $5s4cI = parcelRequire("5s4cI");
var $8Qyzc = parcelRequire("8Qyzc");
var $bfMNh = parcelRequire("bfMNh");

var $5hDuh = parcelRequire("5hDuh");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $5e1c176598a0c920$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $5e1c176598a0c920$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $5e1c176598a0c920$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $5e1c176598a0c920$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $5e1c176598a0c920$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $dnskZ.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $dnskZ.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $dnskZ.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $5e1c176598a0c920$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5e1c176598a0c920$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $5e1c176598a0c920$var$_isSentryError(event)) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $5s4cI.getEventDescription)(event));
        return true;
    }
    if ($5e1c176598a0c920$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $5s4cI.getEventDescription)(event));
        return true;
    }
    if ($5e1c176598a0c920$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $5s4cI.getEventDescription)(event) + ".\nUrl: " + $5e1c176598a0c920$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$5e1c176598a0c920$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $5s4cI.getEventDescription)(event) + ".\nUrl: " + $5e1c176598a0c920$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $5e1c176598a0c920$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $5e1c176598a0c920$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $8Qyzc.isMatchingPattern)(message, pattern);
        });
    });
}
function $5e1c176598a0c920$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $5e1c176598a0c920$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $8Qyzc.isMatchingPattern)(url, pattern);
    });
}
function $5e1c176598a0c920$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $5e1c176598a0c920$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $8Qyzc.isMatchingPattern)(url, pattern);
    });
}
function $5e1c176598a0c920$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error("Cannot extract message for event " + (0, $5s4cI.getEventDescription)(event));
        return [];
    }
    return [];
}
function $5e1c176598a0c920$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5e1c176598a0c920$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5e1c176598a0c920$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $5e1c176598a0c920$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $5e1c176598a0c920$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error("Cannot extract url for event " + (0, $5s4cI.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("5VxHJ", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $450c6b9a3fcbe554$export$1df9218a526d318d);

var $dnskZ = parcelRequire("dnskZ");

var $gwf5J = parcelRequire("gwf5J");
var $1uq7s = parcelRequire("1uq7s");
parcelRequire("9M5tS");
var $faeBy = parcelRequire("faeBy");
var $bfMNh = parcelRequire("bfMNh");

var $iS6GD = parcelRequire("iS6GD");

var $ey2qH = parcelRequire("ey2qH");

var $jCxri = parcelRequire("jCxri");

var $2rSpj = parcelRequire("2rSpj");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $450c6b9a3fcbe554$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $1uq7s.SDK_VERSION)
                }
            ],
            version: (0, $1uq7s.SDK_VERSION)
        };
        _this = _super.call(this, (0, $iS6GD.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $faeBy.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $jCxri.injectReportDialog)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $2rSpj.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $gwf5J.BaseClient));

});
parcelRegister("gwf5J", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $c06b575a7dc650e8$export$4f22f74eddb7716a);

var $dnskZ = parcelRequire("dnskZ");

var $e58Qh = parcelRequire("e58Qh");
parcelRequire("9M5tS");
var $5s4cI = parcelRequire("5s4cI");
var $ax9nW = parcelRequire("ax9nW");
var $13jtF = parcelRequire("13jtF");
var $bfMNh = parcelRequire("bfMNh");
var $lebt9 = parcelRequire("lebt9");
var $lNdH5 = parcelRequire("lNdH5");
var $IakcK = parcelRequire("IakcK");
var $6Mvy8 = parcelRequire("6Mvy8");
var $8Qyzc = parcelRequire("8Qyzc");

var $5hDuh = parcelRequire("5hDuh");

var $2h0Fb = parcelRequire("2h0Fb");
var $c06b575a7dc650e8$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $c06b575a7dc650e8$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $lebt9.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $5s4cI.checkOrSetAlreadyCaught)(exception)) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log($c06b575a7dc650e8$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $13jtF.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $5s4cI.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log($c06b575a7dc650e8$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $2h0Fb.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $dnskZ.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $IakcK.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $5s4cI.uuid4)()),
            timestamp: event.timestamp || (0, $ax9nW.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $e58Qh.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $IakcK.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $lNdH5.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, b), b.data && {
                    data: (0, $lNdH5.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $lNdH5.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $lNdH5.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $lNdH5.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $8Qyzc.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $8Qyzc.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $8Qyzc.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $dnskZ.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $IakcK.rejectedSyncPromise)(new (0, $6Mvy8.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $IakcK.rejectedSyncPromise)(new (0, $6Mvy8.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $6Mvy8.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $c06b575a7dc650e8$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $6Mvy8.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $6Mvy8.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $6Mvy8.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $c06b575a7dc650e8$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $13jtF.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $13jtF.isPlainObject)(event) || event === null)) throw new (0, $6Mvy8.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $6Mvy8.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $13jtF.isPlainObject)(rv) || rv === null)) throw new (0, $6Mvy8.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("2h0Fb", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $1a7daefdb427c3b7$export$51abed9797baa598);

var $dnskZ = parcelRequire("dnskZ");

var $e58Qh = parcelRequire("e58Qh");
var $kObcn = parcelRequire("kObcn");
parcelRequire("9M5tS");
var $iuyb9 = parcelRequire("iuyb9");
var $bfMNh = parcelRequire("bfMNh");

var $5hDuh = parcelRequire("5hDuh");
var $1a7daefdb427c3b7$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $1a7daefdb427c3b7$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $1a7daefdb427c3b7$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $dnskZ.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $dnskZ.__spread)($1a7daefdb427c3b7$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $dnskZ.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $1a7daefdb427c3b7$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $dnskZ.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $1a7daefdb427c3b7$export$e7390a03b70a6f2f(integration) {
    if ($1a7daefdb427c3b7$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $e58Qh.addGlobalEventProcessor), (0, $kObcn.getCurrentHub));
    $1a7daefdb427c3b7$export$b14a8888f80a0b3e.push(integration.name);
    (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log("Integration installed: " + integration.name);
}
function $1a7daefdb427c3b7$export$51abed9797baa598(options) {
    var integrations = {};
    $1a7daefdb427c3b7$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $1a7daefdb427c3b7$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $iuyb9.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("1uq7s", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $115cda8d8dfa75a1$export$31499a9cd224b78c);
var $115cda8d8dfa75a1$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("iS6GD", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $dbd274f9bbdf0e7f$export$2526e21aec9d0ce7);

var $dnskZ = parcelRequire("dnskZ");

var $2cfNa = parcelRequire("2cfNa");
var $7k3ZH = parcelRequire("7k3ZH");

var $lHwN4 = parcelRequire("lHwN4");
parcelRequire("9M5tS");
var $5MpRJ = parcelRequire("5MpRJ");

var $atdG9 = parcelRequire("atdG9");

var $kczB2 = parcelRequire("kczB2");
var $ll93g = parcelRequire("ll93g");
var $38tXO = parcelRequire("38tXO");
var $8mZKF = parcelRequire("8mZKF");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $dbd274f9bbdf0e7f$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $atdG9.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $lHwN4.Severity).Info;
        return (0, $atdG9.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $7k3ZH.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $7k3ZH.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $5MpRJ.supportsFetch)()) {
            var requestOptions = (0, $dnskZ.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $ll93g.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $kczB2.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $38tXO.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $8mZKF.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $2cfNa.BaseBackend));

});
parcelRegister("2cfNa", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $1998f3bf6b354791$export$8f43a53a38d7e95f);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $bfMNh = parcelRequire("bfMNh");
var $6Mvy8 = parcelRequire("6Mvy8");

var $7k3ZH = parcelRequire("7k3ZH");

var $5hDuh = parcelRequire("5hDuh");

var $doJFF = parcelRequire("doJFF");

var $eENxR = parcelRequire("eENxR");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $1998f3bf6b354791$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $6Mvy8.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $6Mvy8.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $7k3ZH.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $doJFF.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $7k3ZH.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $dnskZ.__read)((0, $doJFF.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $5hDuh.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $eENxR.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("7k3ZH", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $554d7fd2aab3d9c0$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $554d7fd2aab3d9c0$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $554d7fd2aab3d9c0$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $554d7fd2aab3d9c0$export$671c7ed8e40a7a57);
parcelRequire("9M5tS");
var $lebt9 = parcelRequire("lebt9");
var $iuyb9 = parcelRequire("iuyb9");
var $554d7fd2aab3d9c0$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $554d7fd2aab3d9c0$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $lebt9.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $554d7fd2aab3d9c0$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $554d7fd2aab3d9c0$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $554d7fd2aab3d9c0$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $554d7fd2aab3d9c0$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $554d7fd2aab3d9c0$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $lebt9.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $554d7fd2aab3d9c0$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $554d7fd2aab3d9c0$var$_getIngestEndpoint(dsn, target) {
    return "" + $554d7fd2aab3d9c0$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $554d7fd2aab3d9c0$var$_encodedAuth(dsn) {
    return (0, $iuyb9.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $554d7fd2aab3d9c0$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $554d7fd2aab3d9c0$var$getStoreEndpoint(dsn) {
    return $554d7fd2aab3d9c0$var$_getIngestEndpoint(dsn, 'store');
}
function $554d7fd2aab3d9c0$export$c1677e22ac2217a5(dsn) {
    return $554d7fd2aab3d9c0$var$getStoreEndpoint(dsn) + "?" + $554d7fd2aab3d9c0$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $554d7fd2aab3d9c0$var$_getEnvelopeEndpoint(dsn) {
    return $554d7fd2aab3d9c0$var$_getIngestEndpoint(dsn, 'envelope');
}
function $554d7fd2aab3d9c0$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $554d7fd2aab3d9c0$var$_getEnvelopeEndpoint(dsn) + "?" + $554d7fd2aab3d9c0$var$_encodedAuth(dsn);
}
function $554d7fd2aab3d9c0$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $554d7fd2aab3d9c0$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $554d7fd2aab3d9c0$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $lebt9.makeDsn)(dsnLike);
    var endpoint = $554d7fd2aab3d9c0$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $lebt9.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("doJFF", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $9c10f1938a89a227$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $9c10f1938a89a227$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $9c10f1938a89a227$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $9c10f1938a89a227$export$2006389de558b996);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $1hGZu = parcelRequire("1hGZu");
var $lebt9 = parcelRequire("lebt9");
var $lNdH5 = parcelRequire("lNdH5");

var $7k3ZH = parcelRequire("7k3ZH");
/** Extract sdk info from from the API metadata */ function $9c10f1938a89a227$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9c10f1938a89a227$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $dnskZ.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $dnskZ.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $9c10f1938a89a227$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $9c10f1938a89a227$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $lebt9.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $1hGZu.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $9c10f1938a89a227$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $dnskZ.__read)($9c10f1938a89a227$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $1hGZu.serializeEnvelope)(envelope),
        type: type,
        url: (0, $7k3ZH.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $9c10f1938a89a227$export$c31057337a18010f(event, api) {
    var sdkInfo = $9c10f1938a89a227$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c10f1938a89a227$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $lebt9.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $1hGZu.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $9c10f1938a89a227$export$2006389de558b996(event, api) {
    var sdkInfo = $9c10f1938a89a227$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9c10f1938a89a227$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $lNdH5.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $7k3ZH.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $7k3ZH.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $lebt9.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $1hGZu.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $1hGZu.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("eENxR", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $aabb3bbf056c1972$export$6f2767450ea1346c);
parcelRequire("9M5tS");
var $IakcK = parcelRequire("IakcK");
/** Noop transport */ var $aabb3bbf056c1972$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $IakcK.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $IakcK.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("atdG9", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $79f7392a30344dc6$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $79f7392a30344dc6$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $79f7392a30344dc6$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $79f7392a30344dc6$export$5425b53185d13d6c);

var $dnskZ = parcelRequire("dnskZ");

var $lHwN4 = parcelRequire("lHwN4");
parcelRequire("9M5tS");
var $5s4cI = parcelRequire("5s4cI");
var $lM8QO = parcelRequire("lM8QO");
var $iuyb9 = parcelRequire("iuyb9");
var $13jtF = parcelRequire("13jtF");
var $lNdH5 = parcelRequire("lNdH5");
var $IakcK = parcelRequire("IakcK");

var $7oEFR = parcelRequire("7oEFR");
function $79f7392a30344dc6$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $79f7392a30344dc6$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $79f7392a30344dc6$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $79f7392a30344dc6$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $13jtF.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $iuyb9.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $lNdH5.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $79f7392a30344dc6$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $79f7392a30344dc6$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $79f7392a30344dc6$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $79f7392a30344dc6$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $79f7392a30344dc6$var$getPopSize(ex);
    try {
        return (0, $lM8QO.createStackParser)((0, $7oEFR.opera10StackParser), (0, $7oEFR.opera11StackParser), (0, $7oEFR.chromeStackParser), (0, $7oEFR.winjsStackParser), (0, $7oEFR.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $79f7392a30344dc6$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $79f7392a30344dc6$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($79f7392a30344dc6$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $79f7392a30344dc6$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $79f7392a30344dc6$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $79f7392a30344dc6$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $5s4cI.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $lHwN4.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $IakcK.resolvedSyncPromise)(event);
}
function $79f7392a30344dc6$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $lHwN4.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $79f7392a30344dc6$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $IakcK.resolvedSyncPromise)(event);
}
function $79f7392a30344dc6$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $13jtF.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $79f7392a30344dc6$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $13jtF.isDOMError)(exception) || (0, $13jtF.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $79f7392a30344dc6$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $13jtF.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $79f7392a30344dc6$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $5s4cI.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $13jtF.isError)(exception)) // we have a real Error object, do nothing
    return $79f7392a30344dc6$export$73fbea5a0a5234af(exception);
    if ((0, $13jtF.isPlainObject)(exception) || (0, $13jtF.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $79f7392a30344dc6$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $5s4cI.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $79f7392a30344dc6$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $5s4cI.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $5s4cI.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $79f7392a30344dc6$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $79f7392a30344dc6$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("7oEFR", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $562a535479c95dfe$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $562a535479c95dfe$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $562a535479c95dfe$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $562a535479c95dfe$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $562a535479c95dfe$export$989a1824b4734ce6);

var $dnskZ = parcelRequire("dnskZ");
// global reference to slice
var $562a535479c95dfe$var$UNKNOWN_FUNCTION = '?';
var $562a535479c95dfe$var$OPERA10_PRIORITY = 10;
var $562a535479c95dfe$var$OPERA11_PRIORITY = 20;
var $562a535479c95dfe$var$CHROME_PRIORITY = 30;
var $562a535479c95dfe$var$WINJS_PRIORITY = 40;
var $562a535479c95dfe$var$GECKO_PRIORITY = 50;
function $562a535479c95dfe$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $562a535479c95dfe$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $562a535479c95dfe$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $562a535479c95dfe$var$chrome = function(line) {
    var parts = $562a535479c95dfe$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $562a535479c95dfe$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $dnskZ.__read)($562a535479c95dfe$var$extractSafariExtensionDetails(parts[1] || $562a535479c95dfe$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $562a535479c95dfe$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $562a535479c95dfe$export$c693d9295441d8f9 = [
    $562a535479c95dfe$var$CHROME_PRIORITY,
    $562a535479c95dfe$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $562a535479c95dfe$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $562a535479c95dfe$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $562a535479c95dfe$var$gecko = function(line) {
    var _a;
    var parts = $562a535479c95dfe$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $562a535479c95dfe$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $562a535479c95dfe$var$UNKNOWN_FUNCTION;
        _a = (0, $dnskZ.__read)($562a535479c95dfe$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $562a535479c95dfe$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $562a535479c95dfe$export$c9ddf1e2b5d48bff = [
    $562a535479c95dfe$var$GECKO_PRIORITY,
    $562a535479c95dfe$var$gecko
];
var $562a535479c95dfe$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $562a535479c95dfe$var$winjs = function(line) {
    var parts = $562a535479c95dfe$var$winjsRegex.exec(line);
    return parts ? $562a535479c95dfe$var$createFrame(parts[2], parts[1] || $562a535479c95dfe$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $562a535479c95dfe$export$b6d155d85c1dcba5 = [
    $562a535479c95dfe$var$WINJS_PRIORITY,
    $562a535479c95dfe$var$winjs
];
var $562a535479c95dfe$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $562a535479c95dfe$var$opera10 = function(line) {
    var parts = $562a535479c95dfe$var$opera10Regex.exec(line);
    return parts ? $562a535479c95dfe$var$createFrame(parts[2], parts[3] || $562a535479c95dfe$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $562a535479c95dfe$export$966ec832d9699d6 = [
    $562a535479c95dfe$var$OPERA10_PRIORITY,
    $562a535479c95dfe$var$opera10
];
var $562a535479c95dfe$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $562a535479c95dfe$var$opera11 = function(line) {
    var parts = $562a535479c95dfe$var$opera11Regex.exec(line);
    return parts ? $562a535479c95dfe$var$createFrame(parts[5], parts[3] || parts[4] || $562a535479c95dfe$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $562a535479c95dfe$export$989a1824b4734ce6 = [
    $562a535479c95dfe$var$OPERA11_PRIORITY,
    $562a535479c95dfe$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $562a535479c95dfe$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $562a535479c95dfe$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("kczB2", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $eb508a53754fe7d9$export$2bdee3f9b92f4e82);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $6Mvy8 = parcelRequire("6Mvy8");
var $5MpRJ = parcelRequire("5MpRJ");
var $IakcK = parcelRequire("IakcK");

var $f1KRk = parcelRequire("f1KRk");

var $dYA6W = parcelRequire("dYA6W");
/** `fetch` based transport */ var $eb508a53754fe7d9$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $dYA6W.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $5MpRJ.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $IakcK.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $6Mvy8.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $f1KRk.BaseTransport));

});
parcelRegister("f1KRk", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $af0b4c3c3c91831c$export$74b99d619e90f481);

var $dnskZ = parcelRequire("dnskZ");

var $doJFF = parcelRequire("doJFF");
var $7k3ZH = parcelRequire("7k3ZH");
parcelRequire("9M5tS");
var $FldJJ = parcelRequire("FldJJ");
var $3Vdd6 = parcelRequire("3Vdd6");
var $lebt9 = parcelRequire("lebt9");
var $aMG5L = parcelRequire("aMG5L");
var $faeBy = parcelRequire("faeBy");
var $bfMNh = parcelRequire("bfMNh");
var $7Xe34 = parcelRequire("7Xe34");
var $1hGZu = parcelRequire("1hGZu");

var $ey2qH = parcelRequire("ey2qH");

var $dYA6W = parcelRequire("dYA6W");
function $af0b4c3c3c91831c$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $af0b4c3c3c91831c$var$global = (0, $faeBy.getGlobalObject)();
/** Base Transport class implementation */ var $af0b4c3c3c91831c$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $7Xe34.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $7k3ZH.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $7k3ZH.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $af0b4c3c3c91831c$var$global.document) $af0b4c3c3c91831c$var$global.document.addEventListener('visibilitychange', function() {
            if ($af0b4c3c3c91831c$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $doJFF.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $doJFF.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $af0b4c3c3c91831c$var$requestTypeToCategory(category) + ":" + reason;
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log('No outcomes to flush');
            return;
        }
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $7k3ZH.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $dnskZ.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $FldJJ.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $lebt9.dsnToString)(this._api.dsn));
        try {
            (0, $dYA6W.sendReport)(url, (0, $1hGZu.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $aMG5L.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $3Vdd6.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $ey2qH.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $bfMNh.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $af0b4c3c3c91831c$var$requestTypeToCategory(requestType);
        return new Date((0, $3Vdd6.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $af0b4c3c3c91831c$var$requestTypeToCategory(requestType);
        return (0, $3Vdd6.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("ey2qH", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a97620231cf376f0$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a97620231cf376f0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("dYA6W", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $a2cce3d85097160f$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $a2cce3d85097160f$export$84bb63b2c17ec44d);
parcelRequire("9M5tS");
var $71dWo = parcelRequire("71dWo");
var $faeBy = parcelRequire("faeBy");
var $5MpRJ = parcelRequire("5MpRJ");
var $bfMNh = parcelRequire("bfMNh");

var $ey2qH = parcelRequire("ey2qH");
var $a2cce3d85097160f$var$global = (0, $faeBy.getGlobalObject)();
var $a2cce3d85097160f$var$cachedFetchImpl;
function $a2cce3d85097160f$export$8be2119ce08e3379() {
    if ($a2cce3d85097160f$var$cachedFetchImpl) return $a2cce3d85097160f$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $5MpRJ.isNativeFetch)($a2cce3d85097160f$var$global.fetch)) return $a2cce3d85097160f$var$cachedFetchImpl = $a2cce3d85097160f$var$global.fetch.bind($a2cce3d85097160f$var$global);
    var document = $a2cce3d85097160f$var$global.document;
    var fetchImpl = $a2cce3d85097160f$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $a2cce3d85097160f$var$cachedFetchImpl = fetchImpl.bind($a2cce3d85097160f$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $a2cce3d85097160f$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($a2cce3d85097160f$var$global && $a2cce3d85097160f$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $a2cce3d85097160f$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $a2cce3d85097160f$var$global.navigator.sendBeacon.bind($a2cce3d85097160f$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $5MpRJ.supportsFetch)()) {
        var fetch_1 = $a2cce3d85097160f$export$8be2119ce08e3379();
        return (0, $71dWo.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("ll93g", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $f89294968eb96f84$export$1c57e6bfd09bad13);

var $dnskZ = parcelRequire("dnskZ");

var $AYEQn = parcelRequire("AYEQn");

var $dYA6W = parcelRequire("dYA6W");
function $f89294968eb96f84$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $dYA6W.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $dnskZ.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $AYEQn.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("AYEQn", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $06f26a46e2f3fdb2$export$d09f50d9ab7f7b69);
parcelRequire("9M5tS");
var $3Vdd6 = parcelRequire("3Vdd6");
var $aMG5L = parcelRequire("aMG5L");
var $1hGZu = parcelRequire("1hGZu");
var $7Xe34 = parcelRequire("7Xe34");
var $IakcK = parcelRequire("IakcK");
var $06f26a46e2f3fdb2$export$d8a725a7dce95622 = 'error';
var $06f26a46e2f3fdb2$export$99adc6fe67a3c63e = 'transaction';
var $06f26a46e2f3fdb2$export$9d7ad34f132fe68f = 'attachment';
var $06f26a46e2f3fdb2$export$42d9e7b5fc564c45 = 'session';
var $06f26a46e2f3fdb2$export$e515cf6dfd2f98b8 = 30;
function $06f26a46e2f3fdb2$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $7Xe34.makePromiseBuffer)(options.bufferSize || $06f26a46e2f3fdb2$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $1hGZu.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $1hGZu.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $3Vdd6.isRateLimited)(rateLimits, category)) return (0, $IakcK.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $06f26a46e2f3fdb2$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $aMG5L.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $3Vdd6.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $IakcK.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $IakcK.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $06f26a46e2f3fdb2$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $06f26a46e2f3fdb2$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $3Vdd6.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("38tXO", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $24895c9d8c5ac08d$export$4c0ac1dd4bbf4921);

var $AYEQn = parcelRequire("AYEQn");
parcelRequire("9M5tS");
var $IakcK = parcelRequire("IakcK");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $24895c9d8c5ac08d$var$XHR_READYSTATE_DONE = 4;
function $24895c9d8c5ac08d$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $IakcK.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $24895c9d8c5ac08d$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $AYEQn.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("8mZKF", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $6180476dab560405$export$874a283af77e8e62);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $6Mvy8 = parcelRequire("6Mvy8");
var $IakcK = parcelRequire("IakcK");

var $f1KRk = parcelRequire("f1KRk");
/** `XHR` based transport */ var $6180476dab560405$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $IakcK.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $6Mvy8.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $f1KRk.BaseTransport));

});


parcelRegister("jCxri", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $e48b8143bae273f0$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $e48b8143bae273f0$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $e48b8143bae273f0$export$deb9aac8ea0b576c);

var $dnskZ = parcelRequire("dnskZ");

var $gamVI = parcelRequire("gamVI");
var $7k3ZH = parcelRequire("7k3ZH");
parcelRequire("9M5tS");
var $5s4cI = parcelRequire("5s4cI");
var $iuyb9 = parcelRequire("iuyb9");
var $faeBy = parcelRequire("faeBy");
var $bfMNh = parcelRequire("bfMNh");

var $ey2qH = parcelRequire("ey2qH");
var $e48b8143bae273f0$var$global = (0, $faeBy.getGlobalObject)();
var $e48b8143bae273f0$var$ignoreOnError = 0;
function $e48b8143bae273f0$export$b79738ab10c590b2() {
    return $e48b8143bae273f0$var$ignoreOnError > 0;
}
function $e48b8143bae273f0$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $e48b8143bae273f0$var$ignoreOnError += 1;
    setTimeout(function() {
        $e48b8143bae273f0$var$ignoreOnError -= 1;
    });
}
function $e48b8143bae273f0$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $iuyb9.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $e48b8143bae273f0$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $e48b8143bae273f0$export$1265a142ff5ba165();
            (0, $gamVI.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $5s4cI.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $5s4cI.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $gamVI.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $iuyb9.markFunctionWrapped)(sentryWrapped, fn);
    (0, $iuyb9.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $e48b8143bae273f0$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$e48b8143bae273f0$var$global.document) return;
    if (!options.eventId) {
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $e48b8143bae273f0$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $7k3ZH.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $e48b8143bae273f0$var$global.document.head || $e48b8143bae273f0$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("2rSpj", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $1c884e8de259e876$export$2dc68d50d56fbbd);

var $dnskZ = parcelRequire("dnskZ");

var $kObcn = parcelRequire("kObcn");

var $lHwN4 = parcelRequire("lHwN4");
parcelRequire("9M5tS");
var $gxSvp = parcelRequire("gxSvp");
var $5s4cI = parcelRequire("5s4cI");
var $faeBy = parcelRequire("faeBy");
var $bn3Qd = parcelRequire("bn3Qd");
var $8Qyzc = parcelRequire("8Qyzc");
var $kdnv0 = parcelRequire("kdnv0");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $1c884e8de259e876$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $dnskZ.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $kObcn.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $5s4cI.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $gxSvp.addInstrumentationHandler)('console', $1c884e8de259e876$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $gxSvp.addInstrumentationHandler)('dom', $1c884e8de259e876$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $gxSvp.addInstrumentationHandler)('xhr', $1c884e8de259e876$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $gxSvp.addInstrumentationHandler)('fetch', $1c884e8de259e876$var$_fetchBreadcrumb);
        if (this._options.history) (0, $gxSvp.addInstrumentationHandler)('history', $1c884e8de259e876$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c884e8de259e876$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $bn3Qd.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $bn3Qd.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $kObcn.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c884e8de259e876$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $kdnv0.severityFromString)(handlerData.level),
        message: (0, $8Qyzc.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $8Qyzc.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $kObcn.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c884e8de259e876$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $kObcn.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c884e8de259e876$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $kObcn.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $lHwN4.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $kObcn.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1c884e8de259e876$var$_historyBreadcrumb(handlerData) {
    var global = (0, $faeBy.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $5s4cI.parseUrl)(global.location.href);
    var parsedFrom = (0, $5s4cI.parseUrl)(from);
    var parsedTo = (0, $5s4cI.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $kObcn.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("bVGq2", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $8af5ec1a01a40555$export$688d98c249d31ad3);
parcelRequire("9M5tS");
var $bfMNh = parcelRequire("bfMNh");

var $ey2qH = parcelRequire("ey2qH");
/** Deduplication filter */ var $8af5ec1a01a40555$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($8af5ec1a01a40555$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $8af5ec1a01a40555$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($8af5ec1a01a40555$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($8af5ec1a01a40555$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $8af5ec1a01a40555$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$8af5ec1a01a40555$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$8af5ec1a01a40555$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $8af5ec1a01a40555$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $8af5ec1a01a40555$var$_getExceptionFromEvent(previousEvent);
    var currentException = $8af5ec1a01a40555$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$8af5ec1a01a40555$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$8af5ec1a01a40555$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $8af5ec1a01a40555$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $8af5ec1a01a40555$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $8af5ec1a01a40555$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $8af5ec1a01a40555$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $8af5ec1a01a40555$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $8af5ec1a01a40555$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("dmbk6", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $9b961cf99f836b3a$export$204155decbc90e5a);

var $dnskZ = parcelRequire("dnskZ");

var $kObcn = parcelRequire("kObcn");

var $lHwN4 = parcelRequire("lHwN4");
parcelRequire("9M5tS");
var $5s4cI = parcelRequire("5s4cI");
var $gxSvp = parcelRequire("gxSvp");
var $bn3Qd = parcelRequire("bn3Qd");
var $13jtF = parcelRequire("13jtF");
var $bfMNh = parcelRequire("bfMNh");

var $atdG9 = parcelRequire("atdG9");

var $ey2qH = parcelRequire("ey2qH");

var $jCxri = parcelRequire("jCxri");
/** Global handlers */ var $9b961cf99f836b3a$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $9b961cf99f836b3a$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $9b961cf99f836b3a$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $dnskZ.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $9b961cf99f836b3a$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $9b961cf99f836b3a$var$_installGlobalOnErrorHandler() {
    (0, $gxSvp.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $dnskZ.__read)($9b961cf99f836b3a$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($9b961cf99f836b3a$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $jCxri.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $13jtF.isString)(msg) ? $9b961cf99f836b3a$var$_eventFromIncompleteOnError(msg, url, line, column) : $9b961cf99f836b3a$var$_enhanceEventWithInitialFrame((0, $atdG9.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $lHwN4.Severity).Error;
        $9b961cf99f836b3a$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $9b961cf99f836b3a$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $gxSvp.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $dnskZ.__read)($9b961cf99f836b3a$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($9b961cf99f836b3a$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $jCxri.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $13jtF.isPrimitive)(error) ? $9b961cf99f836b3a$var$_eventFromRejectionWithPrimitive(error) : (0, $atdG9.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $lHwN4.Severity).Error;
        $9b961cf99f836b3a$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9b961cf99f836b3a$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9b961cf99f836b3a$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $13jtF.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9b961cf99f836b3a$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9b961cf99f836b3a$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $13jtF.isString)(url) && url.length > 0 ? url : (0, $bn3Qd.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9b961cf99f836b3a$var$globalHandlerLog(type) {
    (0, $ey2qH.IS_DEBUG_BUILD) && (0, $bfMNh.logger).log("Global Handler attached: " + type);
}
function $9b961cf99f836b3a$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $5s4cI.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $9b961cf99f836b3a$var$getHubAndAttachStacktrace() {
    var hub = (0, $kObcn.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("9AVP9", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $6fc4547eb5287105$export$8d1e60aaf616fb4f);

var $dnskZ = parcelRequire("dnskZ");

var $e58Qh = parcelRequire("e58Qh");
var $kObcn = parcelRequire("kObcn");
parcelRequire("9M5tS");
var $13jtF = parcelRequire("13jtF");

var $atdG9 = parcelRequire("atdG9");
var $6fc4547eb5287105$var$DEFAULT_KEY = 'cause';
var $6fc4547eb5287105$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $6fc4547eb5287105$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $6fc4547eb5287105$var$DEFAULT_KEY;
        this._limit = options.limit || $6fc4547eb5287105$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $e58Qh.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $kObcn.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $6fc4547eb5287105$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $6fc4547eb5287105$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $13jtF.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $6fc4547eb5287105$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $dnskZ.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $6fc4547eb5287105$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $13jtF.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $atdG9.exceptionFromError)(error[key]);
    return $6fc4547eb5287105$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $dnskZ.__spread)([
        exception
    ], stack));
}

});

parcelRegister("iMcMT", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $dab6a10c4cb539b2$export$f1a018517668e6d3);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $iuyb9 = parcelRequire("iuyb9");
var $lM8QO = parcelRequire("lM8QO");
var $faeBy = parcelRequire("faeBy");

var $jCxri = parcelRequire("jCxri");
var $dab6a10c4cb539b2$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $dab6a10c4cb539b2$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $dnskZ.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $faeBy.getGlobalObject)();
        if (this._options.setTimeout) (0, $iuyb9.fill)(global, 'setTimeout', $dab6a10c4cb539b2$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $iuyb9.fill)(global, 'setInterval', $dab6a10c4cb539b2$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $iuyb9.fill)(global, 'requestAnimationFrame', $dab6a10c4cb539b2$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $iuyb9.fill)(XMLHttpRequest.prototype, 'send', $dab6a10c4cb539b2$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $dab6a10c4cb539b2$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($dab6a10c4cb539b2$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $dab6a10c4cb539b2$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $jCxri.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $lM8QO.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dab6a10c4cb539b2$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $jCxri.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $lM8QO.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $dab6a10c4cb539b2$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iuyb9.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $lM8QO.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $iuyb9.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $lM8QO.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $jCxri.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $dab6a10c4cb539b2$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $faeBy.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $iuyb9.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $jCxri.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $lM8QO.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $jCxri.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $lM8QO.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $iuyb9.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("5xA0y", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $408bf73db0e24032$export$5fba5e10934a4faf);

var $dnskZ = parcelRequire("dnskZ");

var $e58Qh = parcelRequire("e58Qh");
var $kObcn = parcelRequire("kObcn");
parcelRequire("9M5tS");
var $faeBy = parcelRequire("faeBy");
var $408bf73db0e24032$var$global = (0, $faeBy.getGlobalObject)();
/** UserAgent */ var $408bf73db0e24032$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $e58Qh.addGlobalEventProcessor)(function(event) {
            if ((0, $kObcn.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$408bf73db0e24032$var$global.navigator && !$408bf73db0e24032$var$global.location && !$408bf73db0e24032$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $408bf73db0e24032$var$global.location && $408bf73db0e24032$var$global.location.href;
                var referrer = ($408bf73db0e24032$var$global.document || {}).referrer;
                var userAgent = ($408bf73db0e24032$var$global.navigator || {}).userAgent;
                var headers = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("35yDm", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $23fcb447de83c262$export$25a43cb5b5c58c08);
parcelRequire("9M5tS");
var $bfMNh = parcelRequire("bfMNh");
var $iuyb9 = parcelRequire("iuyb9");
var $faeBy = parcelRequire("faeBy");
var $8Qyzc = parcelRequire("8Qyzc");
var $kdnv0 = parcelRequire("kdnv0");
var $23fcb447de83c262$var$global = (0, $faeBy.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $23fcb447de83c262$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $bfMNh.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $23fcb447de83c262$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $23fcb447de83c262$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iuyb9.fill)($23fcb447de83c262$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $kdnv0.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $8Qyzc.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $8Qyzc.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($23fcb447de83c262$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("caZl3", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $8dd5ffc12fd06a2b$export$688d98c249d31ad3);
parcelRequire("9M5tS");
var $bfMNh = parcelRequire("bfMNh");

var $4kBl8 = parcelRequire("4kBl8");
/** Deduplication filter */ var $8dd5ffc12fd06a2b$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($8dd5ffc12fd06a2b$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $4kBl8.IS_DEBUG_BUILD) && (0, $bfMNh.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $8dd5ffc12fd06a2b$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($8dd5ffc12fd06a2b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($8dd5ffc12fd06a2b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$8dd5ffc12fd06a2b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$8dd5ffc12fd06a2b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $8dd5ffc12fd06a2b$var$_getExceptionFromEvent(previousEvent);
    var currentException = $8dd5ffc12fd06a2b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$8dd5ffc12fd06a2b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$8dd5ffc12fd06a2b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $8dd5ffc12fd06a2b$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $8dd5ffc12fd06a2b$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $8dd5ffc12fd06a2b$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("4kBl8", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $3275fea07fa03fd5$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $3275fea07fa03fd5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("iZ7wR", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $dd23c3948e53c8c4$export$56d961ef3a52a072);

var $dnskZ = parcelRequire("dnskZ");
parcelRequire("9M5tS");
var $13jtF = parcelRequire("13jtF");
var $bfMNh = parcelRequire("bfMNh");
var $lNdH5 = parcelRequire("lNdH5");

var $4kBl8 = parcelRequire("4kBl8");
/** Patch toString calls to return proper name for wrapped functions */ var $dd23c3948e53c8c4$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $dnskZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $13jtF.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $dnskZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $lNdH5.normalize)(errorData, this._options.depth);
            if ((0, $13jtF.isPlainObject)(normalizedErrorData)) contexts = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $dnskZ.__assign)({}, normalizedErrorData), _a));
            return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $dnskZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $13jtF.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $dnskZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $13jtF.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $4kBl8.IS_DEBUG_BUILD) && (0, $bfMNh.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("g7tNk", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $bbc46966d85ea47c$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $bbc46966d85ea47c$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("j3vko", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $6c1995f9732d041d$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $6c1995f9732d041d$export$2e2bcd8739ae039);

var $8dH3d = parcelRequire("8dH3d");

var $4lYQk = parcelRequire("4lYQk");

var $38Pz7 = parcelRequire("38Pz7");
var $b5d3Z = parcelRequire("b5d3Z");

var $8NP0A = parcelRequire("8NP0A");
let $6c1995f9732d041d$var$analyticsClient;
const $6c1995f9732d041d$export$d4079397f9611138 = (client)=>{
    $6c1995f9732d041d$var$analyticsClient = client;
};
const $6c1995f9732d041d$export$bf406c01a195b215 = ()=>{
    $6c1995f9732d041d$var$analyticsClient = undefined;
};
const $6c1995f9732d041d$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $38Pz7.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d))));
        if (event && event.context) {
            const fullEvent = (0, $38Pz7.extractAWCDataFromEvent)(event);
            (0, $8NP0A.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $8NP0A.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $b5d3Z.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($6c1995f9732d041d$var$analyticsClient && $6c1995f9732d041d$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $6c1995f9732d041d$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $8NP0A.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $6c1995f9732d041d$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $6c1995f9732d041d$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $6c1995f9732d041d$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $6c1995f9732d041d$export$2e2bcd8739ae039 = $6c1995f9732d041d$var$fireErrorAnalytics;

});
parcelRegister("38Pz7", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $43f696b9dd4eb95a$export$1c850cf68c053906);

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");


var $a9SUw = parcelRequire("a9SUw");
const $43f696b9dd4eb95a$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $a9SUw.getAnalyticsType)(castedEvent);
    const attributes = (0, $a9SUw.getAttributes)(castedEvent);
    const source = (0, $a9SUw.getSource)(castedEvent);
    const actionSubject = (0, $a9SUw.getActionSubject)(castedEvent);
    if (analyticsType === (0, $2105caca302b8178$export$f1d537d508d2945a)) return {
        type: (0, $2105caca302b8178$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $2105caca302b8178$export$a1562d08625f5d7e:
        case 0, $2105caca302b8178$export$947dac6c72b26f81:
        case 0, $2105caca302b8178$export$12346a674644c156:
            {
                const action = (0, $a9SUw.getAction)(castedEvent);
                const actionSubjectId = (0, $a9SUw.getActionSubjectId)(castedEvent);
                const containerId = (0, $a9SUw.getContainerId)(castedEvent);
                const containerType = (0, $a9SUw.getContainerType)(castedEvent);
                const objectId = (0, $a9SUw.getObjectId)(castedEvent);
                const objectType = (0, $a9SUw.getObjectType)(castedEvent);
                const tags = (0, $a9SUw.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
const $2105caca302b8178$export$f636b5b56f1d624a = 'Screen';
const $2105caca302b8178$export$9d2de6eebf7462b5 = 'Drawer';
const $2105caca302b8178$export$1171103ea9083ffa = 'Modal';
const $2105caca302b8178$export$cae2783c9279926 = 'InlineDialog';
const $2105caca302b8178$export$d1123261ca8831d2 = 'Dropdown';
const $2105caca302b8178$export$a1562d08625f5d7e = 'UI';
const $2105caca302b8178$export$947dac6c72b26f81 = 'TRACK';
const $2105caca302b8178$export$f1d537d508d2945a = 'SCREEN';
const $2105caca302b8178$export$12346a674644c156 = 'OPERATIONAL';
const $2105caca302b8178$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("a9SUw", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $7660e0b3654ba042$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $7660e0b3654ba042$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $7660e0b3654ba042$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $7660e0b3654ba042$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $7660e0b3654ba042$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $7660e0b3654ba042$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $7660e0b3654ba042$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $7660e0b3654ba042$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $7660e0b3654ba042$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $7660e0b3654ba042$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $7660e0b3654ba042$export$af63d7414243dad3);

var $aX8Tx = parcelRequire("aX8Tx");

var $6dPbw = parcelRequire("6dPbw");

var $1ilzu = parcelRequire("1ilzu");

var $1O6Yz = parcelRequire("1O6Yz");

var $4lYQk = parcelRequire("4lYQk");

var $jvwCK = parcelRequire("jvwCK");
const $7660e0b3654ba042$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $7660e0b3654ba042$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $7660e0b3654ba042$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $7660e0b3654ba042$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $7660e0b3654ba042$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
const $7660e0b3654ba042$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'source').filter(Boolean));
const $7660e0b3654ba042$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $7660e0b3654ba042$export$6ca3170acb89054 = (event)=>event.payload.action;
const $7660e0b3654ba042$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $7660e0b3654ba042$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'containerId').filter(Boolean));
const $7660e0b3654ba042$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'containerType').filter(Boolean));
const $7660e0b3654ba042$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'objectId').filter(Boolean));
const $7660e0b3654ba042$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($7660e0b3654ba042$var$extractFromContext(event, 'objectType').filter(Boolean));
const $7660e0b3654ba042$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))((0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))($7660e0b3654ba042$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});


parcelRegister("b5d3Z", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $e0f478ed6174c00a$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $e0f478ed6174c00a$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $e0f478ed6174c00a$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $e0f478ed6174c00a$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $e0f478ed6174c00a$export$6f46fb37ad7d962b);

var $1ilzu = parcelRequire("1ilzu");


var $amfa1 = parcelRequire("amfa1");
const $e0f478ed6174c00a$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $2105caca302b8178$export$2ceccf177fae277c));
};
const $e0f478ed6174c00a$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $e0f478ed6174c00a$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $amfa1.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $e0f478ed6174c00a$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $e0f478ed6174c00a$export$34ac71ce24cddec2(event, (0, $2105caca302b8178$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e0f478ed6174c00a$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $amfa1.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $e0f478ed6174c00a$export$34ac71ce24cddec2(event, (0, $2105caca302b8178$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e0f478ed6174c00a$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $amfa1.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $e0f478ed6174c00a$export$34ac71ce24cddec2(event, (0, $2105caca302b8178$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e0f478ed6174c00a$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $amfa1.getImperativeAnalyticsDataFromArguments)(rest);
    $e0f478ed6174c00a$export$34ac71ce24cddec2(event, (0, $2105caca302b8178$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("amfa1", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $4bf9921d547faa39$export$e6baab532ef8c6bf);
const $4bf9921d547faa39$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $4bf9921d547faa39$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $4bf9921d547faa39$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $4bf9921d547faa39$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $4bf9921d547faa39$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $4bf9921d547faa39$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $4bf9921d547faa39$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $4bf9921d547faa39$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $4bf9921d547faa39$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $4bf9921d547faa39$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $4bf9921d547faa39$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $4bf9921d547faa39$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});



parcelRegister("eGqF3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee1b10a41df870d9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6NtES = parcelRequire("6NtES");

var $j3vko = parcelRequire("j3vko");
class $ee1b10a41df870d9$var$CatchAndReportErrors extends (0, $eJOHy.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $j3vko.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children
        });
    }
}
const $ee1b10a41df870d9$var$reportingErrorBoundary = (0, $6NtES.default)()($ee1b10a41df870d9$var$CatchAndReportErrors);
var $ee1b10a41df870d9$export$2e2bcd8739ae039 = $ee1b10a41df870d9$var$reportingErrorBoundary;

});


parcelRegister("i1oZ6", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $c088fd189f2d6a02$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $c088fd189f2d6a02$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $c088fd189f2d6a02$export$e2d53c0cbedd2710 = {
    current: null
};
const $c088fd189f2d6a02$export$8146ab57a3f7a7cb = (0, $eJOHy.createContext)($c088fd189f2d6a02$export$e2d53c0cbedd2710);

});

parcelRegister("8uanK", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $9e4e8a516f065a83$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $1Vjc9 = parcelRequire("1Vjc9");
const $9e4e8a516f065a83$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $1Vjc9.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), {
            ...props,
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("3vcYe", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $ec9534deb537d5ba$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $i1oZ6 = parcelRequire("i1oZ6");

var $9LdGp = parcelRequire("9LdGp");

var $4uKxL = parcelRequire("4uKxL");
function $ec9534deb537d5ba$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $ec9534deb537d5ba$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $i1oZ6.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $9LdGp.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4uKxL.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($ec9534deb537d5ba$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $ec9534deb537d5ba$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $ec9534deb537d5ba$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("jp3Yl", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $0bf3f838bf32c7f6$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $0bf3f838bf32c7f6$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("f4ubo", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $e8b57662f206914f$export$eb2e4b04351cdd9e);

var $eJOHy = parcelRequire("eJOHy");

var $4fidM = parcelRequire("4fidM");

var $iKsw2 = parcelRequire("iKsw2");
var $fwTjO = parcelRequire("fwTjO");

var $d0A2n = parcelRequire("d0A2n");

var $4uKxL = parcelRequire("4uKxL");

var $1Vjc9 = parcelRequire("1Vjc9");

var $7Ll1b = parcelRequire("7Ll1b");
function $e8b57662f206914f$var$load(moduleId, loader) {
    try {
        return (0, $1Vjc9.getExport)(loader());
    } catch (err) {
        throw (0, $7Ll1b.createLoaderError)(err);
    }
}
function $e8b57662f206914f$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4uKxL.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $iKsw2.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e8b57662f206914f$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $fwTjO.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e8b57662f206914f$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props);
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $d0A2n.PHASE).LAZY && (0, $4fidM.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $d0A2n.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            })), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
class $e8b57662f206914f$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = true;
    }
}

});

parcelRegister("f6tE0", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $b9ee40c048194978$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $b9ee40c048194978$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $b9ee40c048194978$export$ba64c908e55507fe);
const $b9ee40c048194978$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $b9ee40c048194978$export$a339266ad71b2447 = 300;
const $b9ee40c048194978$export$ba64c908e55507fe = 1;

});

parcelRegister("6cijW", function(module, exports) {
$parcel$export(module.exports, "preloadMarkedIds", () => $949b14202ea69fb9$export$ac21d099cbc8d569);
$parcel$export(module.exports, "createDeferred", () => $949b14202ea69fb9$export$e673efccd97e4223);
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $949b14202ea69fb9$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $949b14202ea69fb9$var$preloadIds;
const $949b14202ea69fb9$export$ac21d099cbc8d569 = (preload)=>{
    $949b14202ea69fb9$var$preloadIds = preload;
    try {
        $949b14202ea69fb9$var$preloadIds.forEach((lazyId)=>{
            const deffered = $949b14202ea69fb9$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $949b14202ea69fb9$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $949b14202ea69fb9$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($949b14202ea69fb9$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};

});

parcelRegister("50pXd", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $8a8090e50df1c190$export$25bad4aa00c45355);

var $4fidM = parcelRequire("4fidM");

var $8dknI = parcelRequire("8dknI");

var $iKsw2 = parcelRequire("iKsw2");

var $i1oZ6 = parcelRequire("i1oZ6");

var $1Vjc9 = parcelRequire("1Vjc9");

var $f6tE0 = parcelRequire("f6tE0");

var $d98nM = parcelRequire("d98nM");
function $8a8090e50df1c190$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $iKsw2.getConfig)();
    const assets = (0, $4fidM.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $d98nM.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $8a8090e50df1c190$var$fakePromise = {
    then: ()=>$8a8090e50df1c190$var$fakePromise,
    catch: ()=>$8a8090e50df1c190$var$fakePromise,
    finally: ()=>$8a8090e50df1c190$var$fakePromise
};
function $8a8090e50df1c190$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $d98nM.insertLinkTag)(href, rel));
        return $8a8090e50df1c190$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $8a8090e50df1c190$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $8dknI.noopCleanup;
}
function $8a8090e50df1c190$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $1Vjc9.isNodeEnvironment)()) return 0, $8dknI.noopCleanup;
    (0, $i1oZ6.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $f6tE0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $8a8090e50df1c190$export$3af04dbcb01bad4d,
        $8a8090e50df1c190$export$1046fd6a49d5e7a,
        $8a8090e50df1c190$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $8dknI.noopCleanup;
}

});
parcelRegister("d98nM", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $a5ff7950b21a5492$export$6610512821c8a4ce);

var $8dknI = parcelRequire("8dknI");

var $iKsw2 = parcelRequire("iKsw2");

var $i1oZ6 = parcelRequire("i1oZ6");
function $a5ff7950b21a5492$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $8dknI.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $iKsw2.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $i1oZ6.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("e99jZ", function(module, exports) {
$parcel$export(module.exports, "retry", () => $68764876ac28aea8$export$9369b12211e1fce4);
const $68764876ac28aea8$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $68764876ac28aea8$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $68764876ac28aea8$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $68764876ac28aea8$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $68764876ac28aea8$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $68764876ac28aea8$var$calculateDelay(context, policy);
        if (delay) await $68764876ac28aea8$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});


parcelRegister("28uYN", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("kGYxb")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("l8nBh")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("l8nBh")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("7WSCT")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("7WSCT")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("h5R9u")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("fgsCa")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("fgsCa")).getGlobalSingleton);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("ksSib")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("6auXz")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("6auXz")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("6auXz")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("6auXz")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("6auXz")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("6auXz")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("6auXz")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("6auXz")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("6auXz")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("6auXz")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("5ewvH")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("5ewvH")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("crS3v")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("crS3v")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("crS3v")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("crS3v")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("crS3v")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("crS3v")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("jVAYm")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("jVAYm")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("i5Cj4")).addNonEnumerableProperty);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("i5Cj4")).dropUndefinedKeys);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("i5Cj4")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("i5Cj4")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("i5Cj4")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("i5Cj4")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("i5Cj4")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("bPDNT")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("i5cOE")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("9vKss")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("9vKss")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("ROgru")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("3bCue")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("3bCue")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("3bCue")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("fxl6v")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("fxl6v")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("fxl6v")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("vnWDO")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("vnWDO")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("vnWDO")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("3X2Zm")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("3X2Zm")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("3X2Zm")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("cFR3q")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("leaAG")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("leaAG")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("leaAG")).updateRateLimits);
parcelRequire("kGYxb");
parcelRequire("l8nBh");
parcelRequire("7WSCT");

parcelRequire("h5R9u");
parcelRequire("fgsCa");
parcelRequire("ksSib");
parcelRequire("6auXz");
parcelRequire("5ewvH");

parcelRequire("crS3v");

var $jBMAF = parcelRequire("jBMAF");
parcelRequire("jVAYm");
parcelRequire("i5Cj4");

parcelRequire("bPDNT");
parcelRequire("i5cOE");
parcelRequire("9vKss");
parcelRequire("ROgru");
parcelRequire("3bCue");
parcelRequire("fxl6v");
parcelRequire("vnWDO");

var $7IZE7 = parcelRequire("7IZE7");


parcelRequire("3X2Zm");
parcelRequire("cFR3q");
parcelRequire("leaAG");
$parcel$exportWildcard(module.exports, $jBMAF);
$parcel$exportWildcard(module.exports, $7IZE7);

});
parcelRegister("kGYxb", function(module, exports) {
$parcel$export(module.exports, "forget", () => $f106afb94f6663ae$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f106afb94f6663ae$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("l8nBh", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $f62ca6de33a89715$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $f62ca6de33a89715$export$1cfafeee2987818b);

var $fgsCa = parcelRequire("fgsCa");

var $6auXz = parcelRequire("6auXz");
function $f62ca6de33a89715$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $f62ca6de33a89715$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $f62ca6de33a89715$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $6auXz.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $f62ca6de33a89715$export$1cfafeee2987818b() {
    var global = (0, $fgsCa.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("fgsCa", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $b1ce8be1bfedc9df$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $b1ce8be1bfedc9df$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $jBMAF = parcelRequire("jBMAF");
var $b1ce8be1bfedc9df$var$fallbackGlobalObject = {};
function $b1ce8be1bfedc9df$export$256479dc0cea61c4() {
    return (0, $jBMAF.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $b1ce8be1bfedc9df$var$fallbackGlobalObject;
}
function $b1ce8be1bfedc9df$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $b1ce8be1bfedc9df$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("jBMAF", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $4n8no = parcelRequire("4n8no");

var $igDjg = parcelRequire("igDjg");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $4n8no.isBrowserBundle)() && Object.prototype.toString.call(typeof $igDjg !== 'undefined' ? $igDjg : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("4n8no", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $32efcec887a528a3$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $32efcec887a528a3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("6auXz", function(module, exports) {
$parcel$export(module.exports, "isError", () => $47dbb13a3b262fd7$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $47dbb13a3b262fd7$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $47dbb13a3b262fd7$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $47dbb13a3b262fd7$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $47dbb13a3b262fd7$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $47dbb13a3b262fd7$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $47dbb13a3b262fd7$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $47dbb13a3b262fd7$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $47dbb13a3b262fd7$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $47dbb13a3b262fd7$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $47dbb13a3b262fd7$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $47dbb13a3b262fd7$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $47dbb13a3b262fd7$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $47dbb13a3b262fd7$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $47dbb13a3b262fd7$var$objectToString = Object.prototype.toString;
function $47dbb13a3b262fd7$export$e6127cc7fe7395c3(wat) {
    switch($47dbb13a3b262fd7$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $47dbb13a3b262fd7$export$49034edbe6b62415(wat, Error);
    }
}
function $47dbb13a3b262fd7$var$isBuiltin(wat, ty) {
    return $47dbb13a3b262fd7$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $47dbb13a3b262fd7$export$9f9636d330b71954(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'ErrorEvent');
}
function $47dbb13a3b262fd7$export$ef9e2056653f0c8e(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'DOMError');
}
function $47dbb13a3b262fd7$export$12e869b2a583f783(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'DOMException');
}
function $47dbb13a3b262fd7$export$844ec244b1367d54(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'String');
}
function $47dbb13a3b262fd7$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $47dbb13a3b262fd7$export$53b83ca8eaab0383(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'Object');
}
function $47dbb13a3b262fd7$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $47dbb13a3b262fd7$export$49034edbe6b62415(wat, Event);
}
function $47dbb13a3b262fd7$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $47dbb13a3b262fd7$export$49034edbe6b62415(wat, Element);
}
function $47dbb13a3b262fd7$export$49841c62b9eff15(wat) {
    return $47dbb13a3b262fd7$var$isBuiltin(wat, 'RegExp');
}
function $47dbb13a3b262fd7$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $47dbb13a3b262fd7$export$bc2894c7158efbac(wat) {
    return $47dbb13a3b262fd7$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $47dbb13a3b262fd7$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $47dbb13a3b262fd7$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("7WSCT", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $5c9852d9b3d5c369$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $5c9852d9b3d5c369$export$128827c3562ec0cb);

var $dnskZ = parcelRequire("dnskZ");

var $h5R9u = parcelRequire("h5R9u");

var $6s3t3 = parcelRequire("6s3t3");
/** Regular expression used to parse a Dsn. */ var $5c9852d9b3d5c369$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $5c9852d9b3d5c369$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $5c9852d9b3d5c369$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $5c9852d9b3d5c369$var$dsnFromString(str) {
    var match = $5c9852d9b3d5c369$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $h5R9u.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $dnskZ.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $5c9852d9b3d5c369$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $5c9852d9b3d5c369$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $5c9852d9b3d5c369$var$validateDsn(dsn) {
    if (!(0, $6s3t3.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $h5R9u.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $h5R9u.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$5c9852d9b3d5c369$var$isValidProtocol(protocol)) throw new (0, $h5R9u.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $h5R9u.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $5c9852d9b3d5c369$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $5c9852d9b3d5c369$var$dsnFromString(from) : $5c9852d9b3d5c369$var$dsnFromComponents(from);
    $5c9852d9b3d5c369$var$validateDsn(components);
    return components;
}

});
parcelRegister("h5R9u", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $c71c223273ddebf8$export$5949942ba2a7c0e2);

var $dnskZ = parcelRequire("dnskZ");

var $hQZ0B = parcelRequire("hQZ0B");
/** An error emitted by Sentry SDKs and related utilities. */ var $c71c223273ddebf8$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $dnskZ.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $hQZ0B.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("hQZ0B", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $cff69e156605eba9$export$1cb0d91350beb6cc);
var $cff69e156605eba9$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $cff69e156605eba9$var$setProtoOf : $cff69e156605eba9$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $cff69e156605eba9$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $cff69e156605eba9$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("6s3t3", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $4b280c2e2a4a325b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $4b280c2e2a4a325b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("ksSib", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $ee608978bce93dd9$export$285b9172a3741fb7);

var $dnskZ = parcelRequire("dnskZ");

var $6s3t3 = parcelRequire("6s3t3");

var $fgsCa = parcelRequire("fgsCa");

var $6auXz = parcelRequire("6auXz");

var $5ewvH = parcelRequire("5ewvH");

var $i5Cj4 = parcelRequire("i5Cj4");

var $9vKss = parcelRequire("9vKss");

var $fxl6v = parcelRequire("fxl6v");
var $ee608978bce93dd9$var$global = (0, $fgsCa.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $ee608978bce93dd9$var$handlers = {};
var $ee608978bce93dd9$var$instrumented = {};
/** Instruments given API */ function $ee608978bce93dd9$var$instrument(type) {
    if ($ee608978bce93dd9$var$instrumented[type]) return;
    $ee608978bce93dd9$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $ee608978bce93dd9$var$instrumentConsole();
            break;
        case 'dom':
            $ee608978bce93dd9$var$instrumentDOM();
            break;
        case 'xhr':
            $ee608978bce93dd9$var$instrumentXHR();
            break;
        case 'fetch':
            $ee608978bce93dd9$var$instrumentFetch();
            break;
        case 'history':
            $ee608978bce93dd9$var$instrumentHistory();
            break;
        case 'error':
            $ee608978bce93dd9$var$instrumentError();
            break;
        case 'unhandledrejection':
            $ee608978bce93dd9$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $6s3t3.IS_DEBUG_BUILD) && (0, $5ewvH.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $ee608978bce93dd9$export$285b9172a3741fb7(type, callback) {
    $ee608978bce93dd9$var$handlers[type] = $ee608978bce93dd9$var$handlers[type] || [];
    $ee608978bce93dd9$var$handlers[type].push(callback);
    $ee608978bce93dd9$var$instrument(type);
}
/** JSDoc */ function $ee608978bce93dd9$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$ee608978bce93dd9$var$handlers[type]) return;
    try {
        for(var _b = (0, $dnskZ.__values)($ee608978bce93dd9$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $6s3t3.IS_DEBUG_BUILD) && (0, $5ewvH.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $9vKss.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $ee608978bce93dd9$var$instrumentConsole() {
    if (!('console' in $ee608978bce93dd9$var$global)) return;
    (0, $5ewvH.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $ee608978bce93dd9$var$global.console)) return;
        (0, $i5Cj4.fill)($ee608978bce93dd9$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $ee608978bce93dd9$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($ee608978bce93dd9$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $ee608978bce93dd9$var$instrumentFetch() {
    if (!(0, $fxl6v.supportsNativeFetch)()) return;
    (0, $i5Cj4.fill)($ee608978bce93dd9$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $ee608978bce93dd9$var$getFetchMethod(args),
                    url: $ee608978bce93dd9$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $ee608978bce93dd9$var$triggerHandlers('fetch', (0, $dnskZ.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($ee608978bce93dd9$var$global, args).then(function(response) {
                $ee608978bce93dd9$var$triggerHandlers('fetch', (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $ee608978bce93dd9$var$triggerHandlers('fetch', (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $ee608978bce93dd9$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $ee608978bce93dd9$var$global && (0, $6auXz.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $ee608978bce93dd9$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $ee608978bce93dd9$var$global && (0, $6auXz.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $ee608978bce93dd9$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $ee608978bce93dd9$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $i5Cj4.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $6auXz.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $6auXz.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $ee608978bce93dd9$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $i5Cj4.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $i5Cj4.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $ee608978bce93dd9$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $ee608978bce93dd9$var$lastHref;
/** JSDoc */ function $ee608978bce93dd9$var$instrumentHistory() {
    if (!(0, $fxl6v.supportsHistory)()) return;
    var oldOnPopState = $ee608978bce93dd9$var$global.onpopstate;
    $ee608978bce93dd9$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $ee608978bce93dd9$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $ee608978bce93dd9$var$lastHref;
        $ee608978bce93dd9$var$lastHref = to;
        $ee608978bce93dd9$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $ee608978bce93dd9$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ee608978bce93dd9$var$lastHref = to;
                $ee608978bce93dd9$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $i5Cj4.fill)($ee608978bce93dd9$var$global.history, 'pushState', historyReplacementFunction);
    (0, $i5Cj4.fill)($ee608978bce93dd9$var$global.history, 'replaceState', historyReplacementFunction);
}
var $ee608978bce93dd9$var$debounceDuration = 1000;
var $ee608978bce93dd9$var$debounceTimerID;
var $ee608978bce93dd9$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $ee608978bce93dd9$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $ee608978bce93dd9$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $ee608978bce93dd9$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $ee608978bce93dd9$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($ee608978bce93dd9$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($ee608978bce93dd9$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ee608978bce93dd9$var$lastCapturedEvent = event;
        } else if ($ee608978bce93dd9$var$shouldShortcircuitPreviousDebounce($ee608978bce93dd9$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ee608978bce93dd9$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($ee608978bce93dd9$var$debounceTimerID);
        $ee608978bce93dd9$var$debounceTimerID = $ee608978bce93dd9$var$global.setTimeout(function() {
            $ee608978bce93dd9$var$debounceTimerID = undefined;
        }, $ee608978bce93dd9$var$debounceDuration);
    };
}
/** JSDoc */ function $ee608978bce93dd9$var$instrumentDOM() {
    if (!('document' in $ee608978bce93dd9$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $ee608978bce93dd9$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $ee608978bce93dd9$var$makeDOMEventHandler(triggerDOMHandler, true);
    $ee608978bce93dd9$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $ee608978bce93dd9$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $ee608978bce93dd9$var$global[target] && $ee608978bce93dd9$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $i5Cj4.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $ee608978bce93dd9$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $i5Cj4.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $ee608978bce93dd9$var$_oldOnErrorHandler = null;
/** JSDoc */ function $ee608978bce93dd9$var$instrumentError() {
    $ee608978bce93dd9$var$_oldOnErrorHandler = $ee608978bce93dd9$var$global.onerror;
    $ee608978bce93dd9$var$global.onerror = function(msg, url, line, column, error) {
        $ee608978bce93dd9$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($ee608978bce93dd9$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $ee608978bce93dd9$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $ee608978bce93dd9$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $ee608978bce93dd9$var$instrumentUnhandledRejection() {
    $ee608978bce93dd9$var$_oldOnUnhandledRejectionHandler = $ee608978bce93dd9$var$global.onunhandledrejection;
    $ee608978bce93dd9$var$global.onunhandledrejection = function(e) {
        $ee608978bce93dd9$var$triggerHandlers('unhandledrejection', e);
        if ($ee608978bce93dd9$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $ee608978bce93dd9$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("5ewvH", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3cf77a71efca7870$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $3cf77a71efca7870$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3cf77a71efca7870$export$af88d00dbe7f521);

var $dnskZ = parcelRequire("dnskZ");

var $6s3t3 = parcelRequire("6s3t3");

var $fgsCa = parcelRequire("fgsCa");
// TODO: Implement different loggers for different environments
var $3cf77a71efca7870$var$global = (0, $fgsCa.getGlobalObject)();
/** Prefix for logging strings */ var $3cf77a71efca7870$var$PREFIX = 'Sentry Logger ';
var $3cf77a71efca7870$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $3cf77a71efca7870$export$cda52e2a8927a2ca(callback) {
    var global = (0, $fgsCa.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $3cf77a71efca7870$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $3cf77a71efca7870$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $6s3t3.IS_DEBUG_BUILD) $3cf77a71efca7870$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $3cf77a71efca7870$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $3cf77a71efca7870$var$global.console)[name].apply(_a, (0, $dnskZ.__spread)([
                    $3cf77a71efca7870$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $3cf77a71efca7870$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $3cf77a71efca7870$export$af88d00dbe7f521;
if (0, $6s3t3.IS_DEBUG_BUILD) $3cf77a71efca7870$export$af88d00dbe7f521 = (0, $fgsCa.getGlobalSingleton)('logger', $3cf77a71efca7870$var$makeLogger);
else $3cf77a71efca7870$export$af88d00dbe7f521 = $3cf77a71efca7870$var$makeLogger();

});

parcelRegister("i5Cj4", function(module, exports) {
$parcel$export(module.exports, "fill", () => $d2b66884c312ebd3$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $d2b66884c312ebd3$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $d2b66884c312ebd3$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $d2b66884c312ebd3$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $d2b66884c312ebd3$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $d2b66884c312ebd3$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $d2b66884c312ebd3$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $d2b66884c312ebd3$export$d25f2688db1bb433);

var $dnskZ = parcelRequire("dnskZ");

var $l8nBh = parcelRequire("l8nBh");

var $6auXz = parcelRequire("6auXz");

var $3bCue = parcelRequire("3bCue");
function $d2b66884c312ebd3$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $d2b66884c312ebd3$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $d2b66884c312ebd3$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $d2b66884c312ebd3$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $d2b66884c312ebd3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $d2b66884c312ebd3$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $d2b66884c312ebd3$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $d2b66884c312ebd3$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $6auXz.isError)(value)) newObj = (0, $dnskZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $d2b66884c312ebd3$var$getOwnProperties(value));
    else if ((0, $6auXz.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $dnskZ.__assign)({
            type: event_1.type,
            target: $d2b66884c312ebd3$var$serializeEventTarget(event_1.target),
            currentTarget: $d2b66884c312ebd3$var$serializeEventTarget(event_1.currentTarget)
        }, $d2b66884c312ebd3$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $6auXz.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $d2b66884c312ebd3$var$serializeEventTarget(target) {
    try {
        return (0, $6auXz.isElement)(target) ? (0, $l8nBh.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d2b66884c312ebd3$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $d2b66884c312ebd3$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($d2b66884c312ebd3$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $3bCue.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $3bCue.truncate)(serialized, maxLength);
    }
    return '';
}
function $d2b66884c312ebd3$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $6auXz.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $dnskZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $d2b66884c312ebd3$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($d2b66884c312ebd3$export$d25f2688db1bb433);
    return val;
}
function $d2b66884c312ebd3$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6auXz.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("3bCue", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $252040d2c78c0569$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $252040d2c78c0569$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $252040d2c78c0569$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $252040d2c78c0569$export$cdded5b28a5f8c6d);

var $6auXz = parcelRequire("6auXz");
function $252040d2c78c0569$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $252040d2c78c0569$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $252040d2c78c0569$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $252040d2c78c0569$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $6auXz.isString)(value)) return false;
    if ((0, $6auXz.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $252040d2c78c0569$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("9vKss", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $6ecb0be859ff9919$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $6ecb0be859ff9919$export$aad197c7121a6651);

var $dnskZ = parcelRequire("dnskZ");
var $6ecb0be859ff9919$var$STACKTRACE_LIMIT = 50;
function $6ecb0be859ff9919$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $dnskZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $dnskZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $6ecb0be859ff9919$export$c55c24c0eeba0205(frames);
    };
}
function $6ecb0be859ff9919$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $6ecb0be859ff9919$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $6ecb0be859ff9919$var$defaultFunctionName = '<anonymous>';
function $6ecb0be859ff9919$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $6ecb0be859ff9919$var$defaultFunctionName;
        return fn.name || $6ecb0be859ff9919$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $6ecb0be859ff9919$var$defaultFunctionName;
    }
}

});

parcelRegister("fxl6v", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $b4fa4edc4669b38b$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $b4fa4edc4669b38b$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $b4fa4edc4669b38b$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $b4fa4edc4669b38b$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $b4fa4edc4669b38b$export$67fc34576016d6ec);

var $6s3t3 = parcelRequire("6s3t3");

var $fgsCa = parcelRequire("fgsCa");

var $5ewvH = parcelRequire("5ewvH");
function $b4fa4edc4669b38b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $b4fa4edc4669b38b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $b4fa4edc4669b38b$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $b4fa4edc4669b38b$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $fgsCa.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $b4fa4edc4669b38b$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $b4fa4edc4669b38b$export$c82d238e23c40b21() {
    if (!$b4fa4edc4669b38b$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $fgsCa.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($b4fa4edc4669b38b$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $b4fa4edc4669b38b$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $6s3t3.IS_DEBUG_BUILD) && (0, $5ewvH.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $b4fa4edc4669b38b$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $fgsCa.getGlobalObject)();
}
function $b4fa4edc4669b38b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$b4fa4edc4669b38b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $b4fa4edc4669b38b$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $fgsCa.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("crS3v", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $9101eff118b3f264$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $9101eff118b3f264$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $9101eff118b3f264$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $9101eff118b3f264$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $9101eff118b3f264$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $9101eff118b3f264$export$6de4ffac6a2f1098);

var $dnskZ = parcelRequire("dnskZ");

var $fgsCa = parcelRequire("fgsCa");

var $i5Cj4 = parcelRequire("i5Cj4");

var $3bCue = parcelRequire("3bCue");
function $9101eff118b3f264$export$19f53698e68b2496() {
    var global = (0, $fgsCa.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $9101eff118b3f264$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $9101eff118b3f264$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $9101eff118b3f264$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $9101eff118b3f264$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $9101eff118b3f264$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $9101eff118b3f264$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $9101eff118b3f264$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $dnskZ.__assign)((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $9101eff118b3f264$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $9101eff118b3f264$export$d364f2020ab30578(input) {
    var match = input.match($9101eff118b3f264$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $9101eff118b3f264$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $3bCue.snipLine)(line, 0);
    });
    frame.context_line = (0, $3bCue.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $3bCue.snipLine)(line, 0);
    });
}
function $9101eff118b3f264$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $9101eff118b3f264$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $i5Cj4.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("jVAYm", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $e8200528086a724a$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $e8200528086a724a$export$23fbbb20bed71033);

var $dnskZ = parcelRequire("dnskZ");

var $6auXz = parcelRequire("6auXz");

var $kKhJq = parcelRequire("kKhJq");

var $i5Cj4 = parcelRequire("i5Cj4");

var $9vKss = parcelRequire("9vKss");
function $e8200528086a724a$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $e8200528086a724a$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $e8200528086a724a$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $e8200528086a724a$export$a3295358bff77e(object, depth);
    if ($e8200528086a724a$var$jsonSize(normalized) > maxSize) return $e8200528086a724a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e8200528086a724a$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $kKhJq.memoBuilder)();
    var _a = (0, $dnskZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $6auXz.isNaN)(value)) return value;
    var stringified = $e8200528086a724a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $6auXz.isError)(value) || (0, $6auXz.isEvent)(value) ? (0, $i5Cj4.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $e8200528086a724a$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e8200528086a724a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $6auXz.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $9vKss.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $e8200528086a724a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $e8200528086a724a$var$jsonSize(value) {
    return $e8200528086a724a$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("kKhJq", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $f1a5dba4e5b3bf01$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $f1a5dba4e5b3bf01$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("bPDNT", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $89d35554ae8f112b$export$85a4f67f852183e6);

var $h5R9u = parcelRequire("h5R9u");

var $vnWDO = parcelRequire("vnWDO");
function $89d35554ae8f112b$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $vnWDO.rejectedSyncPromise)(new (0, $h5R9u.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $vnWDO.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $vnWDO.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("vnWDO", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $05e5784efe46aef4$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $05e5784efe46aef4$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $05e5784efe46aef4$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6auXz = parcelRequire("6auXz");
function $05e5784efe46aef4$export$1fda8aa4d135f8aa(value) {
    return new $05e5784efe46aef4$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $05e5784efe46aef4$export$78e43115b553f358(reason) {
    return new $05e5784efe46aef4$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $05e5784efe46aef4$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $6auXz.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("i5cOE", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $d2a2a2a08151f8e3$export$e01cef29b4327697);

var $qCnBK = parcelRequire("qCnBK");

var $4n2GX = parcelRequire("4n2GX");
function $d2a2a2a08151f8e3$var$isSupportedSeverity(level) {
    return (0, $4n2GX.SeverityLevels).indexOf(level) !== -1;
}
function $d2a2a2a08151f8e3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $qCnBK.Severity).Warning;
    if ($d2a2a2a08151f8e3$var$isSupportedSeverity(level)) return level;
    return (0, $qCnBK.Severity).Log;
}

});
parcelRegister("qCnBK", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $0500333ef4d0e8e4$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $0500333ef4d0e8e4$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($0500333ef4d0e8e4$export$918a9776c0a3cf27 || ($0500333ef4d0e8e4$export$918a9776c0a3cf27 = {}));
var $0500333ef4d0e8e4$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("4n2GX", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $32eb65f49bdd87a8$export$484b1ea9aec914c);
var $32eb65f49bdd87a8$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("ROgru", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $0a1bf0c6762d6d80$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $0a1bf0c6762d6d80$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("7IZE7", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $fgsCa = parcelRequire("fgsCa");

var $jBMAF = parcelRequire("jBMAF");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $fgsCa.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $jBMAF.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $jBMAF.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $fgsCa.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("3X2Zm", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $2e0933408f22fa02$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $2e0933408f22fa02$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $2e0933408f22fa02$export$32f9b428425aac85);

var $dnskZ = parcelRequire("dnskZ");

var $6auXz = parcelRequire("6auXz");
function $2e0933408f22fa02$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $2e0933408f22fa02$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $dnskZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $dnskZ.__spread)(items, [
            newItem
        ])
    ];
}
function $2e0933408f22fa02$export$d84939284bbafcd4(envelope) {
    var _a = (0, $dnskZ.__read)(envelope, 2), _b = (0, $dnskZ.__read)(_a[1], 1), _c = (0, $dnskZ.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $2e0933408f22fa02$export$32f9b428425aac85(envelope) {
    var _a = (0, $dnskZ.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $dnskZ.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $6auXz.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("cFR3q", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $93a277d076368c45$export$f3b9ed77c03eeb00);

var $3X2Zm = parcelRequire("3X2Zm");

var $7IZE7 = parcelRequire("7IZE7");
function $93a277d076368c45$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $7IZE7.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $3X2Zm.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("leaAG", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $f7431ed82ead1526$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $f7431ed82ead1526$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $f7431ed82ead1526$export$699aff705e0d49d4);

var $dnskZ = parcelRequire("dnskZ");
var $f7431ed82ead1526$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $f7431ed82ead1526$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $f7431ed82ead1526$export$b09ce39faaeb1e7c;
}
function $f7431ed82ead1526$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $f7431ed82ead1526$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $f7431ed82ead1526$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $f7431ed82ead1526$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $dnskZ.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $dnskZ.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $dnskZ.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $f7431ed82ead1526$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("bojCP", function(module, exports) {
$parcel$export(module.exports, "default", () => $206733bbeb7c1198$export$2e2bcd8739ae039);

var $blDT3 = parcelRequire("blDT3");


var $206733bbeb7c1198$export$2e2bcd8739ae039 = (0, $blDT3.matchRoute);

});
parcelRegister("blDT3", function(module, exports) {
$parcel$export(module.exports, "matchRoute", () => $ebb45a97f34a7dd8$export$b4ee0d6794375c82);

var $lD6K8 = parcelRequire("lD6K8");

var $50VlP = parcelRequire("50VlP");

var $bp8l9 = parcelRequire("bp8l9");

var $4aIgt = parcelRequire("4aIgt");
function $ebb45a97f34a7dd8$export$b4ee0d6794375c82(routes, pathname, queryParams = {}, basePath = '') {
    const queryParamObject = typeof queryParams === 'string' ? (0, $bp8l9.parseQuery)(queryParams) : queryParams;
    // fast return if there is no route or only one route
    if (routes.length === 0) return null;
    if (routes.length === 1) return (0, $50VlP.getRouteMatch)(routes[0], pathname, queryParamObject, basePath);
    const tree = (0, $4aIgt.treeifyRoutes)(routes);
    const route = (0, $lD6K8.findRoute)(tree, pathname, queryParamObject, basePath) || tree.fallbackRoute;
    return (0, $50VlP.getRouteMatch)(route, pathname, queryParamObject, basePath);
}

});
parcelRegister("lD6K8", function(module, exports) {
$parcel$export(module.exports, "findRoute", () => $af7c56c94108bbc4$export$4fa936acba669006);

var $gddn1 = parcelRequire("gddn1");

var $4LWJy = parcelRequire("4LWJy");

var $4aIgt = parcelRequire("4aIgt");
/**
 * Helper function to prioritize nodes with capturing groups in their segment patterns.
 * Nodes with capturing groups (e.g., `:id(\\d+)`) are considered more specific than
 * nodes without them (e.g., `:id`), so they are placed at the beginning of the array.
 *
 * @param arr - Array of nodes to modify
 * @param node - Node to add to the array
 *
 * @example
 * // Node with pattern `:id(\\d+)` will be placed before node with pattern `:id`
 * pushOrUnshiftByCaptureGroup(nodes, nodeWithCaptureGroup);
 */ function $af7c56c94108bbc4$var$pushOrUnshiftByCaptureGroup(arr, node) {
    if (node.segmentPattern.includes('(') && node.segmentPattern.includes(')')) // Segment pattern has capturing group, making it more specific
    // Place it at the beginning for higher priority
    arr.unshift(node);
    else // No capturing group, place at the end of the array
    arr.push(node);
}
// Find matching nodes by segment
// sort the nodes by specificity
function $af7c56c94108bbc4$var$matchChildren(node, segments) {
    // how do we define specificity? This is a tricky question.
    // the specificity goes like this:
    // 1. if the segment is an exact match, of course it's the most specific
    // 2. the rest is regex match, within the regex match, we have to consider:
    // 		2.1 the length of segments and if node has descendants. /jira/:id/summary is more specific than /jira/:id if the request URL is /jira/123/summary
    // 3 after checking the length, we have to consider if the segmentPattern has any capturing group. /jira/:id(\d+) is more specific than /jira/:id
    //
    // This is not a comprehensive solution to the specificity problem
    // I will use production urls to verify this heuristic
    const exactMatch = []; // segment is an exact match e.g. /jira matches /jira
    const lengthMatch = []; // check #2.1 from the above comment
    const rest = [];
    const { children: children } = node;
    // treat url segment as empty string if it's undefined
    // possible if we have optional segmentPattern
    const segment = segments[node.level] || '';
    // check if there is next segment
    const hasNextSegment = segments.length > node.level;
    for(const segmentPattern in children)if (Object.prototype.hasOwnProperty.call(children, segmentPattern)) {
        const child = children[segmentPattern];
        if (segment === segmentPattern) // we have exact segment match
        exactMatch.push(child);
        else {
            const regex = (0, $4LWJy.pathToRegexp)(segmentPattern, [], {
                end: true,
                strict: true,
                sensitive: false
            });
            if (regex.test(segment)) {
                const nodeAhasChildren = Object.keys(child.children).length > 0;
                if (hasNextSegment && nodeAhasChildren) // if there is a next segment, we should prioritize nodes with children
                $af7c56c94108bbc4$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else if (!hasNextSegment && !nodeAhasChildren) // if there is no next segment, we should prioritize nodes without children
                $af7c56c94108bbc4$var$pushOrUnshiftByCaptureGroup(lengthMatch, child);
                else $af7c56c94108bbc4$var$pushOrUnshiftByCaptureGroup(rest, child);
            }
        }
    }
    return [
        ...exactMatch,
        ...lengthMatch,
        ...rest
    ];
}
/**
 * Recursively searches for routes in optional segment nodes.
 * This function handles patterns like `/:a?/:b?/:c?` where segments can be omitted.
 * It traverses the tree looking for routes that can match with missing segments.
 *
 * @param node - Current node to examine
 * @param queryParams - Query parameters to match against route constraints
 * @returns Matched route if found, undefined otherwise
 *
 * @example
 * // For pattern `/:projectId?/:viewType?` and URL `/`
 * // This function will check if the `:projectId?` node has a matching route
 */ function $af7c56c94108bbc4$var$recursivelyFindOptionalNodes(node, queryParams = {}) {
    const { segmentPattern: segmentPattern, children: children, routes: routes } = node;
    // Only process nodes with optional segment patterns (ending with '?')
    if (segmentPattern.endsWith('?')) {
        // Try to find a route at this level that matches the query parameters
        const maybeMatchedRoute = $af7c56c94108bbc4$var$matchRoutesByQuery(routes, queryParams);
        if (maybeMatchedRoute) return maybeMatchedRoute;
        // If no route found at this level, recursively check child nodes
        for(const key in children){
            if (Object.prototype.hasOwnProperty.call(children, key)) return $af7c56c94108bbc4$var$recursivelyFindOptionalNodes(children[key], queryParams);
        }
    }
}
/**
 * Matches routes based on query parameters, returning the most specific match.
 * This function filters routes first (for efficiency) then sorts by specificity.
 *
 * Specificity ranking (highest to lowest):
 * 1. Routes with more query parameters (length-based)
 * 2. Routes with exact value matches (e.g., "param=value")
 * 3. Routes ordered by __unsafeOrder (fallback for ties)
 */ function $af7c56c94108bbc4$var$matchRoutesByQuery(routes, queryParamObject) {
    // Early return if no routes to process
    if (routes.length === 0) return null;
    // STEP 1: Filter routes to only include those that match the query parameters
    // This is done first for performance - no point sorting routes that won't match
    const filteredRoutes = routes.filter((route)=>{
        // Routes without query constraints match any query parameters
        if (route.query === undefined) return true;
        // Create a fake match object for the matchQuery function
        // We only need to check if the query matches, not extract actual values
        const fakeMatch = {
            params: {},
            query: {},
            isExact: false,
            path: '',
            url: ''
        };
        // Use the matchQuery function to determine if this route's query constraints
        // are satisfied by the current query parameters
        return !!(0, $gddn1.matchQuery)(route.query, queryParamObject, fakeMatch);
    });
    // Early return if no routes match the query parameters
    if (filteredRoutes.length === 0) return null;
    // STEP 2: Sort the filtered routes by specificity (most specific first)
    const sortedRoutes = filteredRoutes.sort((a, b)=>{
        // 1st sort criterion: number of query parameters
        // Routes with more query parameters are considered more specific
        const aQueryLength = a.query?.length || 0;
        const bQueryLength = b.query?.length || 0;
        // If query lengths differ, prioritize the route with more parameters
        if (bQueryLength !== aQueryLength) return bQueryLength - aQueryLength; // Descending order (more params first)
        // 2nd sort criterion: query parameter specificity type
        // Helper function to classify the specificity of query parameters
        const getQuerySpecificity = (query)=>{
            if (!query) return 0;
            // These are most specific as they require exact parameter values (e.g., "mode=edit", "type=issue")
            if (query.some((q)=>q.includes('='))) return 1; // Medium specificity
            return 0;
        };
        const aSpecificity = getQuerySpecificity(a.query);
        const bSpecificity = getQuerySpecificity(b.query);
        // If specificity levels differ, prioritize higher specificity
        if (aSpecificity !== bSpecificity) return bSpecificity - aSpecificity; // Descending order (higher specificity first)
        // 3rd sort criterion: fallback to __unsafeOrder for deterministic sorting
        const aOrder = a.__unsafeOrder || 0;
        const bOrder = b.__unsafeOrder || 0;
        return aOrder - bOrder; // Ascending order (lower order first)
    });
    // Return the most specific route that matches the query parameters
    // Since the array is sorted by specificity (most specific first),
    // the first element is our best match
    return sortedRoutes[0];
}
function $af7c56c94108bbc4$export$4fa936acba669006(tree, p, queryParams = {}, basePath) {
    // Remove base path to get the relative pathname for matching
    const pathname = p.replace(basePath, '');
    // Split pathname into individual segments for tree traversal
    // Example: '/jira/projects/123' becomes ['', 'jira', 'projects', '123']
    const segments = pathname.split('/');
    // Clean up segments array by removing empty strings from leading/trailing slashes
    if (segments[0] === '') segments.shift(); // Remove leading empty string from initial '/'
    if (segments[segments.length - 1] === '') segments.pop(); // Remove trailing empty string from final '/'
    // Initialize breadth-first search queue with the root node
    // The queue can contain either Node objects (to continue traversal) or
    // InvariantRoute objects (representing potential matches to return)
    const stack = [
        tree.root
    ];
    // Safety mechanism to prevent infinite loops in malformed trees
    let count = 0;
    const maxCount = 2000;
    // Main traversal loop: continue until queue is empty or match found
    while(stack.length > 0 && count < maxCount){
        count += 1;
        // Process next item from queue (FIFO for breadth-first behavior)
        const node = stack.shift();
        // TypeScript safety check (should never be null in practice)
        if (!node) return null;
        // If we encounter a route object instead of a Node, we've found our match
        // This happens when a non-exact route was added to the queue for later evaluation
        if (!(node instanceof (0, $4aIgt.Node))) return node; // Return the matched route
        // Extract node properties for evaluation
        const { children: children, routes: routes, level: level } = node;
        let maybeMatchedRoute = null;
        let shouldMatchChildren = true;
        // SCENARIO 1: Leaf node (no children) - check for terminal route match
        if (Object.keys(children).length === 0) {
            // Structural integrity check - leaf nodes must have routes
            if (!routes.length) throw new Error(`Route tree structural error: Reached a leaf node with no routes. ` + `This indicates the route tree was not built correctly. ` + `Every leaf node should have at least one route associated with it.`);
            // Attempt to match the routes at this leaf node
            maybeMatchedRoute = $af7c56c94108bbc4$var$matchRoutesByQuery(routes, queryParams);
            if (maybeMatchedRoute) {
                // Check if we have unmatched segments remaining
                if (segments.length > level) // We have leftover segments but nowhere to go in the tree
                // Only proceed if the route allows non-exact matching
                {
                    if (maybeMatchedRoute.exact) // Route requires exact matching, so this isn't a valid match
                    maybeMatchedRoute = null;
                }
            }
        } else if (segments.length === level) // We've consumed all URL segments, see if current node has a matching route
        {
            if (routes.length) maybeMatchedRoute = $af7c56c94108bbc4$var$matchRoutesByQuery(routes, queryParams);
        } else if (segments.length < level) {
            // We've run out of segments but the tree goes deeper
            // This can happen with optional patterns like /:a?/:b?/:c?
            shouldMatchChildren = false; // Don't continue normal traversal
            // Look for optional segment patterns that can match with missing segments
            maybeMatchedRoute = $af7c56c94108bbc4$var$recursivelyFindOptionalNodes(node, queryParams);
        } else {
            // We have more segments to match and this node has children to explore
            // Check if current node has a non-exact route that could serve as fallback
            // Non-exact routes can match even when there are additional segments
            const lowSpecifityRoute = $af7c56c94108bbc4$var$matchRoutesByQuery(routes, queryParams);
            if (lowSpecifityRoute && !lowSpecifityRoute.exact) // Add this route to the queue for later consideration
            // It will be returned if no more specific match is found
            stack.unshift(lowSpecifityRoute);
        }
        // If we found a match, return it immediately
        if (maybeMatchedRoute) return maybeMatchedRoute;
        // Continue tree traversal if appropriate
        if (shouldMatchChildren) {
            // Find child nodes that match the current segment, sorted by specificity
            const matchingChildren = $af7c56c94108bbc4$var$matchChildren(node, segments);
            // Add matching children to the front of the queue for priority processing
            // More specific matches will be processed first due to sorting in matchChildren
            stack.unshift(...matchingChildren);
        }
    // Continue to next iteration to process the next item in the queue
    }
    // No match found after exhausting all possibilities
    return null;
}

});
parcelRegister("gddn1", function(module, exports) {
$parcel$export(module.exports, "matchQuery", () => $3a41f701ca06dab7$export$c5d1efe363797780);
function $3a41f701ca06dab7$export$c5d1efe363797780(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}

});

parcelRegister("4LWJy", function(module, exports) {
$parcel$export(module.exports, "pathToRegexp", () => $06f969a281de4bec$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $06f969a281de4bec$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $06f969a281de4bec$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $06f969a281de4bec$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$06f969a281de4bec$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $06f969a281de4bec$export$ef7acd7185315e22(str, options) {
    return $06f969a281de4bec$export$5b9bad9e403cf3d9($06f969a281de4bec$export$98e6a39c04603d36(str, options), options);
}
function $06f969a281de4bec$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $06f969a281de4bec$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $06f969a281de4bec$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $06f969a281de4bec$export$71304158c7e35877(str, keys, options);
    return $06f969a281de4bec$export$968e97c88708237a(re, keys, options);
}
function $06f969a281de4bec$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $06f969a281de4bec$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $06f969a281de4bec$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $06f969a281de4bec$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $06f969a281de4bec$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$06f969a281de4bec$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $06f969a281de4bec$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $06f969a281de4bec$var$stringToRegexp(path, keys, options) {
    return $06f969a281de4bec$export$9a9303716def6456($06f969a281de4bec$export$98e6a39c04603d36(path, options), keys, options);
}
function $06f969a281de4bec$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$06f969a281de4bec$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$06f969a281de4bec$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $06f969a281de4bec$var$escapeString(encode(token));
    else {
        const prefix = $06f969a281de4bec$var$escapeString(encode(token.prefix));
        const suffix = $06f969a281de4bec$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $06f969a281de4bec$var$flags(options));
}
function $06f969a281de4bec$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $06f969a281de4bec$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $06f969a281de4bec$var$arrayToRegexp(path, keys, options);
    return $06f969a281de4bec$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("4aIgt", function(module, exports) {
$parcel$export(module.exports, "Node", () => $d57d43df693e55c1$export$85c928794f8d04d4);
$parcel$export(module.exports, "treeifyRoutes", () => $d57d43df693e55c1$export$6e055daf7492da67);
/* eslint-disable max-classes-per-file */ class $d57d43df693e55c1$export$85c928794f8d04d4 {
    constructor(level, segmentPattern){
        this.children = {};
        this.routes = [];
        this.level = level;
        this.segmentPattern = segmentPattern;
    }
}
class $d57d43df693e55c1$export$7fbedc92909ed28e {
    constructor(){
        // fallback route is the routes that match everything.
        // this is normally useful for 404 pages
        // we specifically handle this route for performance reason
        // because if we put it into the tree, it will always get traversed and has the least specificity.
        this.fallbackRoute = null;
        this.root = new $d57d43df693e55c1$export$85c928794f8d04d4(0, '');
    }
    insert(segmentPatterns, route) {
        let current = this.root;
        for(let i = 0; i < segmentPatterns.length; i++){
            const segmentPattern = segmentPatterns[i];
            if (!current.children[segmentPattern]) current.children[segmentPattern] = new $d57d43df693e55c1$export$85c928794f8d04d4(i + 1, segmentPattern);
            current = current.children[segmentPattern];
        }
        current.routes.push(route);
    }
}
const $d57d43df693e55c1$var$trim = (segmentPatterns)=>{
    // remove the first empty string
    if (segmentPatterns[0] === '') segmentPatterns.shift();
    // remove the last empty string
    if (segmentPatterns[segmentPatterns.length - 1] === '') segmentPatterns.pop();
};
const $d57d43df693e55c1$var$getSegmentPatterns = (path)=>{
    const segmentPatterns = path.split('/');
    $d57d43df693e55c1$var$trim(segmentPatterns);
    return segmentPatterns;
};
const $d57d43df693e55c1$var$handleFallbackRoute = (route, tree)=>{
    if (typeof route.path !== 'string' || route.path === '' || route.path === '/*' || route.path === '*') {
        if (tree.fallbackRoute) throw new Error('There should be only one route that mates everything.');
        tree.fallbackRoute = route;
        return true;
    }
    return false;
};
function $d57d43df693e55c1$export$6e055daf7492da67(routes) {
    const tree = new $d57d43df693e55c1$export$7fbedc92909ed28e();
    routes.forEach((route)=>{
        if ($d57d43df693e55c1$var$handleFallbackRoute(route, tree)) return;
        // Don't be intimidated by the regex, it's not that complicated.
        // The regex will match ":projectType(software|software/c|servicedesk|core)" or "(/secure/|/)".
        // It handles the case where we need to split the path into multiple segments.
        const match = /(:[a-zA-Z]*)?\(([^()]*\/+[^()]*)\)/.exec(route.path);
        if (match) {
            // Given the route.path is "/jira/:projectType(software|software/c)/foo"
            // `match` looks like [":projectType(software|software/c|servicedesk|core)", ":projectType", "software|software/c|servicedesk|core"]
            const segment = match[0];
            const captureGroup = match[2];
            // We create several branches, e.g.
            // /jira/:projectType(software|software/c)/foo
            // becomes
            // - /jira/software/foo
            // - /jira/software/c/foo
            // although they appear in different position in the tree, they should share the same route
            captureGroup.split('|').forEach((projectType)=>{
                const path = route.path.replace(segment, projectType);
                tree.insert($d57d43df693e55c1$var$getSegmentPatterns(path), route);
            });
        } else tree.insert($d57d43df693e55c1$var$getSegmentPatterns(route.path), route);
    });
    return tree;
}

});


parcelRegister("50VlP", function(module, exports) {
$parcel$export(module.exports, "getRouteMatch", () => $e41dc42192134a59$export$b4cb787dccedb024);

var $lsC8D = parcelRequire("lsC8D");

var $gddn1 = parcelRequire("gddn1");
/* This should match what react-router does to compute a root match. */ const $e41dc42192134a59$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $e41dc42192134a59$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $lsC8D.matchPath)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $e41dc42192134a59$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $gddn1.matchQuery)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
function $e41dc42192134a59$export$b4cb787dccedb024(route, pathname, queryParamObject, basePath) {
    if (route) {
        const matchedRoute = $e41dc42192134a59$var$execRouteMatching(route, pathname, queryParamObject, basePath);
        if (matchedRoute) return matchedRoute;
    }
    return null;
}

});
parcelRegister("lsC8D", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => $468e92a0fc19f8e8$export$81336c211d5ff295);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $4LWJy = parcelRequire("4LWJy");
const $468e92a0fc19f8e8$var$cache = {};
const $468e92a0fc19f8e8$var$cacheLimit = 10000;
let $468e92a0fc19f8e8$var$cacheCount = 0;
function $468e92a0fc19f8e8$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $468e92a0fc19f8e8$var$cache[cacheKey] || ($468e92a0fc19f8e8$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $4LWJy.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($468e92a0fc19f8e8$var$cacheCount < $468e92a0fc19f8e8$var$cacheLimit) {
        pathCache[path] = result;
        $468e92a0fc19f8e8$var$cacheCount++;
    }
    return result;
}
function $468e92a0fc19f8e8$export$81336c211d5ff295(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $468e92a0fc19f8e8$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}

});


parcelRegister("bp8l9", function(module, exports) {
$parcel$export(module.exports, "parseQuery", () => $ae3ca65ee0c03083$export$1e8473eaf75b0d10);
// Source: https://github.com/unshiftio/querystringify/blob/2.2.0/index.js
// Purpose: Eliminate dependencies from `@atlassian/match-route` for micro-optimization
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $ae3ca65ee0c03083$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
function $ae3ca65ee0c03083$export$1e8473eaf75b0d10(query) {
    const parser = /([^=?#&]+)=?([^&]*)/g;
    const result = {};
    let part;
    while(part = parser.exec(query)){
        var key = $ae3ca65ee0c03083$var$decode(part[1]), value = $ae3ca65ee0c03083$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}

});



parcelRegister("d9H9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f6eeb373fd43ef5$export$2e2bcd8739ae039);

var $dVcSp = parcelRequire("dVcSp");

var $iRLyr = parcelRequire("iRLyr");
const $1f6eeb373fd43ef5$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $1f6eeb373fd43ef5$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions){
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', this._onBeforeUnload);
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $iRLyr.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        };
        this.setEventData = (eventData)=>{
            this._eventData = eventData;
        };
        this.getEventData = ()=>this._eventData;
        this.setSearchSessionId = (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        };
        this.getSearchSessionId = ()=>this._searchSessionId;
        this.destroy = ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== 'undefined') window.removeEventListener('beforeunload', this._onBeforeUnload);
        };
        this._onBeforeUnload = ()=>{
            this.stop();
            this.destroy();
        };
        this._sendDwellEvent = (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $iRLyr.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$1f6eeb373fd43ef5$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this.browserInteractionTime = new (0, $dVcSp.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});

parcelRegister("cB4zY", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $45f0623d3dd53a05$export$7bf6cf03fd32cddb);

var $eJOHy = parcelRequire("eJOHy");

var $9LdGp = parcelRequire("9LdGp");
const $45f0623d3dd53a05$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $9LdGp.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LdGp.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("1F3FN", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $e71f64f4f06d458f$export$33c5f161e1d4706);

var $bgBRg = parcelRequire("bgBRg");

var $iKsw2 = parcelRequire("iKsw2");

var $ljiBz = parcelRequire("ljiBz");
var $anTtz = parcelRequire("anTtz");

var $1Vjc9 = parcelRequire("1Vjc9");

var $6cijW = parcelRequire("6cijW");
const $e71f64f4f06d458f$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $iKsw2.setConfig)(config);
        (0, $ljiBz.LISTENERS).length = 0;
        (0, $anTtz.setCurrent)(0);
        if (!(0, $1Vjc9.isNodeEnvironment)()) {
            (0, $bgBRg.collect)();
            if (config.markedForPreload) (0, $6cijW.preloadMarkedIds)(config.markedForPreload);
        }
    }
};

});
parcelRegister("bgBRg", function(module, exports) {
$parcel$export(module.exports, "collect", () => $70c5a2b3c93f40a6$export$bb44f104e3c54dae);

var $iKsw2 = parcelRequire("iKsw2");
var $fwTjO = parcelRequire("fwTjO");

var $d0A2n = parcelRequire("d0A2n");

var $fWLnP = parcelRequire("fWLnP");

var $lkNR5 = parcelRequire("lkNR5");
const $70c5a2b3c93f40a6$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $iKsw2.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $fwTjO.MODE).RENDER ? (0, $fWLnP.cloneElements)(markers[i], lazyBegin) : (0, $lkNR5.refElements)(markers[i], lazyBegin);
        if ((0, $d0A2n.COLLECTED).has(lazyBegin)) (0, $d0A2n.COLLECTED).get(lazyBegin).push(value);
        else (0, $d0A2n.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("fWLnP", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $2fbb6afb2585f399$export$c42217d53a7ebafb);
const $2fbb6afb2585f399$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("lkNR5", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $9aae9422396b03a6$export$c69443129766a7fc);
const $9aae9422396b03a6$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});



parcelRegister("fKnDQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e94917eaa49f6f5f$export$2e2bcd8739ae039);
// @ts-ignore no types for this package :(

var $bN0d5 = parcelRequire("bN0d5");

var $iRLyr = parcelRequire("iRLyr");
const $e94917eaa49f6f5f$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $e94917eaa49f6f5f$export$2e2bcd8739ae039 {
    /**
	 * Callback for sending a 'track' analytics event. This callback should either be the
	 * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
	 * The data for the dwell event will be passed to this method for sending.
	 *
	 * @callback trackCallback
	 * @param {Object} eventData - the base event data that will be added to the track event.
	 */ /**
	 * Creates and initialises the DwellTimeHelper.
	 *
	 * @param {trackCallback} trackCallback - the track callback responsible for actually sending
	 * the event.
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * Additional dwell time attributes will be appended to this data. Note that you don't need to
	 * include the 'action' property, as this will be added automatically.
	 * @param {?string} searchSessionId - a unique identifier for the related search session.
	 * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
	 * timing used for measuring dwell time. The following values are possible:
	 * - initialPollInterval: how long to wait before the first dwell milestone event
	 * is fired (in seconds). Default = 5.
	 * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
	 * event. Default = 2.
	 * - idleTimeout: how long to wait for no user activity before pausing
	 * the dwell timer (in seconds). Default = 30s.
	 * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
	 * of the helper.
	 * - iframeDwell = enable detection of activity in iframes.
	 */ constructor(trackCallback, eventData, searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        /**
	 * Starts the dwell timer. This method should be called upon the initial page load.
	 */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
	 * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
	 * finalise a dwell measurement without starting a new one. When switching to a new page in a
	 * single-page app, use newPage instead.
	 */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
	 * Send the final dwell event and reinitialise the dwell timer for a new page.
	 * This method should be called whenever a new page is switched to in a single-page app context.
	 *
	 * @param {Object} eventData - the base data that will be added to the track event.
	 * @param {?string} searchSessionId - the new search session ID.
	 */ this.newPage = (eventData, searchSessionId)=>{
            (0, $iRLyr.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
	 * This is a modified version of timeit's original listForIdleEvents function,
	 * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
	 * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
	 */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
            });
            /**
		 * Find all same origin iframes (same origin allow access to contentWindow.document)
		 * and add event listeners to them too.
		 */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($bN0d5))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $iRLyr.validateDwellBaseEvent)(eventData);
        this._trackCallback = trackCallback;
        this._eventData = eventData;
        this._searchSessionId = searchSessionId;
        this._timing = {
            ...$e94917eaa49f6f5f$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}

});

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

var $5d8ec86348a5c657$exports = {};
$parcel$export($5d8ec86348a5c657$exports, "R50", () => $5d8ec86348a5c657$export$4b84fd0e2c617bd);
$parcel$export($5d8ec86348a5c657$exports, "R75", () => $5d8ec86348a5c657$export$b34b069eff244586);
$parcel$export($5d8ec86348a5c657$exports, "R100", () => $5d8ec86348a5c657$export$be802dd0d8b57f35);
$parcel$export($5d8ec86348a5c657$exports, "R200", () => $5d8ec86348a5c657$export$60847d42f9da92a6);
$parcel$export($5d8ec86348a5c657$exports, "R300", () => $5d8ec86348a5c657$export$4a7404f376229999);
$parcel$export($5d8ec86348a5c657$exports, "R400", () => $5d8ec86348a5c657$export$2010d0fb4295b346);
$parcel$export($5d8ec86348a5c657$exports, "R500", () => $5d8ec86348a5c657$export$2837b5a1a71d5c02);
$parcel$export($5d8ec86348a5c657$exports, "Y50", () => $5d8ec86348a5c657$export$8d9596b529bbb9cf);
$parcel$export($5d8ec86348a5c657$exports, "Y75", () => $5d8ec86348a5c657$export$41060a744ab0b7ae);
$parcel$export($5d8ec86348a5c657$exports, "Y100", () => $5d8ec86348a5c657$export$1cc05bbbf340e559);
$parcel$export($5d8ec86348a5c657$exports, "Y200", () => $5d8ec86348a5c657$export$5aae31392d72caaa);
$parcel$export($5d8ec86348a5c657$exports, "Y300", () => $5d8ec86348a5c657$export$c6930421db9fa514);
$parcel$export($5d8ec86348a5c657$exports, "Y400", () => $5d8ec86348a5c657$export$59619663aa6500fb);
$parcel$export($5d8ec86348a5c657$exports, "Y500", () => $5d8ec86348a5c657$export$874739ea9e379ab6);
$parcel$export($5d8ec86348a5c657$exports, "G50", () => $5d8ec86348a5c657$export$8a6341c32b6a3ee6);
$parcel$export($5d8ec86348a5c657$exports, "G75", () => $5d8ec86348a5c657$export$69a3bf21b9686c2b);
$parcel$export($5d8ec86348a5c657$exports, "G100", () => $5d8ec86348a5c657$export$afbce1382ec95f73);
$parcel$export($5d8ec86348a5c657$exports, "G200", () => $5d8ec86348a5c657$export$747d86715d4175de);
$parcel$export($5d8ec86348a5c657$exports, "G300", () => $5d8ec86348a5c657$export$940e1f69e873f202);
$parcel$export($5d8ec86348a5c657$exports, "G400", () => $5d8ec86348a5c657$export$a49394138f7b8e85);
$parcel$export($5d8ec86348a5c657$exports, "G500", () => $5d8ec86348a5c657$export$6fa04827ac68a4fb);
$parcel$export($5d8ec86348a5c657$exports, "B50", () => $5d8ec86348a5c657$export$226de0355ed012f8);
$parcel$export($5d8ec86348a5c657$exports, "B75", () => $5d8ec86348a5c657$export$8c13c2ee36917869);
$parcel$export($5d8ec86348a5c657$exports, "B100", () => $5d8ec86348a5c657$export$ecfc1dff386a3e7a);
$parcel$export($5d8ec86348a5c657$exports, "B200", () => $5d8ec86348a5c657$export$215b7063051591f1);
$parcel$export($5d8ec86348a5c657$exports, "B300", () => $5d8ec86348a5c657$export$e62e8919cca44969);
$parcel$export($5d8ec86348a5c657$exports, "B400", () => $5d8ec86348a5c657$export$b3de0ae08da2ce64);
$parcel$export($5d8ec86348a5c657$exports, "B500", () => $5d8ec86348a5c657$export$a6ee3d71bc067634);
$parcel$export($5d8ec86348a5c657$exports, "B600", () => $5d8ec86348a5c657$export$67f15409e87642a1);
$parcel$export($5d8ec86348a5c657$exports, "B700", () => $5d8ec86348a5c657$export$f0539dbc42dbb067);
$parcel$export($5d8ec86348a5c657$exports, "P50", () => $5d8ec86348a5c657$export$363e4475840015bb);
$parcel$export($5d8ec86348a5c657$exports, "P75", () => $5d8ec86348a5c657$export$4b0a4417ed59760f);
$parcel$export($5d8ec86348a5c657$exports, "P100", () => $5d8ec86348a5c657$export$6011520a64d9a187);
$parcel$export($5d8ec86348a5c657$exports, "P200", () => $5d8ec86348a5c657$export$a7175d4e9206bc80);
$parcel$export($5d8ec86348a5c657$exports, "P300", () => $5d8ec86348a5c657$export$b48405b95304b5a1);
$parcel$export($5d8ec86348a5c657$exports, "P400", () => $5d8ec86348a5c657$export$c71e4279dd54a18d);
$parcel$export($5d8ec86348a5c657$exports, "P500", () => $5d8ec86348a5c657$export$147899de772240ec);
$parcel$export($5d8ec86348a5c657$exports, "T50", () => $5d8ec86348a5c657$export$2cf711fe14c66f06);
$parcel$export($5d8ec86348a5c657$exports, "T75", () => $5d8ec86348a5c657$export$7a8f4d33f6f9772c);
$parcel$export($5d8ec86348a5c657$exports, "T100", () => $5d8ec86348a5c657$export$776c9c497ef08533);
$parcel$export($5d8ec86348a5c657$exports, "T200", () => $5d8ec86348a5c657$export$69cb3ca10c1e330e);
$parcel$export($5d8ec86348a5c657$exports, "T300", () => $5d8ec86348a5c657$export$9dc1ef0f3f48059b);
$parcel$export($5d8ec86348a5c657$exports, "T400", () => $5d8ec86348a5c657$export$7c835c78b6fcdef8);
$parcel$export($5d8ec86348a5c657$exports, "T500", () => $5d8ec86348a5c657$export$6036577f95c3877e);
$parcel$export($5d8ec86348a5c657$exports, "N0", () => $5d8ec86348a5c657$export$29a4f05edc054374);
$parcel$export($5d8ec86348a5c657$exports, "N10", () => $5d8ec86348a5c657$export$e655ef011c4aa1a2);
$parcel$export($5d8ec86348a5c657$exports, "N20", () => $5d8ec86348a5c657$export$9fdfb749e33cdf97);
$parcel$export($5d8ec86348a5c657$exports, "N30", () => $5d8ec86348a5c657$export$3e51e8f1440314ba);
$parcel$export($5d8ec86348a5c657$exports, "N40", () => $5d8ec86348a5c657$export$1ce2d1575d444ceb);
$parcel$export($5d8ec86348a5c657$exports, "N50", () => $5d8ec86348a5c657$export$8754fc7e6d8b3000);
$parcel$export($5d8ec86348a5c657$exports, "N60", () => $5d8ec86348a5c657$export$c2e91cbeada39b8b);
$parcel$export($5d8ec86348a5c657$exports, "N70", () => $5d8ec86348a5c657$export$5f71e19f3a7ad9de);
$parcel$export($5d8ec86348a5c657$exports, "N80", () => $5d8ec86348a5c657$export$eaa8c8a70ac22806);
$parcel$export($5d8ec86348a5c657$exports, "N90", () => $5d8ec86348a5c657$export$7c87d337fb91a97d);
$parcel$export($5d8ec86348a5c657$exports, "N100", () => $5d8ec86348a5c657$export$d6447c357493214f);
$parcel$export($5d8ec86348a5c657$exports, "N200", () => $5d8ec86348a5c657$export$f563ee71e9ee74cd);
$parcel$export($5d8ec86348a5c657$exports, "N300", () => $5d8ec86348a5c657$export$e2ef2124cf4024b1);
$parcel$export($5d8ec86348a5c657$exports, "N400", () => $5d8ec86348a5c657$export$eece5f492e429f08);
$parcel$export($5d8ec86348a5c657$exports, "N500", () => $5d8ec86348a5c657$export$c39c0fe0f26207ae);
$parcel$export($5d8ec86348a5c657$exports, "N600", () => $5d8ec86348a5c657$export$7090862dc3038a9f);
$parcel$export($5d8ec86348a5c657$exports, "N700", () => $5d8ec86348a5c657$export$ad0bacf983b7ddaa);
$parcel$export($5d8ec86348a5c657$exports, "N800", () => $5d8ec86348a5c657$export$7d61b15e0da132af);
$parcel$export($5d8ec86348a5c657$exports, "N900", () => $5d8ec86348a5c657$export$fbda843f0a27fe96);
$parcel$export($5d8ec86348a5c657$exports, "N10A", () => $5d8ec86348a5c657$export$791e57b27ca738ef);
$parcel$export($5d8ec86348a5c657$exports, "N20A", () => $5d8ec86348a5c657$export$8d43898f60b96a82);
$parcel$export($5d8ec86348a5c657$exports, "N30A", () => $5d8ec86348a5c657$export$920c0d5c49070351);
$parcel$export($5d8ec86348a5c657$exports, "N40A", () => $5d8ec86348a5c657$export$46987b49aab6d1a8);
$parcel$export($5d8ec86348a5c657$exports, "N50A", () => $5d8ec86348a5c657$export$7d3359664e8bb0e5);
$parcel$export($5d8ec86348a5c657$exports, "N60A", () => $5d8ec86348a5c657$export$d2d3bedfb276cac0);
$parcel$export($5d8ec86348a5c657$exports, "N70A", () => $5d8ec86348a5c657$export$6e5e7499ff054f6d);
$parcel$export($5d8ec86348a5c657$exports, "N80A", () => $5d8ec86348a5c657$export$59264b346c877fa7);
$parcel$export($5d8ec86348a5c657$exports, "N90A", () => $5d8ec86348a5c657$export$d092757d7c64925c);
$parcel$export($5d8ec86348a5c657$exports, "N100A", () => $5d8ec86348a5c657$export$486ab785e4bac3c6);
$parcel$export($5d8ec86348a5c657$exports, "N200A", () => $5d8ec86348a5c657$export$fba592bbc6419fea);
$parcel$export($5d8ec86348a5c657$exports, "N300A", () => $5d8ec86348a5c657$export$13609db0e6812ab8);
$parcel$export($5d8ec86348a5c657$exports, "N400A", () => $5d8ec86348a5c657$export$fbae4efaa892d883);
$parcel$export($5d8ec86348a5c657$exports, "N500A", () => $5d8ec86348a5c657$export$f13946d26f440ce6);
$parcel$export($5d8ec86348a5c657$exports, "N600A", () => $5d8ec86348a5c657$export$19f58225ac52a306);
$parcel$export($5d8ec86348a5c657$exports, "N700A", () => $5d8ec86348a5c657$export$6384f09da70e7b62);
$parcel$export($5d8ec86348a5c657$exports, "N800A", () => $5d8ec86348a5c657$export$d0dccc730683edc2);
$parcel$export($5d8ec86348a5c657$exports, "DN900", () => $5d8ec86348a5c657$export$2f6319cf7d736c2a);
$parcel$export($5d8ec86348a5c657$exports, "DN800", () => $5d8ec86348a5c657$export$95126bc8884d6634);
$parcel$export($5d8ec86348a5c657$exports, "DN700", () => $5d8ec86348a5c657$export$8338d8c35d44ff1);
$parcel$export($5d8ec86348a5c657$exports, "DN600", () => $5d8ec86348a5c657$export$5368d76ae4fbbda7);
$parcel$export($5d8ec86348a5c657$exports, "DN500", () => $5d8ec86348a5c657$export$9f0a771d16ec8d36);
$parcel$export($5d8ec86348a5c657$exports, "DN400", () => $5d8ec86348a5c657$export$abcf8c38338b4aa5);
$parcel$export($5d8ec86348a5c657$exports, "DN300", () => $5d8ec86348a5c657$export$97e81faa16a182c7);
$parcel$export($5d8ec86348a5c657$exports, "DN200", () => $5d8ec86348a5c657$export$bfe21c59123ecf33);
$parcel$export($5d8ec86348a5c657$exports, "DN100", () => $5d8ec86348a5c657$export$ee82aa2ea6a1558);
$parcel$export($5d8ec86348a5c657$exports, "DN90", () => $5d8ec86348a5c657$export$682927c6ed76be02);
$parcel$export($5d8ec86348a5c657$exports, "DN80", () => $5d8ec86348a5c657$export$91fd9994c5be9757);
$parcel$export($5d8ec86348a5c657$exports, "DN70", () => $5d8ec86348a5c657$export$d281fbfe3cff2df6);
$parcel$export($5d8ec86348a5c657$exports, "DN60", () => $5d8ec86348a5c657$export$3902c91d8b98a753);
$parcel$export($5d8ec86348a5c657$exports, "DN50", () => $5d8ec86348a5c657$export$8e8133c1ba5845b5);
$parcel$export($5d8ec86348a5c657$exports, "DN40", () => $5d8ec86348a5c657$export$33ff357f6620b39);
$parcel$export($5d8ec86348a5c657$exports, "DN30", () => $5d8ec86348a5c657$export$633847cf062b69e0);
$parcel$export($5d8ec86348a5c657$exports, "DN20", () => $5d8ec86348a5c657$export$9776a6e503bdbf76);
$parcel$export($5d8ec86348a5c657$exports, "DN10", () => $5d8ec86348a5c657$export$6c813d5160dff5db);
$parcel$export($5d8ec86348a5c657$exports, "DN0", () => $5d8ec86348a5c657$export$3d4f271a500072a);
$parcel$export($5d8ec86348a5c657$exports, "DN800A", () => $5d8ec86348a5c657$export$fe151285c22759ec);
$parcel$export($5d8ec86348a5c657$exports, "DN700A", () => $5d8ec86348a5c657$export$a101c6190d0da34);
$parcel$export($5d8ec86348a5c657$exports, "DN600A", () => $5d8ec86348a5c657$export$4b16f52932fda51);
$parcel$export($5d8ec86348a5c657$exports, "DN500A", () => $5d8ec86348a5c657$export$a74bcd7b9845b0d8);
$parcel$export($5d8ec86348a5c657$exports, "DN400A", () => $5d8ec86348a5c657$export$9209c179316d1751);
$parcel$export($5d8ec86348a5c657$exports, "DN300A", () => $5d8ec86348a5c657$export$88f55133f636c8dd);
$parcel$export($5d8ec86348a5c657$exports, "DN200A", () => $5d8ec86348a5c657$export$51126f85d1009512);
$parcel$export($5d8ec86348a5c657$exports, "DN100A", () => $5d8ec86348a5c657$export$a069b547bd23af78);
$parcel$export($5d8ec86348a5c657$exports, "DN90A", () => $5d8ec86348a5c657$export$40cce05af3b2600a);
$parcel$export($5d8ec86348a5c657$exports, "DN80A", () => $5d8ec86348a5c657$export$b78942185925a0d);
$parcel$export($5d8ec86348a5c657$exports, "DN70A", () => $5d8ec86348a5c657$export$e058fb44b8eaafca);
$parcel$export($5d8ec86348a5c657$exports, "DN60A", () => $5d8ec86348a5c657$export$92b0b8de26920c18);
$parcel$export($5d8ec86348a5c657$exports, "DN50A", () => $5d8ec86348a5c657$export$67564f7459d3fc9e);
$parcel$export($5d8ec86348a5c657$exports, "DN40A", () => $5d8ec86348a5c657$export$77868e1ca884ffa3);
$parcel$export($5d8ec86348a5c657$exports, "DN30A", () => $5d8ec86348a5c657$export$2afd71d7d3ea2cd5);
$parcel$export($5d8ec86348a5c657$exports, "DN20A", () => $5d8ec86348a5c657$export$f2a0acaab9972c70);
$parcel$export($5d8ec86348a5c657$exports, "DN10A", () => $5d8ec86348a5c657$export$9ab70e67d6475361);
$parcel$export($5d8ec86348a5c657$exports, "T30", () => $5d8ec86348a5c657$export$d2adc5dedf09fced);
$parcel$export($5d8ec86348a5c657$exports, "L50", () => $5d8ec86348a5c657$export$f51762073d2bb381);
$parcel$export($5d8ec86348a5c657$exports, "L75", () => $5d8ec86348a5c657$export$95e26d54def96891);
// Reds
const $5d8ec86348a5c657$export$4b84fd0e2c617bd = '#FFEBE6';
const $5d8ec86348a5c657$export$b34b069eff244586 = '#FFBDAD';
const $5d8ec86348a5c657$export$be802dd0d8b57f35 = '#FF8F73';
const $5d8ec86348a5c657$export$60847d42f9da92a6 = '#FF7452';
const $5d8ec86348a5c657$export$4a7404f376229999 = '#FF5630';
const $5d8ec86348a5c657$export$2010d0fb4295b346 = '#DE350B';
const $5d8ec86348a5c657$export$2837b5a1a71d5c02 = '#BF2600';
const $5d8ec86348a5c657$export$8d9596b529bbb9cf = '#FFFAE6';
const $5d8ec86348a5c657$export$41060a744ab0b7ae = '#FFF0B3';
const $5d8ec86348a5c657$export$1cc05bbbf340e559 = '#FFE380';
const $5d8ec86348a5c657$export$5aae31392d72caaa = '#FFC400';
const $5d8ec86348a5c657$export$c6930421db9fa514 = '#FFAB00';
const $5d8ec86348a5c657$export$59619663aa6500fb = '#FF991F';
const $5d8ec86348a5c657$export$874739ea9e379ab6 = '#FF8B00';
const $5d8ec86348a5c657$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5d8ec86348a5c657$export$69a3bf21b9686c2b = '#ABF5D1';
const $5d8ec86348a5c657$export$afbce1382ec95f73 = '#79F2C0';
const $5d8ec86348a5c657$export$747d86715d4175de = '#57D9A3';
const $5d8ec86348a5c657$export$940e1f69e873f202 = '#36B37E';
const $5d8ec86348a5c657$export$a49394138f7b8e85 = '#00875A';
const $5d8ec86348a5c657$export$6fa04827ac68a4fb = '#006644';
const $5d8ec86348a5c657$export$226de0355ed012f8 = '#DEEBFF';
const $5d8ec86348a5c657$export$8c13c2ee36917869 = '#B3D4FF';
const $5d8ec86348a5c657$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5d8ec86348a5c657$export$215b7063051591f1 = '#2684FF';
const $5d8ec86348a5c657$export$e62e8919cca44969 = '#0065FF';
const $5d8ec86348a5c657$export$b3de0ae08da2ce64 = '#0052CC';
const $5d8ec86348a5c657$export$a6ee3d71bc067634 = '#0747A6';
const $5d8ec86348a5c657$export$67f15409e87642a1 = '#669DF1';
const $5d8ec86348a5c657$export$f0539dbc42dbb067 = '#8FB8F6';
const $5d8ec86348a5c657$export$363e4475840015bb = '#EAE6FF';
const $5d8ec86348a5c657$export$4b0a4417ed59760f = '#C0B6F2';
const $5d8ec86348a5c657$export$6011520a64d9a187 = '#998DD9';
const $5d8ec86348a5c657$export$a7175d4e9206bc80 = '#8777D9';
const $5d8ec86348a5c657$export$b48405b95304b5a1 = '#6554C0';
const $5d8ec86348a5c657$export$c71e4279dd54a18d = '#5243AA';
const $5d8ec86348a5c657$export$147899de772240ec = '#403294';
const $5d8ec86348a5c657$export$2cf711fe14c66f06 = '#E6FCFF';
const $5d8ec86348a5c657$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5d8ec86348a5c657$export$776c9c497ef08533 = '#79E2F2';
const $5d8ec86348a5c657$export$69cb3ca10c1e330e = '#00C7E6';
const $5d8ec86348a5c657$export$9dc1ef0f3f48059b = '#00B8D9';
const $5d8ec86348a5c657$export$7c835c78b6fcdef8 = '#00A3BF';
const $5d8ec86348a5c657$export$6036577f95c3877e = '#008DA6';
const $5d8ec86348a5c657$export$29a4f05edc054374 = '#FFFFFF';
const $5d8ec86348a5c657$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5d8ec86348a5c657$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5d8ec86348a5c657$export$3e51e8f1440314ba = '#EBECF0';
const $5d8ec86348a5c657$export$1ce2d1575d444ceb = '#DFE1E6';
const $5d8ec86348a5c657$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5d8ec86348a5c657$export$c2e91cbeada39b8b = '#B3BAC5';
const $5d8ec86348a5c657$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5d8ec86348a5c657$export$eaa8c8a70ac22806 = '#97A0AF';
const $5d8ec86348a5c657$export$7c87d337fb91a97d = '#8993A4';
const $5d8ec86348a5c657$export$d6447c357493214f = '#7A869A';
const $5d8ec86348a5c657$export$f563ee71e9ee74cd = '#6B778C';
const $5d8ec86348a5c657$export$e2ef2124cf4024b1 = '#5E6C84';
const $5d8ec86348a5c657$export$eece5f492e429f08 = '#505F79';
const $5d8ec86348a5c657$export$c39c0fe0f26207ae = '#42526E';
const $5d8ec86348a5c657$export$7090862dc3038a9f = '#344563';
const $5d8ec86348a5c657$export$ad0bacf983b7ddaa = '#253858';
const $5d8ec86348a5c657$export$7d61b15e0da132af = '#172B4D';
const $5d8ec86348a5c657$export$fbda843f0a27fe96 = '#091E42';
const $5d8ec86348a5c657$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5d8ec86348a5c657$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5d8ec86348a5c657$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5d8ec86348a5c657$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5d8ec86348a5c657$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5d8ec86348a5c657$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5d8ec86348a5c657$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5d8ec86348a5c657$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5d8ec86348a5c657$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5d8ec86348a5c657$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5d8ec86348a5c657$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5d8ec86348a5c657$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5d8ec86348a5c657$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5d8ec86348a5c657$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5d8ec86348a5c657$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5d8ec86348a5c657$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5d8ec86348a5c657$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5d8ec86348a5c657$export$2f6319cf7d736c2a = '#E6EDFA';
const $5d8ec86348a5c657$export$95126bc8884d6634 = '#DCE5F5';
const $5d8ec86348a5c657$export$8338d8c35d44ff1 = '#CED9EB';
const $5d8ec86348a5c657$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5d8ec86348a5c657$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5d8ec86348a5c657$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5d8ec86348a5c657$export$97e81faa16a182c7 = '#8C9CB8';
const $5d8ec86348a5c657$export$bfe21c59123ecf33 = '#7988A3';
const $5d8ec86348a5c657$export$ee82aa2ea6a1558 = '#67758F';
const $5d8ec86348a5c657$export$682927c6ed76be02 = '#56637A';
const $5d8ec86348a5c657$export$91fd9994c5be9757 = '#455166';
const $5d8ec86348a5c657$export$d281fbfe3cff2df6 = '#3B475C';
const $5d8ec86348a5c657$export$3902c91d8b98a753 = '#313D52';
const $5d8ec86348a5c657$export$8e8133c1ba5845b5 = '#283447';
const $5d8ec86348a5c657$export$33ff357f6620b39 = '#202B3D';
const $5d8ec86348a5c657$export$633847cf062b69e0 = '#1B2638';
const $5d8ec86348a5c657$export$9776a6e503bdbf76 = '#121A29';
const $5d8ec86348a5c657$export$6c813d5160dff5db = '#0E1624';
const $5d8ec86348a5c657$export$3d4f271a500072a = '#0D1424';
const $5d8ec86348a5c657$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5d8ec86348a5c657$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5d8ec86348a5c657$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5d8ec86348a5c657$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5d8ec86348a5c657$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5d8ec86348a5c657$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5d8ec86348a5c657$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5d8ec86348a5c657$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5d8ec86348a5c657$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5d8ec86348a5c657$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5d8ec86348a5c657$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5d8ec86348a5c657$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5d8ec86348a5c657$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5d8ec86348a5c657$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5d8ec86348a5c657$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5d8ec86348a5c657$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5d8ec86348a5c657$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5d8ec86348a5c657$export$d2adc5dedf09fced = '#292A2E';
const $5d8ec86348a5c657$export$f51762073d2bb381 = '#94C748';
const $5d8ec86348a5c657$export$95e26d54def96891 = '#B3DF72';

/**
 * Character key codes which can be used in keyboard events.
 */ const $331378e6eb9d51ed$export$390330c10ff2b9a1 = 'ArrowUp';
const $331378e6eb9d51ed$export$a80636c6f41931fe = 'ArrowDown';
const $331378e6eb9d51ed$export$4af703091671bc = 'Home';
const $331378e6eb9d51ed$export$e2bc30913faa5db7 = 'End';
const $331378e6eb9d51ed$export$10f6869ed0a7d75b = 'Tab';
const $331378e6eb9d51ed$export$8152f929a25a0ff4 = 'Enter';
const $331378e6eb9d51ed$export$e51a3576c045c8d5 = 'Space';
const $331378e6eb9d51ed$export$2bb790b9008907b4 = 'Escape';

const $0139489ca8ea5bd0$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0139489ca8ea5bd0$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0139489ca8ea5bd0$export$13f57c02915787b3 = 'atlaskit-portal';

const $90a9eddfce0c3200$export$ed5835cc67e87f72 = 'akPortalMount';
const $90a9eddfce0c3200$export$80816bd900e5bd00 = 'akPortalUnmount';

const $3a6f6559ec260003$export$881d135f98d8d7d0 = 100;
const $3a6f6559ec260003$export$9ab5bdcb8a1d6c34 = false;
const $3a6f6559ec260003$export$f267d0e9ab3eb265 = false;
const $3a6f6559ec260003$export$12c1dc38ea1692da = 0;
const $3a6f6559ec260003$export$c6d9b82b8528dcc3 = false;

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c1d236d1310af702$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $c336a4a8eee57272$export$a1562d08625f5d7e = 'ui';
const $c336a4a8eee57272$export$947dac6c72b26f81 = 'track';
const $c336a4a8eee57272$export$f1d537d508d2945a = 'screen';
const $c336a4a8eee57272$export$12346a674644c156 = 'operational';
const $c336a4a8eee57272$export$b055de0e665cb20c = 'unknown';

const $3c00358b8d5a4fa2$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("if6ia")
//# sourceMappingURL=shared~vendor~atlassian~ar.386e7ea9.js.map
